var AppContextManager = {

    HtmlHelper: {
        getControl: function (elementId, createIfNotExists) {
            let element = $("#" + elementId);
            if (createIfNotExists && element.length === 0) {
                element = $("<input>", {
                    type: "hidden",
                    id: elementId,
                    name: elementId
                }).appendTo("body");
            }
            return element;
        }
    },

    PatientContext: {
        setPatientId: function (pid) {
            if ((typeof pid !== "undefined" || pid) && pid > 0) {
                let element = AppContextManager.HtmlHelper.getControl("Session_PatientID", true);
                $(element).val(pid);
            }
        },
        getPatientId: function () {
            let element = $(AppContextManager.HtmlHelper.getControl("Session_PatientID"));
            return element.length === 0 ? 0 : element.val();
        },
        clear: function () {
            return $(AppContextManager.HtmlHelper.getControl("Session_PatientID")).val('');
        }
    }
};

$(document).ajaxSend(function (_ev, xhr, _settings) {
    var tokens = document.getElementsByName("__RequestVerificationToken");
    if (tokens.length > 0) {
        xhr.setRequestHeader('__RequestVerificationToken', tokens[0].value);
    }
});

function modalDrag(myModal) {
    $(myModal).draggable({
        cursor: "move", handle: "#portletHeadHand", containment: "body"
        , start: function () { }
        , drag: function () { }
        , stop: function () {
            var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
            var SourPosi = $(myModal).position(), SoTop = SourPosi.top;
            if (winHeight > 0 && SoTop + 50 >= winHeight) { $(myModal).css({ top: (winHeight - 50) }); }
            else if (SoTop < 0) { $(myModal).css({ top: 10 }); }
        }
    });
}

function CustomAssignBtnVisibility() {
    if ($('#memeberCareTeamTbl').length > 0 && $('#memeberCareTeamTbl').is(':visible') == true) {
        var drpVal = $('#ddlSearchCareTeamType').val();
        if (drpVal == "-1") {
            $('.crtmAdd').hide();
        }
    }
}
//
function MVCLoadControl(Ctrl, Container, Control, url, OuterLayer, IsPh) {
    var eleid = $('#' + Control).attr("id");
    if (eleid == null)
        MVCDBControlLoad(Container, Control, url, OuterLayer, IsPh);
    else
        MVCDBControlRead(Ctrl, Control, IsPh);
}
/*To Read Control*/
function MVCDBControlRead(Ctrl, Control, IsPh) {
    var grid = $('#' + Control).data('kendoGrid');
    if (Control == "MyMembersGridNew") {
        if (prevmemval == 0 && count != undefined) {
            if (Ctrl == 1)
                MVCDBControlLoad("_myMemberPartialViewContainer", "MyMembersGridNew", baseURL + "/Dashboard/MyMembers/", "blockOne");
            else
                MVCDBControlLoad("memberGrid", 'MyMembersGridNew', baseURL + "/Dashboard/MyMembers/", "panelLeft", IsPh);
        }
        else {
            //grid.dataSource.read();
            if (gridPagerMode && !((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1'))) {
                gridPagination.fetchGridData('MyMembersGridNew');
            } else {
                grid.dataSource.page(1);
            }
        }
        var count = grid.dataSource.total();
        prevmemval = count;
    }
    else if (Control == "OpenAuthorization") {
        if (prevauthval == 0) {
            MVCDBControlLoad("_myMemberPartialViewContainer", "OpenAuthorization", baseURL + "/Authorization/OpenAuthorization/", "blockOne");
        }
        else {
            readDatasourcefromGrid(Control, false);
        }
        var count = grid.dataSource.total();
        prevauthval = count;
    }
    else if (Control == "PendingActivityGrid") {
        if (prevpenval == 0) {
            MVCDBControlLoad("_myMemberPartialViewContainer", "PendingActivityGrid", baseURL + "/Dashboard/PendingActivities/", "blockOne");
        }
        else {
            readDatasourcefromGrid(Control, true);
        }
        var count = grid.dataSource.total();
        prevpenval = count;
    }
    else if (Control == "ReqRecGrid") {
        if (prevreqrecval == 0) {
            if (Ctrl == 1)
                MVCDBControlLoad("_requestReceivedPartialViewContainer", "ReqRecGrid", baseURL + "/RequestReceivedDashboard/RequestReceived/", "thirdViewrow");
            else
                MVCDBControlLoad("memberGrid", 'ReqRecGrid', baseURL + "/RequestReceivedDashboard/RequestReceived/", "thirdViewrow");
        }
        else {
            MVCDBControlLoad("_requestReceivedPartialViewContainer", "ReqRecGrid", baseURL + "/RequestReceivedDashboard/RequestReceived/", "thirdViewrow");
        }
        var count = grid.dataSource.total();
        prevreqrecval = count;
    }
    else if (Control == "ReqRejGrid") {
        if (prevreqrejval == 0) {
            if (Ctrl == 1)
                MVCDBControlLoad("_requestReceivedPartialViewContainer", "ReqRejGrid", baseURL + "/RequestRejectedDashboard/RequestRejected/", "thirdViewrow");
            else
                MVCDBControlLoad("memberGrid", 'ReqRejGrid', baseURL + "/RequestRejectedDashboard/RequestRejected/", "thirdViewrow");
        }
        else {
            MVCDBControlLoad("_requestReceivedPartialViewContainer", "ReqRejGrid", baseURL + "/RequestRejectedDashboard/RequestRejected/", "thirdViewrow");
        }
        var count = grid.dataSource.total();
        prevreqrejval = count;
    }
    else if (Control == "AlertsGridNew") {
        if (prevalertval == 0) {
            if (Ctrl == 1)
                MVCDBControlLoad("_myAlertsPartialViewContainer", "AlertsGridNew", baseURL + "/Alert/MyAlerts/", "rowTwoHt");
            else
                MVCDBControlLoad("memberGrid", 'AlertsGridNew', baseURL + "/Alert/MyAlerts/", "rowTwoHt");
        }
        else {
            readDatasourcefromGrid(Control, true);
        }
        var count = grid.dataSource.total();
        prevalertval = count;
    }
}
function LoadFilterCriteria() {
    var pan = $('#spanMyAlertsHeaderName').html();
    if (pan == "My Alerts") {
        $('#_myAlertsPartialViewContainer').html('').load(baseURL + "/Alert/MyAlerts", function () {
            //$('#AlertsGridNew').css({ "height": "210px" })
            //$('#AlertsGridNew .k-grid-content').css({ "height": "162px" })
            loadGridOnPagerMode('AlertsGridNew');
            setDashboardGrids("AlertsGridNew");
            onLoadMyAlerts();
        });
    }
    else if (pan == "Risk Profile")
        $('#_myAlertsPartialViewContainer').html('').load(baseURL + "/Risk/ShowRiskProfile", function () {
            //onLoadRiskProfile();
            setDashboardGrids("RiskProfilechartNew");
        });
    else if (pan == "Disease Profile")
        $('#_myAlertsPartialViewContainer').html('').load(baseURL + "/Dashboard/ShowDiseaseProfile", function () {
            setDashboardGrids("DiseasechartNew");
            //onLoadDiseaseProfile();
        });
    else if (pan == "Quality Indicators")
        $('#_myAlertsPartialViewContainer').html('').load(baseURL + "/Dashboard/MyQualityIndicators", function () {
            setDashboardGrids("QualityIndicatorNew");
            //onLoadQualityIndicators();
        });
}
function getDateWithoutSecondFormat() {
    return IS_12HRS_FORMAT ? "MM/dd/yyyy hh:mm tt" : "MM/dd/yyyy HH:mm";
}
function getTimeWithOutSecondFormat() {
    return IS_12HRS_FORMAT ? "hh:mm tt" : "HH:mm";
}
function getDateFormat() {
    return IS_12HRS_FORMAT ? "MM/dd/yyyy hh:mm:ss tt" : "MM/dd/yyyy HH:mm:ss";
}
function getTimeFormat() {
    return IS_12HRS_FORMAT ? "hh:mm:ss tt" : "HH:mm:ss";
}
function valUpdAppForm() {
    var msgCount = 0;
    $('#divAppointmentUpdatePopup .ValMsg').remove();
    if ($('#selectAppointmentStatus').val() < 0) {
        $('#selectAppointmentStatus').closest('td').append('<span class="ValMsg" style="color:red">*</span>');
        msgCount = 1;
    }
    if ($('#AppointmentNotes').is(":visible") && $('#AppointmentNotes').val() == '') {
        $('#AppointmentNotes').closest('td').append('<span class="ValMsg" style="color:red">*</span>');
        msgCount = 1;
    }
    if ($('#AppointmentDate').is(":visible") && $('#AppointmentDate').val() == '') {
        $('#AppointmentDate').closest('td').append('<span class="ValMsg" style="color:red;padding-left:30px;">*</span>');
        msgCount = 1;
    }
    else {
        var fupdate = $('#AppointmentDate').val();
        endDateStr1 = fupdate.split(' ')[0];
        var timevalidation = IS_12HRS_FORMAT ? /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/ : /^([0?1][0-9]|2[0-3])(:[0-5]\d)$/;
        if (!date_regex.test(endDateStr1)) {
            CmnStatusMessageDisp('divRequestRejectCommentsPopupMsg', 'Enter valid Date in MM/DD/YYYY format.', 'Error');
            $('#AppointmentDate').closest('td').append('<span class="ValMsg" style="color:red;padding-left:30px;">*</span>');
            msgCount = 1;
        }
        else if (!timevalidation.test(fupdate.split(' ')[2] != undefined ? fupdate.split(' ')[1] + ' ' + fupdate.split(' ')[2] : fupdate.split(' ')[1])) {
            CmnStatusMessageDisp('divRequestRejectCommentsPopupMsg', 'Enter valid time.', 'Error');
            $('#AppointmentDate').closest('td').append('<span class="ValMsg" style="color:red;padding-left:30px;">*</span>');
            msgCount = 1;
        }
        else if (new Date($('#AppointmentDate').val()) < new Date($("#CurrentUserDate").val()) && $('#selectAppointmentStatus option:selected').text().toLowerCase() !== 'completed') {
            CmnStatusMessageDisp('divRequestRejectCommentsPopupMsg', "Appointment date should be greater than or equal to today's date.", 'Error');
            $('#AppointmentDate').closest('td').append('<span class="ValMsg" style="color:red;padding-left:30px;">*</span>');
            msgCount = 1;
        }
        else if (new Date($('#AppointmentDate').val()) > new Date($("#CurrentUserDate").val()) && $('#selectAppointmentStatus option:selected').text().toLowerCase() === 'completed') {
            CmnStatusMessageDisp('divRequestRejectCommentsPopupMsg', "Appointment date should be less than or equal to today's date.", 'Error');
            $('#AppointmentDate').closest('td').append('<span class="ValMsg" style="color:red;padding-left:30px;">*</span>');
            msgCount = 1;
        }
        else {
            $('#AppointmentDatemsg').find('.requiredfields').hide();
        }
    }

    if (msgCount > 0)
        return false;
    else
        return true;
}
function SubUpdAppForm() {
    if (valUpdAppForm()) {
        var rulePatientId = $('#hdnRequestReceivedRulePatientId').val();
        var datastring = $("#divAppointmentUpdatePopup form").serialize();
        $('select[disabled]').each(function () {
            datastring = datastring + '&' + $(this).attr('name') + '=' + $(this).val();
        });
        datastring = datastring + '&PatientId=' + rulePatientId
        var updAppUrl = baseURL + "/Home/UpdateAppointment/";
        $.ajax({
            type: "POST",
            url: updAppUrl,
            data: datastring,
            dataType: "json",
            asyns: false,
            success: function (data) {
                if (data.success && data.success == true) {
                    var ficoObject = { eventSource: "RRCMAPPOINTMENTREJECT", parentConrolId: "", moduleName: "CM", eventType: "POST", patientId: rulePatientId, isAsync: true };
                    var response = ficoRealTimeValidation(ficoObject);
                    CheckValidationMessages(response);
                    if (!$('#ReceivedAppoinmentCount').attr('id')) {
                        try {
                            if (isMAL) {
                                RefreshGridOnActionPerformed("REQREC", "CM");
                                RefreshGridOnActionPerformed("REQREJ", "CM");
                            }
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                    }
                    if ($('#ReceivedAppoinmentCount').attr('id'))
                        FillRequestCountFreek();
                    $('#btnRequestReceivedSearch' + (isMAL ? 'MAL' : '')).trigger('click');
                    $('#closePopUp').trigger('click');
                    $('#dBCal').trigger('click');
                }
            },

        });
    }
}

function AcceptMember(inactivateCM) {
    $.ajax({
        type: "GET",
        url: baseURL + "/CommonDefaultSessionState/AcceptReferenceForMember?listReferenceId=" + $("#hdnReferenceIds").val() + "&listPatientId=" + $("#hdnPatientIdRR").val() + "&listIsActTransfer=" + $("#hdnIsActTransferValues").val() + "&inactivateCM=" + inactivateCM + "&isMTM=" + (isMTMval === true || isMTMval.toLowerCase() === 'true'),
        dataType: "json",
        success: function (data) {
            if (data.success) {
                CustomAlert(data.msg);
                $('#btnRequestReceivedSearch' + (isMAL ? 'MAL' : '')).trigger('click');
                if ($('#ReceivedAppoinmentCount').attr('id'))
                    FillRequestCountFreek();
                var MymemberheaderName = $('#MyMemberHeaderName').html();
                if (MymemberheaderName == 'My Members') {
                    $('#btnMyMemRfsh').trigger('click');
                }
                $("#hdnIsFromIAPCM").val('');
                if ($('#ddlPActReferTypeCM').val() == 'Member' && $('#ddlPActModule').val() == "1") {
                    $("#CMMyMembersGrid").data("kendoGrid").dataSource.page(1);
                }
            }
            else
                CustomAlert(data.msg);
            loader(0);
            $("#closePopUp").trigger('click');
        },
        error: function () { $("#closePopUp").trigger('click'); loader(0); }
    });
}
function AcceptReqReceivedAGComplaint(listReferralId, listComplaintId, Source, listpatientId) {
    var listCheckBox = null; var ddlRRReferType = '';
    if (Source == '1') { // Is from WLM
        listCheckBox = $('.AGPendingComplaintsGridchildcheckbox:checked:visible');
        ddlRRReferType = '6';
    }
    else {
        listCheckBox = Source == 'MAL' ? $('#ReqRecGridMAL .clsRefralChkMember:checked') : $('.clsRefralChkMember:checked');
        ddlRRReferType = Source == 'MAL' ? $('#selectRequestReceivedReferTypeMAL').val() : $('#selectRequestReceivedReferType').val();
    }
    
    $.ajax({
        type: "POST",
        url: baseURL + "/CommonDefaultSessionState/AcceptReferenceForAGComplaint?ReferelId=" + listReferralId + "&ComplaintId=" + listComplaintId + "&ddlRRReferType=" + ddlRRReferType + "&listPatientId=" + listpatientId,
        dataType: "json",
        success: function (data) {
            loader(0);
            if (data.success) {
                if (listCheckBox.length == 1) {
                    var listComplaintRedirect = $(listCheckBox[0]).data('complaintredirect').split('|');
                    SetComplaintData(listComplaintRedirect[0], listComplaintRedirect[1], listComplaintRedirect[2], null, null, null);
                }
                else {
                    CustomAlert(data.msg);
                }
            }
            else
                CustomAlert(data.msg);

            if (Source == '1' && listCheckBox.length > 1) {
                $("#AGPendingComplaintsGrid").data("kendoGrid").dataSource.read();
            }
            else {
                if (Source === 'MAL') {
                    $('#btnRequestReceivedSearchMAL').trigger('click');
                    RefreshGridOnActionPerformed("TCAL", "AG");
                    if (listCheckBox.length > 1) {
                        BindRequestRecievedDataMAL();
                    }
                }
                else {
                    $('#btnRequestReceivedSearch').trigger('click');
                    if ($.trim($('#MyMemberHeaderName').html()) == 'Open Complaints') {
                        $("#OpenComplaints").data("kendoGrid").dataSource.read();
                    }
                }
            }

        }
    });
    listCheckBox.removeAttr('checked');
}
function UMAuthAccept(listCheckBox, listReferralId, source, IsFromWLM) {
    loader(1);
    $.ajax({
        type: "GET",
        url: baseURL + '/Dashboard/AcceptReferenceForUMAuth',
        dataType: "json",
        data: {
            'listReferalId': listReferralId,
            'timeDictionaryobj': timeZone
        },
        success: function (data) {
            if (data.success) {
                loader(0);
                if (data.flag) {
                    if (listCheckBox.length == 1) {
                        //var referenceId = getReferreceId('requestReceived');
                        lstAuthRedVals = $(listCheckBox[0]).data('authredirect').split('|');
                        SetAuthDatanew(lstAuthRedVals[0], lstAuthRedVals[1], lstAuthRedVals[2], lstAuthRedVals[3], lstAuthRedVals[4], lstAuthRedVals[5]);
                    }
                    else {
                        CustomAlert(data.msg);
                        if (source !== 'mal') {
                            $('#btnRequestReceivedSearch').trigger('click');
                            if ($.trim(($('#MyMemberHeaderName').html() || '').toUpperCase()) == 'OPEN AUTHORIZATION' && $("#OpenAuthorization").data("kendoGrid") != null) {
                                $("#OpenAuthorization").data("kendoGrid").dataSource.read();
                            }
                        }
                        else if (source === 'mal' && $("#ReqRecGridMAL").data("kendoGrid") !== undefined) {
                                $("#ReqRecGridMAL").data("kendoGrid").dataSource.read();
                        } else {
                            // For Sonar
                        }
                        if (IsFromWLM == '1')
                            $("#UMPendingAuthorizationsGrid").data("kendoGrid").dataSource.read();
                    }
                }
                else {
                    CustomAlert(data.msg);
                    if (source != 'mal') {
                        if (isDashBoardRefresh) {
                            DashBoardRefresh("UM");
                        } else {
                            $('#btnRequestReceivedSearch').trigger('click');
                        }
                    }
                    if (IsFromWLM == '1')
                        $("#UMPendingAuthorizationsGrid").data("kendoGrid").dataSource.read();
                }
            }
            else {
                CustomAlert(data.msg);
                loader(0);
            }
        }
    });
}

function acceptReqRecComments(dataParams) {
    $.ajax({
        type: "POST",
        url: baseURL + "/CommonDefaultSessionState/AcceptReferenceForActivity",
        dataType: "json",
        data: dataParams,
        success: function (data) {
            if (data.success) {
                if ($('#hdnActLogReqRecReqType').val() == "ActLogReqRec") {
                    $('#btnCloseRequestReceivedAcceptComments').trigger('click');
                    $('#btnActLogRequestReceivedSearch').trigger('click');
                    $('#btnActLogMemberActSearch').trigger('click');
                } else {
                    refereshDatasourcefromPager('ReqRecGrid' + (isMAL ? 'MAL' : ''));
                    RefreshGridOnActionPerformed("TCAL", "CM");
                    // $('#btnRequestReceivedSearch,#btnCloseRequestReceivedAcceptComments').trigger('click');
                    $('#btnCloseRequestReceivedAcceptComments').trigger('click');
                    $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                    if (((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) && !isMAL) {
                        if ((data.msg == 'Activity has been accepted successfully!') || (data.msg == 'All activities have been accepted successfully!.'))
                            CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Success');
                        else
                            CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Error');
                    }
                    else {
                        legacyModalAlert("Message", data.msg, true, null, true, 10000);
                    }
                    if ($('#ReceivedAppoinmentCount').attr('id'))
                        FillRequestCountFreek();
                }
            } else {
                if (((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) && !isMAL)
                    CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Error');
                else
                    legacyModalAlert("Message", data.msg, true, null, true, 10000);
            }
            $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled');
            if ($('#ddlPActReferTypeCM').val() == 'Activity' && $('#ddlPActModule').val() == "1") {
                $("#CMPendingActivitiesGrid").data("kendoGrid").dataSource.page(1);
            }
        }
    });
}
function ValidateReReferdata() {
    var msgcount = 0;
    if ($('#chkRRGroupActivity').is(':checked')) {
        if ($('#ddlRRStaffIdsIdhdn').val() == null || $('#ddlRRStaffIdsIdhdn').val() == "") {
            msgcount = 1;
        } else {
            $('#ddlRRStaffIdsIdhdn').closest('td').find('.requiredfields').hide();
        }
    }
    else {
        if ($('#hdnCareStaffRequestRejectReferMember').val() == "" || $.trim($('#selectCareStaffRequestRejectReferMember').val()) == "") {
            msgcount = 1;
            $('#selectCareStaffRequestRejectReferMember').closest('td').find('.requiredfields').show();
        } else {
            $('#selectCareStaffRequestRejectReferMember').closest('td').find('.requiredfields').hide();
        }
    }
    if ($('#selectReasonForRefRequestRejectReferMember').val() < 0) {
        msgcount = 1;
        $('#selectReasonForRefRequestRejectReferMember').closest('td').find('.requiredfields').show();
    } else {
        $('#selectReasonForRefRequestRejectReferMember').closest('td').find('.requiredfields').hide();

    }
    if ($('#txtNotesRequestRejectReferMember').val().trim().length <= 0) {
        msgcount = 1;
        $('#txtNotesRequestRejectReferMember').closest('td').find('.requiredfields').show();
    } else {
        $('#txtNotesRequestRejectReferMember').closest('td').find('.requiredfields').hide();
    }
    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}
function formatDateWithTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var AMPM = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    var strTime = hours + ':' + minutes + ':' + seconds + ' ' + AMPM;
    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + " " + strTime;
}
function showOrHideSpecConfigColumn(columnName, colNumber) { //UHC-3712
    var visibleCols = careTeamVisibleCols.split('|');
    var isColConfigured = visibleCols.filter(function (obj) { return obj === columnName });
    if (isColConfigured.length > 0) { $("#careTeamGrid").data("kendoGrid").showColumn(colNumber); }
    else { $("#careTeamGrid").data("kendoGrid").hideColumn(colNumber); }
}
function disableCareTeamSearch(isDisable) {
    if (isDisable) {
        $('#txtCareTeamStartDate').attr('disabled', 'disabled');
        $('#txtCareTeamEndDate').attr('disabled', 'disabled');
        $('#btnCareTeamHistory').attr('disabled', 'disabled');
        $('#txtCareTeamStartDate').next().css('display', 'none');
        $('#txtCareTeamEndDate').next().css('display', 'none');
    }
    else {
        $('#dllCTActive').removeAttr('disabled');
        $('#txtCareTeamStartDate').removeAttr('disabled');
        $('#txtCareTeamEndDate').removeAttr('disabled');
        $('#btnCareTeamHistory').removeAttr('disabled');
        $('#txtCareTeamStartDate').next().css('display', 'block');
        $('#txtCareTeamEndDate').next().css('display', 'block');
    }
}
function CareTeamShowHideCol() {
    var selText = $('#ddlSearchCareTeamType option:selected').text();
    if (isDynColsDataExists == true) {
        showOrHideSpecConfigColumn("Care Team Role", 3);
        showOrHideSpecConfigColumn("Specialty", 9);
        showOrHideSpecConfigColumn("Phone", 10);
        showOrHideSpecConfigColumn("Extension Number", 11);
        showOrHideSpecConfigColumn("Fax", 12);
        showOrHideSpecConfigColumn("Start Date", 13);
        showOrHideSpecConfigColumn("End Date", 14);
        showOrHideSpecConfigColumn("Created By", 16);
        showOrHideSpecConfigColumn("Created On", 17);
        showOrHideSpecConfigColumn("Updated By", 18);
        showOrHideSpecConfigColumn("Updated On", 19);
        showOrHideSpecConfigColumn("Caregiver Type", 24);
    }
    if (selText == "Internal Care Team") {
        $("#careTeamGrid").data("kendoGrid").hideColumn(4);
        $("#careTeamGrid").data("kendoGrid").hideColumn(22);
        $("#careTeamGrid").data("kendoGrid").hideColumn(6);
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").showColumn(7);
            $("#careTeamGrid").data("kendoGrid").showColumn(8);
        }
        else {
            showOrHideSpecConfigColumn("Zip / Postal Code", 7);
            showOrHideSpecConfigColumn("Primary", 8);
        }
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(5);
        showOrHideSpecConfigColumn("Release of Information", 15);
        $("#careTeamGrid").data("kendoGrid").hideColumn(20);
        $("#careTeamGrid").data("kendoGrid").hideColumn(21);//UHC-3712
        $("#careTeamGrid").data("kendoGrid").hideColumn(24);
        $(".crtmAdd").show();
        $(".crtmEdit").show();
        $(".crtmDelete").show();
        $("#btnCareTeamHistory").show();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").show();
        $('.hoverIsPrimaryCls').aToolTip();
        disableCareTeamSearch(false);
    }
    else if (selText == "External Care Team") {
        $('.hoverIsPCPCls').aToolTip();
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").showColumn(4);
            $("#careTeamGrid").data("kendoGrid").showColumn(6);
            $("#careTeamGrid").data("kendoGrid").showColumn(5);
            $("#careTeamGrid").data("kendoGrid").showColumn(15);
            $("#careTeamGrid").data("kendoGrid").showColumn(22);
        }
        else {
            showOrHideSpecConfigColumn("PCP", 4);
            showOrHideSpecConfigColumn("PBP", 6);
            showOrHideSpecConfigColumn("Premium Provider", 5);
            showOrHideSpecConfigColumn("Release of Information", 15);
            showOrHideSpecConfigColumn("Health Home", 22);
        }
        $("#careTeamGrid").data("kendoGrid").hideColumn(7);
        $("#careTeamGrid").data("kendoGrid").hideColumn(8);
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(20);
        $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        $("#careTeamGrid").data("kendoGrid").hideColumn(24);
        $(".crtmAdd").show();
        $(".crtmEdit").show();
        $('.crtmDelete').show();
        $("#btnCareTeamHistory").show();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").show();
        disableCareTeamSearch(false);
    }
    else if (selText == "Provider") {
        $("#careTeamGrid").data("kendoGrid").hideColumn(4);
        $("#careTeamGrid").data("kendoGrid").hideColumn(6);
        $("#careTeamGrid").data("kendoGrid").hideColumn(7);
        $("#careTeamGrid").data("kendoGrid").hideColumn(8);
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(5);
        $("#careTeamGrid").data("kendoGrid").hideColumn(15); //UHC-3712
        $("#careTeamGrid").data("kendoGrid").hideColumn(20);
        $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        $("#careTeamGrid").data("kendoGrid").hideColumn(22);
        $("#careTeamGrid").data("kendoGrid").hideColumn(24);
        $(".crtmAdd").show();
        $(".crtmEdit").show();
        $(".crtmDelete").show();
        $("#btnCareTeamHistory").show();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").show();
        disableCareTeamSearch(false);
    }
    else if (selText == "Caregiver") {
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").showColumn(8);
            $("#careTeamGrid").data("kendoGrid").showColumn(15);
        }
        else {
            showOrHideSpecConfigColumn("Primary", 8);
            showOrHideSpecConfigColumn("Release of Information", 15);
        }
        $("#careTeamGrid").data("kendoGrid").hideColumn(4);
        $("#careTeamGrid").data("kendoGrid").hideColumn(6);
        $("#careTeamGrid").data("kendoGrid").hideColumn(7);
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(5);
        $("#careTeamGrid").data("kendoGrid").hideColumn(20);
        $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        $("#careTeamGrid").data("kendoGrid").hideColumn(22);
        showOrHideSpecConfigColumn("Caregiver Type", 24);
        $(".crtmAdd").show();
        $(".crtmEdit").show();
        $(".crtmDelete").show();
        $("#btnCareTeamHistory").show();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").show();
        disableCareTeamSearch(false);
    }
    else if (selText == "PCP History") {
        $('.hoverIsPCPCls').aToolTip();
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").showColumn(4);
            $("#careTeamGrid").data("kendoGrid").showColumn(6);
            $("#careTeamGrid").data("kendoGrid").showColumn(5);
            $("#careTeamGrid").data("kendoGrid").hideColumn(22);
        }
        else {
            showOrHideSpecConfigColumn("PCP", 4);
            showOrHideSpecConfigColumn("PBP", 6);
            showOrHideSpecConfigColumn("Premium Provider", 5);
            showOrHideSpecConfigColumn("Health Home", 22);
        }
        $("#careTeamGrid").data("kendoGrid").hideColumn(7);
        $("#careTeamGrid").data("kendoGrid").hideColumn(8);
        $("#careTeamGrid").data("kendoGrid").hideColumn(15); //UHC-3712
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(20);
        $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        $("#careTeamGrid").data("kendoGrid").hideColumn(24);
        $(".crtmAdd").hide();
        $(".crtmEdit").hide();
        $(".crtmDelete").hide();
        $("#btnCareTeamHistory").hide();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").hide();
        disableCareTeamSearch(false);

    }
    else if (selText == "Common Contacts") {
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").hideColumn(20);
            $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        }
        else {
            showOrHideSpecConfigColumn("Billing NPI", 20);
            showOrHideSpecConfigColumn("NPI Type", 21);
        }
        $("#careTeamGrid").data("kendoGrid").hideColumn(4);
        $("#careTeamGrid").data("kendoGrid").hideColumn(5);
        $("#careTeamGrid").data("kendoGrid").hideColumn(6);
        $("#careTeamGrid").data("kendoGrid").hideColumn(7);
        $("#careTeamGrid").data("kendoGrid").showColumn(11);
        $("#careTeamGrid").data("kendoGrid").showColumn(12);
        $("#careTeamGrid").data("kendoGrid").hideColumn(15);
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#careTeamGrid").data("kendoGrid").hideColumn(22);
        $("#careTeamGrid").data("kendoGrid").hideColumn(24);
        $(".crtmAdd").show();
        $(".crtmEdit").show();
        $(".crtmDelete").show();
        $("#btnCareTeamHistory").show();
        $("#chkCareTeamdefaultContainer").show();
        $("#divdllCTActive").show();
        disableCareTeamSearch(true);
    }
    else {
        $('.hoverIsPCPCls').aToolTip();
        if (isDynColsDataExists == false) {
            $("#careTeamGrid").data("kendoGrid").showColumn(4);
            $("#careTeamGrid").data("kendoGrid").showColumn(6);
            $("#careTeamGrid").data("kendoGrid").showColumn(8);
            $("#careTeamGrid").data("kendoGrid").showColumn(5);
            $("#careTeamGrid").data("kendoGrid").showColumn(15);
            $("#careTeamGrid").data("kendoGrid").hideColumn(22);
            $("#careTeamGrid").data("kendoGrid").hideColumn(7);
            $("#careTeamGrid").data("kendoGrid").hideColumn(20);
            $("#careTeamGrid").data("kendoGrid").hideColumn(21);
        }
        else {
            showOrHideSpecConfigColumn("PCP", 4);
            showOrHideSpecConfigColumn("PBP", 6);
            showOrHideSpecConfigColumn("Primary", 8);
            showOrHideSpecConfigColumn("Premium Provider", 5);
            showOrHideSpecConfigColumn("Release of Information", 15);
            showOrHideSpecConfigColumn("Health Home", 22);
            showOrHideSpecConfigColumn("Zip / Postal Code", 7);
            showOrHideSpecConfigColumn("Billing NPI", 20);
            showOrHideSpecConfigColumn("NPI Type", 21);
        }
        $(".crtmAdd").hide();
        $('.crtmDelete').hide();
        $(".crtmEdit").show();
        $("#btnCareTeamHistory").show();
        $("#careTeamGrid").data("kendoGrid").showColumn(0);
        $("#divdllCTActive").show();
        $('.hoverIsPrimaryCls').aToolTip();
        disableCareTeamSearch(false);
    }
    if ($('#dllCTActive option:selected').text() == "Inactive") {
        //g8cal-18
        $("#chkCareTeamdefaultContainer").hide();
        if (selText === "Internal Care Team") {
            $('#careTeamGrid .clschkCareTeamHead').hide();
            $(".crtmEdit").show();
        }
        else if (selText === "Caregiver") {
            $("#careTeamGrid").data("kendoGrid").showColumn(0);
            $('#careTeamGrid .clschkCareTeamHead').show();
            $(".crtmEdit").show();
        }
        else if (selText === "PCP History") {
            $("#careTeamGrid").data("kendoGrid").hideColumn(0);
            $("#chkCareTeamdefaultContainer").show();
        }
        else {
            $("#careTeamGrid").data("kendoGrid").hideColumn(0);
            $(".crtmEdit").hide();
        }
        $(".crtmAdd").hide();
        $(".crtmDelete").hide();
        $("#btnCareTeamHistory").hide();
    }
    else {
        if (selText === "PCP History") {
            $('#careTeamGrid .clschkCareTeamHead').hide();
            $("#careTeamGrid").data("kendoGrid").hideColumn(0);
        }
        else {
            $('#careTeamGrid .clschkCareTeamHead').show();
        }
        $("#chkCareTeamdefaultContainer").show();
    }
}
function ValidateAcceptAgActivity(CompSchedularDate, ActivityDuedate, ComplaintRecivedDate) {
    var flag = true;
    var isValidDateTime = true;
    $(".AcceptCommentsScheduleddate .k-input").each(function (index, element) {
        var endDateStr1 = $(element).val();
        if (endDateStr1 === "") {
            CompSchedularDate = "";
            $(this).closest('td').find('#ScheduledDate_Valid').show();
        }
        else {
            $(this).closest('td').find('#ScheduledDate_Valid').hide();
            var endDateStr2 = endDateStr1.split(' ')[0];
            var timevalidation = IS_12HRS_FORMAT ? /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/ : /^([0?1][0-9]|2[0-3])(:[0-5]\d)$/;
            if (!date_regex.test(endDateStr2)) {
                $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>Enter valid Date in MM/DD/YYYY format</span>');
                if (isValidDateTime) {
                    isValidDateTime = false;
                }
            }
            else if (!timevalidation.test(endDateStr1.split(' ')[2] !== undefined ? endDateStr1.split(' ')[1] + ' ' + endDateStr1.split(' ')[2] : endDateStr1.split(' ')[1])) {
                $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>Enter valid time</span>');
                if (isValidDateTime) {
                    isValidDateTime = false;
                }
            }
            else {
                if (isValidDateTime) {
                    isValidDateTime = true;
                }
            }
        }
    });
    if (ToValue(CompSchedularDate, "") === "") {
        CmnStatusMessageDisp('divRequestAGAcceptCommentsPopupMsg', "Enter valid Date in MM/DD/YYYY format for scheduled date.", 'Error');
        return false;
    }
    else if (!isValidDateTime) {
        return false;
    }
    else {
        if ((ToValue(ActivityDuedate, "") !== "") && (new Date(CompSchedularDate) > new Date(ActivityDuedate))) {
            flag = CustomConfirm("Scheduled date is greater than due date, click Ok to continue");
        }
    }
    return flag;
}
function ValidationForRejReferalComplaint() {

    $('span.validationMessage').remove();
    $msg = $('#validationMessageReferComplaint');
    $msg.html('');

    if ($("#chkRRAGGroupActivity").is(":checked") == true) {
        var staffIds = $('#ddlRRAGStaffIdsIdhdn').val();
        if (staffIds == '') {
            $('#tdRejAGComplaintReferWQReferTo').append('<span class="validationMessage"  style="color:red">*</span>');
            return false;
        }
    }
    else {
        if ($('#selectRRejAGComplaintReferReferTo').val() == -1) {
            $('#tdRejAGComplaintReferReferTo').append('<span class="validationMessage"  style="color:red">*</span>');
            return false;
        }
    }
    return true;
}
//uhg-2365 Add Timezone,Hint Que,Ans Validations
function ValidateCareStaffDetails() {
    let isValid = true;

    A11yForms.clearFormFieldValidation();

    isValid &= A11yForms.validateFormField('txtFirstName', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('txtLastName', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('txtPrimaryPhone', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtAlternatePhone', null, [A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtMobileName', null, [A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtFax', null, [A11yForms.VALIDATIONS.FAX]);
    isValid &= A11yForms.validateFormField('txtPrimaryEmail', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.EMAIL]);
    isValid &= A11yForms.validateFormField('txtAlternateEmail', null, [A11yForms.VALIDATIONS.EMAIL]);
    isValid &= A11yForms.validateFormField('txtZip', null, [A11yForms.VALIDATIONS.ZIP]);
    isValid &= A11yForms.validateFormField('TimeZone', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('HintId', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('txtHintAnswer', null, A11yForms.VALIDATIONS.REQUIRED);

    if (!isValid) {
        A11yAlerts.createErrorAlert('#divUserProfileMessage');
    }

    return isValid;
}
function UpdateCareStaffDetails() {
    datastring = $('#btnUpdate').closest('form').serialize();
    var languageIds = $('#ddlLanguageIdhdn').val();
    var Url = baseURL + "/CommonDefaultSessionState/UpdateCareStaffDetails?languageIds=" + languageIds;
    $.ajax({
        type: "POST",
        url: Url,
        data: datastring,
        dataType: "json",
        asyns: false,
        success: function (data) {
            if (data.success && data.success == true) {
                A11yAlerts.createSuccessAlert('#divUserProfileMessage', data.msg + '. In order for changes to take effect, please log out and log back in.');
                receiveCareTransitionNotification = $('#chkEPCareTransitionNotification').is(":checked");
                carestaffAddress = data.carestaffAddress; //UHC-3380
            }
            else {
                A11yAlerts.createErrorAlert('#divUserProfileMessage', data.msg);
            }
        },
        error: function () {
            A11yAlerts.createErrorAlert('#divUserProfileMessage', A11yAlerts.ALERT_MSG.ERROR_OCCURRED);
        }
    });
}
function AddMSActivity(obj) {
    var StaffGroupIds = "";
    var deptId = "";
    if ($('#chkGroupActivity').is(':checked')) {
        StaffGroupIds = $('#ddlStaffIdsIdhdn').val();
        deptId = $('#ddlMsDepartment').val();
    }
    var ficoEventSource = "";
    if ($(obj).text() === 'Add') {
        ficoEventSource = "CMACTIVITYADD";
    } else if ($(obj).text() === 'Update and Close') {
        ficoEventSource = "CMACTIVITYUPDATE";
    } else {
        ficoEventSource = "CMACTIVITYADD";
    }
    var ficoCmActivity = {
        scheduledActivity: $("#selectActivityType").data("kendoDropDownList") != null ? $("#selectActivityType").data("kendoDropDownList").text() : "",
        completedActivity: $("#ddlActTypeCompleted").find('.k-input').html(),
        msActivity: $("#selectMSActivityType").data("kendoDropDownList") != null ? $("#selectMSActivityType").data("kendoDropDownList").text() : "",
        isWorkQueue: $('#chkGroupActivity').is(':checked'),
        workQueueName: $("#ddlDepartmentIdhdntxt").val(),
        type: $("#selectScheduledType :selected").text(),
        forCareStaff: $("#rdoEAInternal").is(":checked")
    };
    var dataParams = "";
    var comment = $('#Comments').val();
    var AddActUrl = baseURL + "/MemberService/AddMSActivity?patientID=" + $('#PatientId').val() + "&activityTypeId=" + $('#selectMSActivityType').val() + "&followupDate=" + $('#FollowupDate').val() + '&carestaffID=' + $('#hdnCareStaffAddActivity').val() + "&comments=" + encodeURIComponent(comment) + '&deptId=' + deptId + '&staffIds=' + StaffGroupIds;
    $.ajax({
        type: "GET",
        url: AddActUrl,
        data: dataParams,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data == 1) {
                var ficoObject = { eventSource: ficoEventSource, parentConrolId: "", moduleName: "CM", eventType: "POST", cmActivityInfo: ficoCmActivity, isAsync: true };
                var response = ficoRealTimeValidation(ficoObject);
                CheckValidationMessages(response);
                if ($(obj).text() === 'Add') {
                    ClearMSAddActivity();
                }
                CmnStatusMessageDisp('validationMessageActivity', "Activity added successfully.", 'Success');
                var isMyScheduleVisibleAdd = $('#popUpGlobalMySchedule').is(':visible');
                if (isMyScheduleVisibleAdd) {
                    var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                    if (currentView == "Week") {
                        $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                        loadGlobalMySchedule();
                    }
                    else {
                        $("#scheduler").data("kendoScheduler").dataSource.read();//PROD-1103
                    }
                }
                if (!isMyScheduleVisibleAdd && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                    $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                }

                if ($(obj).attr('id') === 'btnCloseActivityForm') {
                    closeEditActivityForm();
                }
                if (($('#HiddenToDoListTabId').val() != "" || $('#HiddenToDoListTabId').val() != "undefined") && $("#hdnIsClinicalReqActivity").val() == "0") //PROD-6418
                    $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
                if ($("#hdnIsClinicalReqActivity").length > 0 && $("#hdnIsClinicalReqActivity").val() == '1') { //PROD-6418
                    $('#tabClinicalRequiredActivityList_' + $('#hdnClinicalRequiredActId').val()).trigger('click');
                } //PROD-6418
                if ($.trim($('#panelTitle,#requestHeaderName').text()) == 'Request Rejected')
                    $('#btnRequestReceivedSearch').trigger('click');
                if ($("#outstandingActivitesGrid").is(':visible')) {
                    $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
                }
                if ($("#outstandingExternalActivitesGrid").is(':visible')) {
                    $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
                }
            }
            else
                CmnStatusMessageDisp('validationMessageActivity', "Error please try again.", 'Error');

        }
    });
}

function ClearMSAddActivity() {
    $("#selectMSActivityType").data("kendoDropDownList").value(-1);
    $('#Comments').val('');
    $('#FollowupDate').kendoDateTimePicker({ value: new Date(currentFollowupdate), format: getDateWithoutSecondFormat() });
}

function ValidationForMSAddActivity() {  // NOSONAR Complaining about operators
    let isValid = true;

    A11yForms.clearFormFieldValidation();

    if ($.trim($('#bulkPatientIdAddActivity').val()) === "" && $('#PatientName') !== undefined && $('#PatientId').val() === '0') {
        A11yForms.showFormFieldError('PatientName', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#selectMSActivityType').val() === '-1' || $('#selectMSActivityType').val() === "") {
        A11yForms.showFormFieldError('selectMSActivityType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    isValid &= validateScheduledDate();
    isValid &= validateMSWorkQueueActivity();

    if (!isValid) {
        A11yAlerts.createErrorAlert('#validationMessageActivity', null, true);
    } else {
        clearAddOrEditValidation();
    }

    return isValid;
}

function validateMSWorkQueueActivity() {
    let isValid = true;
    if ($('#chkGroupActivity').is(':checked')) {
        // Work Queue Activity is checked
        let workQueueId = $('#ddlMsDepartment').val();
        if (workQueueId === "" || workQueueId === "-1") {
            A11yForms.showFormFieldError('ddlMsDepartment', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }

        let StaffIds = $('#ddlStaffIdsIdhdn').val();
        if (StaffIds === "") {
            A11yForms.showFormFieldError('ddlStaffIds', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }

        return isValid;
    }

    if ($.trim($('#ddlMSCareStaffAddActivity').val()) === "" || $.trim($('#hdnCareStaffAddActivity').val()) === "") {
        A11yForms.showFormFieldError('ddlMSCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED);
        $('#hdnCareStaffAddActivity').val('');
        return false;
    }

    let ds = $("#ddlMSCareStaffAddActivity").data("kendoAutoComplete").dataSource.data();
    if (ds != null && ds.length > 0) {
        let dataItem = $.grep(ds, function (v) {
            return v.FullName === $("#ddlMSCareStaffAddActivity").val();
        });
        if (dataItem == null || dataItem.length === 0) {
            $("#ddlMSCareStaffAddActivity").val('');
            $("#hdnCareStaffAddActivity").val('');
            A11yForms.showFormFieldError('ddlMSCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED);
            return false;
        }

        return true;
    }

    let loginstaffName = careStaffFullNameWithRole;
    if ($.trim($('#ddlMSCareStaffAddActivity').val()).toLowerCase() !== $.trim(loginstaffName).toLowerCase()) {
        $("#ddlMSCareStaffAddActivity").val('');
        $("#hdnCareStaffAddActivity").val('');
        A11yForms.showFormFieldError('ddlMSCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED);
        return false;
    }

    return true;

}

function CheckAvailability(obj) {
    var startDate = $('#activityForm #FollowupDate').val();
    var endDate = $('#activityForm #DueDate').val();
    var duration = $('#activityForm #FollowupDuration').val();

    var datastring = $("#activityForm form").serialize();
    if ($(".EACareStaffType").is(":Visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
        datastring += datastring.search("type=EXTERNAL") < 0 ? "&type=EXTERNAL" : "";
        var id = $('#ProviderFollowupId').val();
    }
    else
        var id = $('#PatientFollowupId').val();

    if (preStartDate != startDate || preEndDate != endDate || preDuration != duration) {
        $.ajax({
            type: "POST",
            url: baseURL + "/Home/CheckAvailabilityAsync?patientFollowupId=" + id,
            data: datastring,
            dataType: "json",
            async: true,
            success: function (data) {
                //if (data == -1) { console.log('sp err'); }
                if (data != 0) {
                    var btnSubmitVal = $('#btnSubmitActivityForm').val() || '';
                    var btnCloseVal = $('#btnCloseActivityForm').val() || '';
                    var popName = 'Add Activity';

                    var submitValLower = btnSubmitVal.toLowerCase();
                    var closeValLower = btnCloseVal.toLowerCase();

                    if (submitValLower.includes('edit') || submitValLower.includes('update') ||
                        closeValLower.includes('edit') || closeValLower.includes('update')) {
                        popName = 'Edit Activity';
                    }
                    $().ConfirmationBox({
                        Title: popName, Top: 200, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                        Content: "An activity is already scheduled for this time. Would you still prefer to schedule this activity on this time?"
                    }, function (response) {
                        if (response) AddUpdateActvt(obj);
                        else
                            $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                    });
                } else AddUpdateActvt(obj);
            }
        });
    }
    else {
        AddUpdateActvt(obj);
    }
}
function GetAddActivityCSValue() {
    if ($(".EACareStaffType:checked").val() === "PHARMACIST") {
        return $('#hdnPharmacyCareStaffAddActivity').val();
    }
    else {
        return $('#hdnCareStaffAddActivity').val();
    }
}
function AddUpdateActvt(obj) {
    loader(1);
    $('#activityForm #CareTeamIds').val($('#AddActCareTeamhdn').val());
    var ficoEventSource = "";
    if ($(obj).text() === 'Add') {
        ficoEventSource = "CMACTIVITYADD";
    } else if ($(obj).text() === 'Update and Close') {
        ficoEventSource = "CMACTIVITYUPDATE";
    } else {
        ficoEventSource = "CMACTIVITYADD";
    }
    var ddl = $('#selectActivityType').data('kendoDropDownList');
    if (ddl != undefined) { ddl.enable(true); }
    if ($("#selectScheduledType").val() == 0 || $("#selectScheduledType").val() == 1)
        $('#CustomFiledDetailsXmlData').val(fnCreateCustomFieldstoXML("divcustomfields", parseInt($("#selectScheduledType").val()) + 1, 1));
    if ($("#selectScheduledType").val() == 1)
        $('#OutComeCustomFiledDetailsXmlData').val(fnCreateCustomFieldstoXML("divOutComeCustomField", 2, 2));
    var datastring = $("#activityForm form").serialize();
    datastring = datastring + '&StaffId=' + $('#ddlStaffIdsIdhdn').val();
    $('select[disabled]').each(function () {
        datastring = datastring + '&' + $(this).attr('name') + '=' + $(this).val();
    });
    datastring = datastring + '&isMTM=' + (isMTMval === true || isMTMval.toLowerCase() === 'true' || $(".EACareStaffType:checked").val() == "PHARMACIST");

    $("#divcustomfields").html();
    if ($('#activityForm #DueDate').is(':disabled')) { datastring = datastring + '&' + $('#activityForm #DueDate').attr('name') + '=' + $('#activityForm #DueDate').val(); }
    if ($('#chkProgramActivity').is(':checked') == true) {
        if ($('#divEditActHierarchy .clsRdoMemEligMini:checked').length > 0) { datastring = datastring + '&LobBenId=' + $('#divEditActHierarchy .clsRdoMemEligMini:checked').data('lobbenid'); }
        else if ($('#PatientFollowupId').val() != null || $('#PatientFollowupId').val() != "") { datastring = datastring + '&LobBenId=' + $('#divEditActHierarchyName').find('.clsMemEligClick').data('lobbenid'); }
    }
    var chkdChkBx = $('#chkGroupActivity').is(':checked');
    var chkRecurring = $('#chkIsRecurringActivity').is(':checked');
    //var deptId = $('#ddlStaffIdsIdhdn').val();
    //var workQueueId = $('#ddlDepartment').val();
    var workQueueId = $('#ddlDepartmentIdhdn').val();
    var activityNotes = chkdChkBx ? $('#Comments').val() : $('#OutComeComments').val();
    var activityOutComeId = $('#ddlActivityOutcome').val();
    var placeOfServiceId = $('#ddlActivityPlaceOfService').val();
    var DocumentId = $("#hdnPatientDocumentId").val();
    var ActivityTypeId = $("#selectActivityType").val();
    if (DocumentId == '') { DocumentId = 0; }
    var isRescheduled;
    var isMyScheduleVisibleAdd = $('#popUpGlobalMySchedule').is(':visible');
    if ($('#hdnIsReSchedueled').val() == '1')
        isRescheduled = true;
    else
        isRescheduled = false;
    var isNoteUpd = $('#Comments').length > 0 ? true : false;
    var notesConTypeId = $('input[name=rdoAHNIsConfidential]:checked').val();
    var outConTypeId = $('#AOIsConfidential:visible').length === 0 ? 0 : $('input[name=rdoAOIsConfidential]:checked').val();
    var HasNotification = 0;
    var completedActTypes = '';
    var engOutreachSubActivity = '';
    var AddActUrl = '';
    var ActivityTypeName = $("#selectActivityType").data("kendoDropDownList") != null ? $("#selectActivityType").data("kendoDropDownList").text() : "";
    if ($('#divReturnActivityNotification').is(':visible')) { HasNotification = $("#chkReturnActivityNotification").is(':checked') ? 1 : 0; }
    if ($.trim($('#bulkPatientIdAddActivity').val()) != "") {
        if ($('#selectScheduledType').val() == 1) {
            if ($('#hdnIsReSchedueled').val() == 1)
                completedActTypes = $('#CareActivityTypeId').val();
            else
                completedActTypes = $('#AddActTypeCompletedhdn').val();//multiple completed act selected
            AddActUrl = baseURL + "/Home/EditActivity?bulkPatientId=" + $.trim($('#bulkPatientIdAddActivity').val()) + "&IsChecked=" + chkdChkBx + "&activityType=" + ActivityTypeName + '&contactType=' + encodeURIComponent($('#selectContactType option:selected').text()) + '&workQueueId=' + workQueueId + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + $('#ddlHCPCCode').val() + '&completedActTypes=' + completedActTypes + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + ActivityTypeId + '&hasNotification=' + HasNotification + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&OutConfidetialTypeId=" + outConTypeId;
        }
        else {
            if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL")
                AddActUrl = baseURL + "/Home/EditExternalActivity?bulkPatientId=" + $.trim($('#bulkPatientIdAddActivity').val()) + "&IsChecked=" + chkdChkBx + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + ($('#ddlHCPCCode').val() || 0) + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + (ActivityTypeId || 0);
            else
                AddActUrl = baseURL + "/Home/EditActivity?bulkPatientId=" + $.trim($('#bulkPatientIdAddActivity').val()) + "&IsChecked=" + chkdChkBx + "&activityType=" + ActivityTypeName + '&contactType=' + encodeURIComponent($('#selectContactType option:selected').text()) + '&workQueueId=' + workQueueId + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + $('#ddlHCPCCode').val() + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + ActivityTypeId + '&hasNotification=' + HasNotification + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&OutConfidetialTypeId=" + outConTypeId;
        }
    }
    else {
        //uhc-69 - to send completed activties param only if activity type completed is selected
        if ($('#selectScheduledType').val() == 1) {
            if ($('#hdnEngOutReachActivity').val() !== undefined && $('#hdnEngOutReachActivity').val() === 'true') {
                completedActTypes = $('#hdnEngOutreachActivityTypeId').val();
                engOutreachSubActivity = $('#ddlEngOutReachSubType').is(':visible') ? $('#ddlEngOutReachSubType').val() : '';
            }
            else {
                if ($('#hdnIsReSchedueled').val() == 1)
                    completedActTypes = $('#CareActivityTypeId').val();
                else
                    completedActTypes = $('#AddActTypeCompletedhdn').val();//multiple completed act selected
            }
            if (!$(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() === "EXTERNAL" && ($('#hdnEngOutReachActivity').val() !== undefined && $('#hdnEngOutReachActivity').val() === 'true')) {
                AddActUrl = baseURL + "/Home/EditExternalActivity?IsChecked=" + chkdChkBx + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + ($('#ddlHCPCCode').val() || 0) + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + (ActivityTypeId || 0) + '&completedActTypes=' + completedActTypes + '&careActivitySubType=' + engOutreachSubActivity + '&isEngOutActivity=' + true;
            }
            else {
                AddActUrl = baseURL + "/Home/EditActivity?IsChecked=" + chkdChkBx + "&activityType=" + ActivityTypeName + '&contactType=' + encodeURIComponent($('#selectContactType option:selected').text()) + '&workQueueId=' + workQueueId + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + $('#ddlHCPCCode').val() + '&completedActTypes=' + completedActTypes + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + ActivityTypeId + '&hasNotification=' + HasNotification + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&OutConfidetialTypeId=" + outConTypeId + '&careActivitySubType=' + engOutreachSubActivity;
            }
        }
        else {
            if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() === "EXTERNAL") {
                AddActUrl = baseURL + "/Home/EditExternalActivity?IsChecked=" + chkdChkBx + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + ($('#ddlHCPCCode').val() || 0) + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + (ActivityTypeId || 0);
            }
            else {
                AddActUrl = baseURL + "/Home/EditActivity?IsChecked=" + chkdChkBx + "&activityType=" + encodeURIComponent(ActivityTypeName) + '&contactType=' + encodeURIComponent($('#selectContactType option:selected').text()) + '&workQueueId=' + workQueueId + '&activityOutcomeId=' + activityOutComeId + "&isRescheduled=" + isRescheduled + '&placeOfServiceId=' + placeOfServiceId + '&HCPCCode=' + $('#ddlHCPCCode').val() + "&DocumentId=" + DocumentId + "&ActivityTypeId=" + ActivityTypeId + '&hasNotification=' + HasNotification + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&OutConfidetialTypeId=" + outConTypeId + "&meetingGuid=" + meetingGuid;
                meetingGuid = "";
            }
        }
        //uhc-69
    }
    //PROD-10157 ---Starts Passing PH Qulaity measure parameters//isEmptyObject
    if (!jQuery.isEmptyObject(SelectedOppDetailIds) && SelectedQualityActionStatusId !== 0 && SelectedQualityMeasureStatusId !== 0 && ($('#dBQM').hasClass('TabbedPanelsTab TabbedPanelsTabSelected') || $('#liCarePlan').hasClass('TabbedPanelsTabSelected'))) {        
        AddActUrl = AddActUrl + '&QMOppDetailIds=' + SelectedOppDetailIds + '&QMActionStatusId=' + SelectedQualityActionStatusId + '&QMMeasureStatusId=' + SelectedQualityMeasureStatusId + '&careOppEventMeasureId=' + SelectedCareOppEventMeasureId;
        SelectedQualityActionStatusId = 0;
        SelectedQualityMeasureStatusId = 0;
        SelectedOppDetailIds = [];
        SelectedCareOppEventMeasureId = 0;
    }
    //PROD-10157---Ends
    var selectedCSorPharmacist = GetAddActivityCSValue();
    let selPatientId = $.fn.setNumberOnUndefinedOrNull($('#PatientId').val());
    var IsCheckCareStaffLeave = baseURL + "/Common/IsCareStaffInLeave?scheduleDate=" + $('#FollowupDate').val() + "&careStaff=" + selectedCSorPharmacist + "&isCoiFlag=" + true + "&patientId=" + selPatientId;
    //To Implement Leave functionality for scheduled Activity
    var ficoCmActivity = {
        scheduledActivity: ActivityTypeName,
        completedActivity: $("#ddlActTypeCompleted").find('.k-input').html(),
        msActivity: $("#selectMSActivityType").data("kendoDropDownList") != null ? $("#selectMSActivityType").data("kendoDropDownList").text() : "",
        isWorkQueue: chkdChkBx,
        workQueueName: $("#ddlDepartmentIdhdntxt").val(),
        type: $("#selectScheduledType :selected").text(),
        forCareStaff: $("#rdoEAInternal").is(":checked")
    };
    var ficoPreObject = { eventSource: ficoEventSource, parentConrolId: "", moduleName: "CM", eventType: "PRE", cmActivityInfo: ficoCmActivity };
    var ficoPreResponse = ficoRealTimeValidation(ficoPreObject);
    var isRuleHardValidation = CheckValidationMessages(ficoPreResponse);
    if (isRuleHardValidation) {
        loader(0);
        $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
        return;
    }
    if ($('#selectScheduledType').val() == "0" && !chkdChkBx && !chkRecurring) {
        $.ajax({
            type: "POST",
            url: IsCheckCareStaffLeave,
            dataType: "json",
            asyns: false,
            success: function (data) {
                if (data.success == true) {
                    if (!data.CoiRestrictedUser) {
                        var conFlag = CustomConfirm(data.Result);
                        if (conFlag) {
                            AddActUrl = AddActUrl + '&alternateCareStaff=' + data.AlternateCareStaff;
                            datastring = datastring.replace('&ReferTo=' + selectedCSorPharmacist, '&ReferTo=' + data.AlternateCareStaff);
                            $.ajax({
                                type: "POST",
                                url: AddActUrl,
                                data: datastring,
                                dataType: "json",
                                asyns: false,
                                success: function (data) {
                                    if (data.success && data.success == true) {
                                        var ficoObject = { eventSource: ficoEventSource, parentConrolId: "", moduleName: "CM", eventType: "POST", cmActivityInfo: ficoCmActivity, isAsync: true };
                                        var response = ficoRealTimeValidation(ficoObject);
                                        CheckValidationMessages(response);
                                        if ($(obj).text() === 'Add') {
                                            ClearAddActivity();
                                            // Re-apply program/clinical program context
                                            if (typeof applyProgramActivityContext === 'function') {
                                                applyProgramActivityContext();
                                            }
                                        }
                                        CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Success');
                                        //$('#validationMessageActivity').show().html('').html(data.model.ErrorMessage).css('color', 'green');
                                        if (isMyScheduleVisibleAdd) {
                                            var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                                            if (currentView == "Week") {
                                                $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                                                loadGlobalMySchedule();
                                            }
                                            else {
                                                $("#scheduler").data("kendoScheduler").dataSource.read();//PROD-1103
                                            }
                                        }

                                        if (isMAL) {
                                            RefreshGridOnActionPerformed("TCAL", "CM");
                                            RefreshGridOnActionPerformed("REQREC", "CM");
                                            RefreshGridOnActionPerformed("REQREJ", "CM");
                                        }
                                        if (!isMyScheduleVisibleAdd && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                                            $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                                                onLoadMyCalendar();
                                            });
                                        }

                                        if ($(obj).attr('id') === 'btnCloseActivityForm') {
                                            if ($('#divEngOutReachAddActivity').length > 0) {
                                                $('#btnCloseEngOutreachEditActivityForm').trigger('click');
                                            }
                                            else {
                                                closeEditActivityForm();                                                
                                            }                                            
                                        }
                                        else {
                                            if ($('#divEngOutReachAddActivity').length > 0) {
                                                $('#engOutReachGrid').data("kendoGrid").dataSource.read();
                                            }
                                        }
                                        if (($('#HiddenToDoListTabId').val() != "" || $('#HiddenToDoListTabId').val() != "undefined") && $("#hdnIsClinicalReqActivity").val() == "0") //PROD-6418
                                            $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
                                        if ($("#hdnIsClinicalReqActivity").length > 0 && $("#hdnIsClinicalReqActivity").val() == '1') { //PROD-6418
                                            $('#tabClinicalRequiredActivityList_' + $('#hdnClinicalRequiredActId').val()).trigger('click');
                                        } //PROD-6418
                                        if ($.trim($('#panelTitle,#requestHeaderName').text()) == 'Request Rejected')
                                            $('#btnRequestReceivedSearch').trigger('click');
                                        if ($("#outstandingActivitesGrid").is(':visible')) {
                                            $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
                                        }
                                        if ($("#outstandingExternalActivitesGrid").is(':visible')) {
                                            $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
                                        }
                                        $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                                    }
                                    else {
                                        CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Error');
                                        $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                                    }
                                    scrollToStatusMessage();
                                    //$('#validationMessageActivity').html('').html(data.model.ErrorMessage).css('color', 'red');
                                    loader(0);
                                    //   $('#bulkPatientIdAddActivity').val('');//To Fix  UHG - 504
                                },
                                error: function () {
                                    loader(0);
                                    $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                                }
                            });
                        }
                        else { loader(0); $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled'); }
                    } else {
                        CustomAlert(data.Result);
                        loader(0);
                        $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                    }
                }
                else {
                    $.ajax({
                        type: "POST",
                        url: AddActUrl,
                        data: datastring,
                        dataType: "json",
                        asyns: false,
                        success: function (data) {
                            if (data.success && data.success == true) {
                                var ficoObject = { eventSource: ficoEventSource, parentConrolId: "", moduleName: "CM", eventType: "POST", cmActivityInfo: ficoCmActivity, isAsync: true };
                                var response = ficoRealTimeValidation(ficoObject);
                                CheckValidationMessages(response);
                                if ($(obj).text() === 'Add') {
                                    ClearAddActivity();
                                    // Re-apply program/clinical program context
                                    if (typeof applyProgramActivityContext === 'function') {
                                        applyProgramActivityContext();
                                    }
                                }
                                    CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Success');
                                //$('#validationMessageActivity').show().html('').html(data.model.ErrorMessage).css('color', 'green');
                                if (isMyScheduleVisibleAdd) {
                                    var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                                    if (currentView == "Week") {
                                        $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                                        loadGlobalMySchedule();
                                    }
                                    else {
                                        $("#scheduler").data("kendoScheduler").dataSource.read();//PROD-1103
                                    }
                                }
                                if (!isMyScheduleVisibleAdd && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103 
                                    $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                                        onLoadMyCalendar();
                                    });
                                }

                                if (isMAL) {
                                    RefreshGridOnActionPerformed("TCAL", "CM");
                                    RefreshGridOnActionPerformed("REQREC", "CM");
                                    RefreshGridOnActionPerformed("REQREJ", "CM");
                                }
                                if ($(obj).attr('id') === 'btnCloseActivityForm') {
                                    closeEditActivityForm();                                                                    
                                }
                                if (($('#HiddenToDoListTabId').val() != "" || $('#HiddenToDoListTabId').val() != "undefined") && $("#hdnIsClinicalReqActivity").val() == "0") //PROD-6418
                                    $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
                                if ($("#hdnIsClinicalReqActivity").length > 0 && $("#hdnIsClinicalReqActivity").val() == '1') { //PROD-6418
                                    $('#tabClinicalRequiredActivityList_' + $('#hdnClinicalRequiredActId').val()).trigger('click');
                                } //PROD-6418
                                if ($.trim($('#panelTitle,#requestHeaderName').text()) == 'Request Rejected')
                                    $('#btnRequestReceivedSearch').trigger('click');
                                if ($("#outstandingActivitesGrid").is(':visible')) {
                                    $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
                                }
                                if ($("#outstandingExternalActivitesGrid").is(':visible')) {
                                    $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
                                }
                                $('#hdnIsReSchedueled').val('');
                                $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                            }
                            else {
                                CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Error');
                                $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                            }
                            scrollToStatusMessage();
                            //$('#validationMessageActivity').html('').html(data.model.ErrorMessage).css('color', 'red');
                            loader(0);
                            // $('#bulkPatientIdAddActivity').val('');//To Fix  UHG - 504
                        },
                        error: function () {
                            loader(0);
                            $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                        }
                    });
                }
            },
            error: function (x, y) {
                loader(0);
                $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
            }
        });
    }
    else {
        $.ajax({
            type: "POST",
            url: AddActUrl,
            data: datastring,
            dataType: "json",
            asyns: false,
            success: function (data) {
                if (data.success && data.success == true) {
                    var ficoObject = { eventSource: ficoEventSource, parentConrolId: "", moduleName: "CM", eventType: "POST", cmActivityInfo: ficoCmActivity, isAsync: true };
                    var response = ficoRealTimeValidation(ficoObject);
                    CheckValidationMessages(response);
                    if ($(obj).text() === 'Add') {
                        ClearAddActivity();
                        // Re-apply program/clinical program context
                        if (typeof applyProgramActivityContext === 'function') {
                            applyProgramActivityContext();
                        }
                    }
                    if ($('#divEngOutReachAddActivity').length > 0) {
                        A11yAlerts.createSuccessAlert('#divEngOutreachMessage', 'Activity has been added to Engagement Outreach History.');
                    }
                    else {
                        CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Success');
                        scrollToStatusMessage();
                    }
                    //$('#validationMessageActivity').show().html('').html(data.model.ErrorMessage).css('color', 'green');
                    if (isMyScheduleVisibleAdd) {
                        var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                        if (currentView == "Week") {
                            $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                            loadGlobalMySchedule();
                        }
                        else {
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                    }
                    if (isMAL) {
                        RefreshGridOnActionPerformed("TCAL", "CM");
                        RefreshGridOnActionPerformed("REQREC", "CM");
                        RefreshGridOnActionPerformed("REQREJ", "CM");
                    }
                    if (!isMyScheduleVisibleAdd && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }
                    if ($(obj).attr('id') === 'btnCloseActivityForm') {
                        if ($('#divEngOutReachAddActivity').length > 0 && $('#activityForm').parent().attr('id') === 'divEngOutReachAddActivity') {
                            $('#btnEngOutreachActivityCancel').trigger('click');
                        }
                        else {
                            closeEditActivityForm();
                        }
                    }
                    else {
                        if ($('#divEngOutReachAddActivity').length > 0) {
                            $('#engOutReachGrid').data("kendoGrid").dataSource.read();
                        }
                    }
                    if ($('#HiddenToDoListTabId').val() != "" || $('#HiddenToDoListTabId').val() != "undefined")
                        $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
                    if ($.trim($('#panelTitle,#requestHeaderName').text()) == 'Request Rejected')
                        $('#btnRequestReceivedSearch').trigger('click');
                    if ($("#outstandingActivitesGrid").is(':visible')) {
                        $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
                    }
                    if ($("#outstandingExternalActivitesGrid").is(':visible')) {
                        $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
                    }
                    $('#hdnIsReSchedueled').val('');
                    $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                }
                else {
                    if ($('#divEngOutReachAddActivity').length > 0) {
                        A11yAlerts.createErrorAlert('#divEngOutreachMessage', data.model.ErrorMessage);
                    }
                    else {
                        CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Error');
                        scrollToStatusMessage();
                    }
                    $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                }
                //$('#validationMessageActivity').html('').html(data.model.ErrorMessage).css('color', 'red');
                loader(0);
                //$('#bulkPatientIdAddActivity').val('');//To Fix  UHG - 504
            },
            error: function () {
                loader(0);
                $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
            }
        });
    }
    //$('#hdnIsReSchedueled').val('');
    //$('#btnSubmitActivityForm').removeAttr('disabled');//uhg-3798
}

function closeEditActivityForm() {
    ClearAddActivity();
    setTimeout(function () {
    $('#hdnCnstRoiAdded').val(1);
    $('#btnCloseEditActivityForm').trigger('click');
    }, 1500);
}

function closeEngagementOutreachActivityScreen(hideActivity) {
    $('#tblMyMembersFilter,#MymembersNewdiv,#titleCPIndex,#btnAdmissionFilter,#divPHMymebersFilters,.widgetIcons').show();
    if (hideActivity) {
        $('#divMyMembersEngOutreachActivity').empty().hide();
    }
    A11yUtil.fixA11yViolationsOnScreenLoad('#panelLeft');
}

function onActChange() {
    if ($(this)[0]._old != '') {
        $("#ddlCareStaffAddActivity").prop('disabled', false);
        $("#divGroupActivity #chkGroupActivity").prop('disabled', false);
    } else {
        $('#divPatientNameField').hide();
        $('#divPatientName').html('');
        $('#activityForm #PatientId').val('');
        $('#ddlCareStaffAddActivity').val('');
        $('#hdnCareStaffAddActivity').val('');
        if ($("#divGroupActivity #chkGroupActivity").prop('checked')) {
            $("#divGroupActivity #chkGroupActivity").trigger('click');
        }
        $("#divGroupActivity #chkGroupActivity").prop('disabled', true);
        $("#ddlCareStaffAddActivity").prop('disabled', true);
    }

}
function ValidationForAddOrEditActivity(obj, IsOutcomeMandatory, isDurationMandatory) {  // NOSONAR Complaining that it is to complex.

    DevUtils.logDebug('ValidationForAddOrEditActivity', 'GCHomeCommonRefs', { obj: obj, IsOutcomeMandatory: IsOutcomeMandatory, isDurationMandatory: isDurationMandatory });

    $('span.validationMessage').remove();   // GCPROD-25699: used by custom fields
    let isValid = true;
    let validScheduleDate = true;

    A11yForms.clearFormFieldValidation();

    if ($.trim($('#bulkPatientIdAddActivity').val()) === "" && $('#PatientName') !== undefined && $('#PatientId').val() === '0') {
        A11yForms.showFormFieldError('PatientName', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }
    if (isPlaceofServiceMandatory === "True" && $('#selectScheduledType').val() === '1' && ($('#ddlActivityPlaceOfService').val() === '-1' || $('#ddlActivityPlaceOfService').val() === "" )) {
        A11yForms.showFormFieldError('ddlActivityPlaceOfService', A11yForms.ERROR_MESSAGES.REQUIRED);
        $('#lblddlActivityPlaceOfService').addClass('ah-label-error');
        isValid = false;
    }

    if ($("#selectActivityType").closest(".k-widget").is(':visible') && ($('#selectActivityType').val() === '-1' || $('#selectActivityType').val() === "")) {
        A11yForms.showFormFieldError('selectActivityType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($("#ddlActTypeCompleted").is(':visible') && ($('#AddActTypeCompletedhdn').val() === "")) {
        A11yForms.showFormFieldError('ddlActTypeCompletedKD', A11yForms.ERROR_MESSAGES.REQUIRED);
        // This label is shared by ddlActTypeCompletedKD and selectActivityType
        $('#lblActType').addClass('ah-label-error');
        isValid = false;
    }

    if ($('#selectContactType option:selected').text() === configuredTelehealthContactType && $('#selectScheduledType').val() === "0" && $("#rdoEAInternal").is(":checked") === true) {
        if (!isMeetingGenerated) {
            A11yForms.showFormFieldError('selectContactType', meetingValidationMsg);
            isValid = false;
        }
    }

    if ($('#selectContactType').val() === '-1' || $('#selectContactType').val() === "") {
        A11yForms.showFormFieldError('selectContactType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    // Scheduled
    if ($('#selectScheduledType').val() === '0' && $('#selectScript') === '-1') {
        A11yForms.showFormFieldError('selectContactType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    isValid &= validatePhoneField();
    isValid &= validateDuration(true, 'FollowupHrs', 'FollowupMins', 'divActivityDuration', 'schedDurationLabel');  // Scheduled Duration
    isValid &= validateScheduledDate();
    isValid &= validateDueDate();
    isValid &= fnValidateCustomFields("divcustomfields");

    // Completed
    if ($("#selectScheduledType").val() === '1') {
        isValid &= fnValidateCustomFields("divOutComeCustomField");
        isValid &= validateDuration(isDurationMandatory, 'ActualFollowupHrs', 'ActualFollowupMins', 'divActualDuration', 'actualDurationLabel');    // Actual Duration
    }

    // Case Conference
    if ($('#selectScheduledType').val() === '2') {
        let careTeam = $('input[id*="AddActCareTeam"]:checked');
        if (careTeam.length <= 0) {
            A11yForms.showFormFieldError('divAddActCareTeam', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    }

    isValid &= validateWorkQueueActivity();
    isValid &= validateRecurringActivity();

    if ($('#chkProgramActivity').is(':checked') && $('#divEditActHierarchy .clsRdoMemEligMini:checked').length === 0 && $('#divEditActHierarchy').css('display') !== 'none') {
        A11yForms.showFormFieldError('MemEligMain_MiniView', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#chkProgramActivity').is(':checked') && $('#ddlPrgmActPrgm.ddlPrgmActPrgmVal').val() === '-1' || $('#ddlPrgmActPrgm.ddlPrgmActPrgmVal').val() === "") {
        A11yForms.showFormFieldError('ddlPrgmActPrgm', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#chkCliProgramActivity').is(':checked') && $('#ddlClinicalProg.cliProgValidation').val() === '-1' || $('#ddlClinicalProg.cliProgValidation').val() === "") {
        A11yForms.showFormFieldError('ddlClinicalProg', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    $("#ActivityOutcomeType .ah-label").removeClass('ah-required');
    $("#ActivityOutcome .ah-label").removeClass('ah-required');
    if ($('#selectScheduledType').val() === '1' && IsOutcomeMandatory) {
        // Completed activity
        isValid &= A11yForms.validateFormField('ddlActivityOutcomeType', null, [A11yForms.VALIDATIONS.REQUIRED]);
        if ($('#ddlActivityOutcomeType').val() == "-1") {
            $("#ActivityOutcomeType .ah-label").addClass('ah-required');
        }
        if ($('#ddlActivityOutcome').val() === '-1' || $('#ddlActivityOutcome').val() === null || $('#ddlActivityOutcome').val() === undefined) {
            $("#ActivityOutcome .ah-label").addClass('ah-required');
            A11yForms.showFormFieldError('ddlActivityOutcome', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    }

    if ($('#divEngOutreachSubType').length === 1 && $('#ddlEngOutReachSubType').is(':visible') && $('#ddlEngOutReachSubType').val() === '-1') {
        A11yForms.showFormFieldError('ddlEngOutReachSubType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    let fupdate = $('#FollowupDate').val();
    let scheduledDate = fupdate.split(' ')[0];
    let duedate = $('#DueDate').val();
    let endDueDateStr1 = duedate.split(' ')[0];
    if (isValid && (new Date(scheduledDate) > new Date(endDueDateStr1))) {
        let popName = (($('#btnSubmitActivityForm').text() === 'Update') ? 'Edit' : 'Add') + ' Activity';
        let activityType = (($('#btnSubmitActivityForm').text() === 'Update') ? 'reschedule' : 'schedule');
        isValid = false;
        validScheduleDate = false;
        insertOverLay('ConfirmPopup_Div', '', '1000010');
        $().ConfirmationBox({ Title: popName, Content: 'Scheduled date is greater than due date. Would you still prefer to ' + activityType + ' this activity?', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }], ButtonAlign: 'center' }, function (CVR) {
            $('#lean_overlay_level_1').remove();
            if (CVR) {
                isValid = true;
                if ($('#selectScheduledType').val() === '1') {
                    AddUpdateActvt(obj);
                } else {
                    CheckAvailability(obj);
                }
            } else {
                isValid = false;
            }
        });
    }

    if (!isValid && validScheduleDate) {
        A11yAlerts.createErrorAlert('#validationMessageActivity');
    } else {
        clearAddOrEditValidation();
    }

    return isValid;
}

function validatePhoneField() {
    let isValid = true;
    $('.cstfield.phone').each(function() {
        if ($(this).val() !== "" && !$(this).val().match(PhoneandFaxformat)) {
            let phoneField = 'txtLabelPhone_' + $(this).data('id');
            A11yForms.showFormFieldError(phoneField, A11yForms.ERROR_MESSAGES.VALID_PHONE);
            isValid = false;
        }
    });
    return isValid;
}

function validateDuration(isMandatory, durHrsId, durMinsId, parentDiv, labelId) {
    DevUtils.logDebug('validateDuration', 'GCHomeCommonRefs', { isMandatory: isMandatory, durHrsId: durHrsId, durMinsId: durMinsId, parentDiv: parentDiv, labelId: labelId });

    let durHrsVal = $('#' + durHrsId).val().trim();
    let durMinsVal = $('#' + durMinsId).val().trim();
    let isValid = true;

    $("#actualDurationLabel").removeClass('ah-required');
    if (isMandatory && (durHrsVal === "" || durMinsVal === "")) {
        if (durHrsVal === "") {
            $("#actualDurationLabel").addClass('ah-required');
            A11yForms.showFormFieldError(durHrsId, A11yForms.ERROR_MESSAGES.REQUIRED, parentDiv);
        }
        if (durMinsVal === "") {
            $("#actualDurationLabel").addClass('ah-required');
            A11yForms.showFormFieldError(durMinsId, A11yForms.ERROR_MESSAGES.REQUIRED, parentDiv);
        }
        isValid = false;
    }

    if (parseInt(durHrsVal) > 23) {
        A11yForms.showFormFieldError(durHrsId, 'Enter maximum 23 Hrs.', parentDiv);
        isValid = false;
    }

    if (parseInt(durMinsVal) > 59) {
        A11yForms.showFormFieldError(durMinsId, 'Enter maximum 59 Mins.', parentDiv);
        isValid = false;
    }

    if (!isValid) {
        $('#' + labelId).addClass('ah-label-error');
    }

    return isValid;
}

function validateScheduledDate() {

    if (!A11yForms.validateFormField('FollowupDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATETIME])) {
        return false;
    }

    let fupdate = $('#FollowupDate').val();
    let endDateStr1 = fupdate.split(' ')[0];
    let endDate1 = new Date(endDateStr1);
    let endYear1 = endDate1.getFullYear();
    let d1 = new Date();
    let n1 = d1.getFullYear();
    let endYear110 = n1 + 10;

    if (endYear1 > endYear110) {
        endYear110 += 1;
        A11yForms.showFormFieldError('FollowupDate', 'Scheduled Date should be less than year ' + endYear110);
        return false;
    }

    if ($('#selectScheduledType').val() !== "1") {
        // NOT a Completed activity
        let hdnFollowupDate = currentFollowupdate.split(' ')[0];
        if (new Date(hdnFollowupDate) > new Date(endDateStr1)) {
            A11yForms.showFormFieldError('FollowupDate', "Scheduled date should not be less than today's date.");
            return false;
        }
    }

    return true;
}

function validateDueDate() { // NOSONAR Complaining that it is to complex.
    if ($.trim($('#DueDate').val()) === "") {
        return true;
    }

    if (!A11yForms.validateFormField('DueDate', null, [A11yForms.VALIDATIONS.DATETIME])) {
        return false;
    }

    let duedate = $('#DueDate').val();
    let endDueDateStr1 = duedate.split(' ')[0];
    let endDueDate1 = new Date(endDueDateStr1);
    let endDueYear1 = endDueDate1.getFullYear();
    let d1 = new Date();
    let n1 = d1.getFullYear();
    let endYear110 = n1 + 10;
    let ProgramWorkflowId = $("#hdnProgramWorkflowId").val() !== '0' ? true : false;
    let ClinicalRequiredWorkflowId = $("#hdnClinicalRequiredWorkflowId").val() !== null && $("#hdnClinicalRequiredWorkflowId").val() !== '' ? true : false;

    if (endDueYear1 > endYear110) {
        endYear110 += 1;
        A11yForms.showFormFieldError('DueDate', 'Due Date should be less than year ' + endYear110);
        return false;
    }

    let fupdate = $('#FollowupDate').val();
    endDateStr1 = fupdate.split(' ')[0];

    let dueDateTime = new Date(duedate);
    let schDateTime = new Date(fupdate);

    if ($('#selectScheduledType').val() !== "1") {
        // NOT a Completed activity
        let followupDate = currentFollowupdate;
        let Flag = $('#DueDate').is(":disabled");

        if (!ProgramWorkflowId && !ClinicalRequiredWorkflowId && duedate === fupdate && !Flag) {
            A11yForms.showFormFieldError('DueDate', "Due date cannot be same as scheduled date.");
            return false;
        }
        if (!ProgramWorkflowId && !ClinicalRequiredWorkflowId && schDateTime > dueDateTime && !Flag) {
            A11yForms.showFormFieldError('DueDate', "Due date cannot be less than scheduled date.");
            return false;
        }
        if (!ProgramWorkflowId && !ClinicalRequiredWorkflowId && Date.parse(followupDate) > Date.parse(duedate) && !Flag) {
            A11yForms.showFormFieldError('DueDate', "Due date should not be less than today's date.");
            return false;
        }
    }

    return true;
}

function validateWorkQueueActivity() { // NOSONAR Complaining that it is to complex.
    if ($('#chkGroupActivity').is(':checked')) {
        // Work Queue Activity is checked
        let isValid = true;

        let workQueueIds = $('#ddlDepartmentIdhdn').val();
        DevUtils.logDebug('validateWorkQueueActivity', 'GCHomeCommonRefs', { workQueueIds: workQueueIds });
        if (workQueueIds === "") {
            A11yForms.showFormFieldError('ddlDepartment', A11yForms.ERROR_MESSAGES.REQUIRED);
            $('#ddlMsDepartment_label').addClass('ah-label-error');
            isValid = false;
        }

        let StaffIds = $('#ddlStaffIdsIdhdn').val();
        if (StaffIds === "") {
            A11yForms.showFormFieldError('ddlStaffIds', A11yForms.ERROR_MESSAGES.REQUIRED);
            $('#ddlStaffIds_label').addClass('ah-label-error');
            isValid = false;
        }

        return isValid;
    }

    // Work Queue Activity is not checked
    if (!$("#AddActFor").is(":visible") && $('#selectScheduledType').val() !== "2" && ($('#ddlCareStaffAddActivity').val().length <= 3 || $('#hdnCareStaffAddActivity').val() === "")) {
        // The 'Add Activity For' radio buttons are NOT displayed.
        // The 'Type' is not Case Conference
        // The 'Care Staff' isn't specified
        A11yForms.showFormFieldError('ddlCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED, 'divCareStaff');
        return false;
    }

    if (!$(".EACareStaffType").is(":visible")) {
        // The 'Add Activity For' radio buttons are NOT displayed.
        return true;
    }

    // The 'Add Activity For' radio buttons ARE displayed.
    if ($('#selectScheduledType').val() !== "2" && $(".EACareStaffType:checked").val() === "INTER" && ($('#ddlCareStaffAddActivity').val().length <= 3 || $('#hdnCareStaffAddActivity').val() === "")) {
        // The 'Type' is not Case Conference
        // Care Staff radio button is checked
        // The 'Care Staff' isn't specified
        A11yForms.showFormFieldError('ddlCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED, 'divCareStaff');
        return false;
    }

    if ($(".EACareStaffType:checked").val() === "EXTERNAL" && $("#ddlExCareStaff").val() === '-1') {
        // External Care Team radio button is checked
        // The 'External Care Team' isn't specified
        A11yForms.showFormFieldError('ddlExCareStaff', A11yForms.ERROR_MESSAGES.REQUIRED);
        return false;
    }
    if ($(".EACareStaffType:checked").val() === "PHARMACIST" && ($('#hdnPharmacyCareStaffAddActivity').val() === "" || $('#ddlPharmacyCareStaffAddActivity').val() === "")) {
        // Pharmacists radio button is checked
        // The 'Pharmacists' isn't specified
        A11yForms.showFormFieldError('ddlPharmacyCareStaffAddActivity', A11yForms.ERROR_MESSAGES.REQUIRED, 'dvPharmacyCareStaff');
        return false;
    }

    return true;
}

function validateRecurringActivity() {
    if (!$('#chkIsRecurringActivity').is(':checked')) {
        // Recurring Activity is not checked
        return true;
    }

    // Recurring Activity is checked
    let endAfter = $("input[id='RecurrenceValues_EndAfterType']:checked").val();
    switch (endAfter) {
        case "1":	// End After N occurrences
            return validateEndAfterOccurrences();

        case "2":	// End After Date
            return validateEndAfterDate();

        default:
            break;
    }

    return true;

}

function validateEndAfterOccurrences() {

    if (!A11yForms.validateFormField('RecurrenceValues_EndAfterNoOfOccurrences', null, [A11yForms.VALIDATIONS.REQUIRED])) {
        return false;
    }

    let numberOfOccurence = Number($('#RecurrenceValues_EndAfterNoOfOccurrences').val().trim());
    if (isNaN(numberOfOccurence)) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterNoOfOccurrences', 'Enter numbers');
        return false;
    }

    if ($('li.k-state-active').text().trim() === "Yearly" && numberOfOccurence > 1) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterNoOfOccurrences', 'Occurrences must be 1 for Yearly');
        return false;
    }
    if (numberOfOccurence > 12) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterNoOfOccurrences', 'Occurrences should be less than or equal to 12');
        return false;
    }

    return true;
}

function validateEndAfterDate() {
    if (!A11yForms.validateFormField('RecurrenceValues_EndAfterDate', null, [A11yForms.VALIDATIONS.REQUIRED])) {
        return false;
    }

    let fupdate = $('#FollowupDate').val();
    let endDateStr1 = fupdate.split(' ')[0];
    let endDate1 = new Date(endDateStr1);
    endDate1.setUTCHours(0, 0, 0, 0);

    let endDateStr = $('#RecurrenceValues_EndAfterDate').val();
    let endDate = new Date(`${endDateStr} UTC`);
    endDate.setUTCHours(0, 0, 0, 0);
    let d = new Date();
    d.setUTCHours(0, 0, 0, 0);
    let curDate = new Date();
    curDate.setUTCHours(0, 0, 0, 0);
    let endDatefromcurrdd = new Date(curDate.getFullYear() + 1, curDate.getMonth(), (curDate.getDate() - 1));

    if (!date_regex.test(endDateStr)) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterDate', A11yForms.ERROR_MESSAGES.VALID_DATE);
        return false;
    }

    if (endDate > endDatefromcurrdd) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterDate', 'End Date must be within one year of current date');
        return false;
    }

    if (endDate < d) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterDate', 'End Date cannot be prior to current date');
        return false;
    }

    if (endDate < endDate1) {
        A11yForms.showFormFieldError('RecurrenceValues_EndAfterDate', 'End Date cannot be less than scheduled date');
        return false;
    }

    if ($('div#activityForm li.tabselected.k-state-active').text().trim() === "Daily") {
        let maxNoOfRecurrences = 99; // max number of occurrences
        let requiredDate = new Date(curDate.getFullYear(), curDate.getMonth(), (curDate.getDate() + maxNoOfRecurrences));
        if (endDate > requiredDate) {
            A11yForms.showFormFieldError('RecurrenceValues_EndAfterDate', 'Number of occurrences cannot exceed 99. Please choose a different date.');
            return false;
        }
    }

    return true;
}

function clearAddOrEditValidation() {
    A11yForms.clearFormFieldValidation();
    A11yAlerts.remove('validationMessageActivity');
}

function openActivityPopup(ProgramWorkflowId, PatientFollowupId, patientId, clsId, reqActDueDate, careActivityType, MemClinicalProgId) {
    var CareActivityTypeId = ToValue(careActivityType, '') !== '' ? careActivityType : $("#imgAddActivity_" + ProgramWorkflowId).data('careactivitytypeid');
    var ScriptId = $("#imgAddActivity_" + ProgramWorkflowId).data('scriptid');
    var ActivityStatus = $("#imgAddActivity_" + ProgramWorkflowId).data('activitystatus');
    var ScriptStatus = $("#imgAddActivity_" + ProgramWorkflowId).data('scriptstatus');
    var groupId = $("#imgAddActivity_" + ProgramWorkflowId).data('groupId');
    var RefferToStaffId = $("#imgAddActivity_" + ProgramWorkflowId).data('reffertostaffid');
    var ReferrerToStaffName = $("#imgAddActivity_" + ProgramWorkflowId).data('reffertostaffname');
    var memBenfProgramId = $("#imgAddActivity_" + ProgramWorkflowId).data('membenfprogid') === undefined ? 0 : $("#imgAddActivity_" + ProgramWorkflowId).data('membenfprogid');
    var dataRootName = $("#imgAddActivity_" + ProgramWorkflowId).data('datarootname') === undefined ? "" : $("#imgAddActivity_" + ProgramWorkflowId).data('datarootname');
    var lobBenId = $("#GridToDoList").is(":visible") ? $('#HiddenToDoListTabId').val() : 0;
    var memLobBenId = $("#imgAddActivity_" + ProgramWorkflowId).data('memlobbenid');
    var url = ''; //PROD-6418
    if ($("#hdnIsClinicalReqActivity").length > 0 && $("#hdnIsClinicalReqActivity").val() == '1')
        url = baseURL + "/Home/EditActivity?patientId=" + patientId + "&ClinicalRequiredWorkflowId=" + ProgramWorkflowId + "&ActivityTypeId=" + CareActivityTypeId + "&ScriptId=" + ScriptId + "&isToDoList=" + true + "&ActId=" + PatientFollowupId + "&isProvider=" + isProvider + "&lobBenId=" + lobBenId + "&programId=" + memBenfProgramId + "&dataRootName=" + dataRootName + "&memClinicalProgId=" + MemClinicalProgId;
    else {
        url = baseURL + "/Home/EditActivity?patientId=" + patientId + "&WorkflowId=" + ProgramWorkflowId + "&ActivityTypeId=" + CareActivityTypeId + "&ScriptId=" + ScriptId + "&isToDoList=" + true + "&ActId=" + PatientFollowupId + "&isProvider=" + isProvider + "&lobBenId=" + lobBenId + "&programId=" + memBenfProgramId + "&dataRootName=" + dataRootName + "&memLobBenId=" + memLobBenId;
    }
    //PROD-6418
    $('#popUpDialog2').CMNPopup({
        pvUrl: url, //PROD-6418
        onLoad: function () {
            //disabling Type while scheduling required activity, also in Edit Activity
            $('#selectScheduledType').attr('disabled', 'disabled');
            if (reqActDueDate != null) {
                $('#DueDate').val(reqActDueDate);
            }
            $('#divDueDate #DueDate').attr('disabled', 'disabled');
            $('#btnCheckActivityDueDate').hide();
            onLoadEditActivity();
            $('#loaderImg').hide();
            if (ReferrerToStaffName != undefined && ReferrerToStaffName != null && ReferrerToStaffName != "") {
                $('#ddlCareStaffAddActivity').val(unescapeHtml(ReferrerToStaffName));
                $('#hdnCareStaffAddActivity').val(RefferToStaffId);
            }
            var dropdownlist = $("#selectActivityType").data("kendoDropDownList");
            if (dropdownlist != undefined)
                dropdownlist.enable(false);
            if (groupId && groupId > 0) {
                $('#selectScheduledType').val(2);
                $("#divIdAddActCareTeam").show();
                $('#divIdCareStaff').hide();
                $('.scheduledType').hide();
            }

            $("#rdoEAExternal").attr("disabled", true);
            $('#AddActFor').hide();
            $('#selectScript').hide();
            var scriptName = $("#hdnStaticScriptName").val() == "" ? "N/A" : $("#hdnStaticScriptName").val();
            $('#divScript #lblAAScriptName').text(scriptName).show();
        },
        onClose: function () {
            ClearActivityHdnCntrls();
            if ($('#hdnIsFromToDolist').length > 0) {
                $('#hdnIsFromToDolist').val('');
            }
            $("#rdoEAExternal").attr("disabled", false);
            $('#AddActFor').show();
            $('#popUpDialog2').html('');
        },
        popUpHeader: clsId == 'add_icon' ? "Add Activity" : "Edit Activity",
        popLevel: ($('#popUpDialog1').is(':visible')) ? 2 : 1,
        closeButton: "#btnCloseEditActivityForm",
        modalWidth: MODAL_WIDTH.MEDIUM
    });
}
function groupTable($rows, startIndex, total) {
    if (total == 0) {
        return;
    }
    var i, currentIndex = startIndex, count = 1, lst = [];
    var tds = $rows.find('td:eq(' + currentIndex + ')');
    var ctrl = $(tds[0]);
    lst.push($rows[0]);
    for (i = 1; i <= tds.length; i++) {
        if (ctrl.text() == $(tds[i]).text()) {
            count++;
            $(tds[i]).addClass('deleted');
            lst.push($rows[i]);
        }
        else {
            if (count > 1) {
                ctrl.attr('rowspan', count);
                groupTable($(lst), startIndex + 1, total - 1)
            }
            count = 1;
            lst = [];
            ctrl = $(tds[i]);
            lst.push($rows[i]);
        }
    }
}
function PharmacistCntrls() {
    if ($(".EACareStaffType:checked").val() === 'PHARMACIST') {
        ShowHidePharmacistFields();
    }
}
function ShowHideCareStaffToMTM() {
    if ($(".EACareStaffType:checked").val() === 'PHARMACIST') {
        $('#divIdCareStaff').hide();
        $('#divIdExCareStaff').hide();
        $('#divIdCareStaff').hide();
        $('#divIdExCareStaff').hide();

    }
}
function ClearActivityHdnCntrls() {
    if ($("#hdnCareStaffAddActivity").length > 0) {
        $("#hdnCareStaffAddActivity").val('');
    }
    if ($("#hdnPharmacyCareStaffAddActivity").length > 0) {
        $("#hdnPharmacyCareStaffAddActivity").val('');
    }
}
function LoadMemberDtl() {
    $('#selectMymbembersteam,#divFilterCntrls').show();
    $('#DivOpenAuthorization').hide();
    $('#MyMemberHeaderName').html('').html('My Members');
    DBMemberDetailsLoad(1, "blockOne");
    $('#btnMemexpndClick').show();
    if (isPHval === "True" && iscmval === "False" && isumval === "False" && isagval==="False") {
        $('#MymemCareDropList').hide();
    }
    else {
        $('#MymemCareDropList').show();
    }
    $('#divMemActiveInactive').show();
    $('#divCareStaffRiskFilter').show();
}

function SetArrowsMembers() {
    var itemname = $('#MyMemberHeaderName').html();

    //if (((iscmval == 'True' && isumval == 'False' && isagval == 'False') || (iscmval == 'False' && isumval == 'False' && isagval == 'True') || (iscmval == 'False' && isumval == 'True' && isagval == 'False')) && (rolenameval != isphysicianrole)) {
    //    SetArrowdisplay('rightarrowMyMembers', 'leftarrowMyMembers', 0);
    //}
    //else { SetArrowdisplay('rightarrowMyMembers', 'leftarrowMyMembers', 3); }

    if (iscmval == 'True' && isumval == 'False' && isagval == 'False') {
        SetArrowdisplay('rightarrowMyMembers', 'leftarrowMyMembers', 0);
    }
    else {
        SetArrowdisplay('rightarrowMyMembers', 'leftarrowMyMembers', 3);
    }
}
function ShowHoverMenu(tableid, menuid, ctrlid) {
    var pos = $('#' + ctrlid).offset();
    $('#' + menuid).hide();
    var chkboxes = $('#' + tableid).find('input[type="checkbox"]:checked');
    if (chkboxes.length === 1) {
        pos = $(chkboxes[0]).offset();
        var menheight = $('#' + menuid).height();
        var tabheight = $('#' + tableid).height();
        var tabtop = $('#' + tableid).offset().top;
        var mentop = pos.top;
        if ((mentop + menheight) > (tabtop + tabheight)) {
            mentop = ((mentop + 10) - menheight);
        }
        mentop -= $(window).scrollTop();
        $('#' + menuid).show().css('left', (pos.left + 15) + "px").css('top', mentop + "px");
    }
    else {
        $('#' + menuid).hide();
    }
}
function SetArrowdisplay(RightArrow, leftArrow, setval) {
    if (setval == 0) {
        $('#' + RightArrow).attr("disabled", true);
        $('#' + leftArrow).attr("disabled", true);
        $('#' + RightArrow).attr('class', 'Next_disable');
        $('#' + leftArrow).attr('class', 'Previous_disable');
    }
    else if (setval == 1) {
        $('#' + RightArrow).attr("disabled", false);
        $('#' + leftArrow).attr("disabled", true);
        $('#' + RightArrow).attr('class', 'Next');
        $('#' + leftArrow).attr('class', 'Previous_disable');
    }
    else if (setval == 2) {
        $('#' + RightArrow).attr("disabled", true);
        $('#' + leftArrow).attr("disabled", false);
        $('#' + RightArrow).attr('class', 'Next_disable');
        $('#' + leftArrow).attr('class', 'Previous');
    }
    else if (setval == 3) {
        $('#' + RightArrow).attr("disabled", false);
        $('#' + leftArrow).attr("disabled", false);
        $('#' + RightArrow).attr('class', 'Next');
        $('#' + leftArrow).attr('class', 'Previous');
    }
}
function CaseConfPerformActivity() {
    $(document).off('click', '#btnCaseConfComplete').on('click', '#btnCaseConfComplete', function () {
        $listchkbox = $('.clsCaseConfComplete');
        var listCareTeamId = "";
        var caseConferencedatastring = "";
        var comments = $('#CaseConfCompleteNotes').val();
        var groupid = $('#hdnCaseConfCompGroupId').val();
        var actId = $('#hdnActivityId').val();
        var caseConfNotes = $('#CaseConfOutcomeNotes').val();
        var caseConfOutComeId = $('#selectCaseConfActivityOutcome').val();
        var caseConfHCPCCode = $('#selectHCPCCode').val();
        var actualHrs = parseInt($('#tdActualFollowupHrs').val());
        var actualMins = parseInt($('#tdActualFollowupMins').val());
        var actualDuration = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
        var placeOfServiceid = $('#selectCaseConfActivityPlaceOfService').val();
        var selectedEmails = "";
        $.each($listchkbox, function (key, item) {
            if ($(item).is(':checked')) {
                listCareTeamId += $(item).attr('Id').split('_')[1] + "|";
                if (!$(item).data('isduplicate'))
                    selectedEmails += $(item).data('emailid') + "|";
            }
        });
        $('#hdnCaseConfMemIdAndCareTeamId').val(listCareTeamId);
        $('#hdnCaseConfCompDescription').val(comments);
        $('#hdnCaseConfEmailsSelected').val(selectedEmails);
        var patientId = $('#hdnCaseConfPerformPatientId').val();
        var description = $('#hdnCaseConfCompDescription').val();
        var isMyScheCCVisible = $("#popUpGlobalMySchedule").is(':visible');
        if (ValidationCaseConferenceActivity()) {
            var activityOutCome = $('#selectCaseConfActivityOutcome option:selected').text();
            var outcometype = $('#selectCaseConfActivityOutcomeType option:selected').text();
            var Islocknote = $('#CaseConfCompleteNotes:visible').length > 0 ? true : false;
            var Noteconfidential = $('input[name=rdoAHNIsCaseConfidential]:checked').val();
            var OutNoteconfidential = $.fn.isNullOrEmpty($('#AOIsConfidential').val()) ? 0 : $('input[name=rdoAOIsConfidential]:checked').val();
            //To Allow '#' in Notes
            caseConferencedatastring = {
                groupId: groupid, completeNotes: comments, listCareTeamId: listCareTeamId, caseConfOutComeId: caseConfOutComeId, caseConfNotes: caseConfNotes, actualDuration: actualDuration, placeOfServiceId: placeOfServiceid, HCPCCodeId: caseConfHCPCCode, IsLockNote: Islocknote, NoteConfidentialTypeId: Noteconfidential, OutcomeNoteConfidentialTypeId: OutNoteconfidential, patientId: patientId
            };

            $.ajax({
                type: "POST",
                url: baseURL + "/Home/CaseConfCompleteActivity",
                data: caseConferencedatastring,
                async: false,
                dataType: "json",
                success: function (data) {
                    $("#id1frame").contents().find('.UpdatePanelProgress').find("#imgbtnSearch").trigger('click');
                    $('#btnCaseConfPopupClose').trigger('click');
                    if (!isMyScheCCVisible && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }//PROD-1103
                    if (isMyScheCCVisible) {
                        var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                        if (currentView == "Week") {
                            $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                            loadGlobalMySchedule();
                        }
                        else {
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                    }//PROD-1103
                    if ($('#hdnIsFrmPendingActivities').val() == "1") {
                        LoadPendingActivityGrid();
                        $('#hdnIsFrmPendingActivities').val("");
                    }
                    else if ($('#CMPendingActivitiesGrid').is(':visible')) {
                        LoadWorkLogMgrCmActivities();
                    }
                    $('#btnCaseConfPopupClose').trigger('click');
                    if (outcometype.trim() == "Unsuccessful") {
                        if (CustomConfirm('Do you want reschedule the activity ?')) {
                            $('#popUpDialog1').CMNPopup({
                                pvUrl: baseURL + "/Home/EditActivity?ActId=" + actId + "&isFromReschedule=" + true,
                                onLoad: function () {
                                    $('#selectScheduledType').val(2);
                                    onLoadEditActivity();
                                    $('#hdnIsReSchedueled').val('1');
                                    $("#divIdAddActCareTeam").show();
                                    $('#divIdCareStaff').hide();
                                    $('.scheduledType').hide();
                                    $('#btnSubmitActivityForm').hide();
                                    $('#btnCloseActivityForm').text('Add and Close').removeClass('ah-btn-secondary').addClass('ah-btn-primary');
                                    if ($("#rdoEAExternal").is(":visible")) {
                                        $("#rdoEAExternal").attr("disabled", true);
                                    }
                                    A11yModal.trapFocusInModal('popUpDialog1');
                                },
                                onClose: function () {
                                    // if (isCompletePendingActivity) { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                                    if ($('#hdnIsFrmPendingActivities').val() == "1") {
                                        LoadPendingActivityGrid();
                                        $('#hdnIsFrmPendingActivities').val("");
                                    }
                                    else if ($('#CMPendingActivitiesGrid').is(':visible')) {
                                        LoadWorkLogMgrCmActivities();
                                    }
                                    if ($('#hdnIsReSchedueled').length > 0) { $('#hdnIsReSchedueled').val(0); }
                                    ClearActivityHdnCntrls();
                                },
                                popUpHeader: "Reschedule Activity",
                                popLevel: 0,
                                closeButton: "#btnCloseEditActivityForm",
                                modalWidth: MODAL_WIDTH.MEDIUM

                            });
                        }
                        else {
                            // if (isCompletePendingActivity) { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                            if ($('#hdnIsFrmPendingActivities').val() == "1") {
                                LoadPendingActivityGrid();
                                $('#hdnIsFrmPendingActivities').val("");
                            }
                            else if ($('#CMPendingActivitiesGrid').is(':visible')) {
                                LoadWorkLogMgrCmActivities();
                            }
                        }
                    }
                    else {
                        var flag = CustomConfirm('Are you sure you want to send the emails to the participants?');
                        if (flag) {
                            if ($('#popUpGlobalMySchedule').is(':visible')) { $('#popUpGlobalMySchedule,#lean_overlay_-1').hide(); }
                            if (IsSmartCommEnabled === "1") {
                                LoadDraftLetterCaseConf(patientId, groupid);
                            }
                            else {
                                OpenConference_Init(patientId, groupid);
                            }
                        }
                    }

                    if ($('#CMPendingActivitiesGrid').is(':visible')) {
                        LoadWorkLogMgrCmActivities();
                    }
                    if ($("#outstandingActivitesGrid").is(':visible')) {
                        $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
                    }
                    if ($("#outstandingExternalActivitesGrid").is(':visible')) {
                        $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
                    }

                }
            });

            RefreshGridOnActionPerformed("TCAL", "CM");
        }
        $('#hdnIsReSchedueled').val('');
    });
}

function ValidationCaseConferenceActivity() {
    var msgcount = 0;
    var listCareTeamId = "";
    $('span.validationMessage').remove();
    $listchkbox = $('.clsCaseConfComplete');
    $.each($listchkbox, function (key, item) {
        if ($(item).is(':checked')) {
            listCareTeamId += $(item).attr('Id').split('_')[1] + "|";
        }
    });
    if (listCareTeamId == '' || listCareTeamId.length < 1) {
        $('#tdParticipants').append('<span class="validationMessage" style="color:red">*</span>');
        msgcount = 1;
    }
    if (parseInt($.trim($('#tdActualFollowupHrs').val())) > 23) {
        $('#tdActivityOutComeDuration').append('<span class="validationMessage" style="color:red">Enter maximum 23 Hrs. </span>');
        // return false;
        msgcount = 1;
    }
    if (parseInt($.trim($('#tdActualFollowupMins').val())) > 59) {
        $('#tdActivityOutComeDuration').append('<span class="validationMessage" style="color:red">Enter valid Mins</span>');
        // return false;
        msgcount = 1;
    }
    //GFID-231
    if (IsActivityOutcomeMandatory === false) {
        if ($('#selectCaseConfActivityOutcomeType').val() == -1) {
            $('#tdActivityOutComeType').append('<span class="validationMessage" style="color:red">*</span>');
            msgcount = 1;
        }
        if ($('#selectCaseConfActivityOutcome').val() == -1) {
            $('#tdActivityOutCome').append('<span class="validationMessage" style="color:red">*</span>');
            // return false;
            msgcount = 1;
        }
    }

    if (IsActualDurationMandatory == true) {
        if ($('#tdActualFollowupHrs').val() == "" && $('#tdActualFollowupMins').val() == "") {
            $('#tdActivityOutComeDuration').append('<span class="validationMessage" style="color:red">*</span>');
            msgcount = 1;
        }
    }

    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}

function RejectMSActivityFrmActivityLog(referenceId, referedby, referedto) {

    $('#divRequestRejectCommentsPopup').CMNPopup({ popUpHeader: "Reason for Rejection", closeButton: '#btnCloseRequestRejectComments' });
    $('#divRequestRejectCommentsPopup textarea').val('');
    $('#divRequestRejectCommentsPopup #divReqRjctIsConfidential').hide();
    $('#trIsConfidential').hide();
    requestReferTypeGlobal = "MS Activity";
    $('#hdnSendRequestRejectCommentsRejectionId').val(referenceId);
    $('#spnRequestRejectCommentsRequestFrom').text(referedby);
    $('#spnRequestRejectCommentsCareMember').text(referedto);
}


function PrepareAcceptMSActivityGrid(listReferenceId) {
    var html = "";
    $.ajax({
        type: "GET",
        url: baseURL + "/Home/GetMSActivity?listReferenceId=" + listReferenceId,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">' + GetHtmlDecode(GetHtmlDecode(altruistaIDLabelValue)) + '</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Priority</th><th scope="col" style="width:215px">Follow up Date</th><th align="left" scope="col">Script Name</th><th align="left" scope="col">Notes</th><th align="left" scope="col">Contact Type</th></tr>';
                $.each(data.activityList, function (key, item) {
                    $('#hdnMSRequestReceivedAcceptCrmQueueIds').val(item.CrmQueueId);
                    var prior = item.Priority && item.Priority != 'null' ? item.Priority : 'N/A';
                    var Comments = item.Comments && item.Comments !== 'null' ? unescapeHtml(item.Comments) : 'N/A';
                    var Venue = item.Venue && item.Venue != 'null' ? item.Venue : 'N/A';
                    var ScriptName = item.ScriptName && item.ScriptName != 'null' ? item.ScriptName : 'N/A';
                    var strCheck = '<input type="button" style="float:right;margin-right:-5px; margin-top:-2px;" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                    html += '<tr><td>' + $.fn.replaceAndEscapeHtmlExt(item.PatientFullName) + '</td><td>' + item.AltruistaId + '</td><td>' + escapeHtml(item.CareActivityTypeName) + '</td><td>' + prior + '</td><td style="width:185px;">';
                    html += '<input type="text" data-PatientId="' + item.PatientId + '"  class="MSAcceptCommentsFolloUpdate" id="txtMSAcceptCommentsFolloUpdate_' + key + '" value="' + item.FollowupDateString + '"/>' + strCheck + '</td><td>' + ScriptName + '</td><td>' + escapeHtml(Comments) + '</td><td>' + Venue + '</td></tr>';
                });
                html += '</table>';
                $('#tdTableForMSActivities').html('').AhsAppend(html);
                $('.MSAcceptCommentsFolloUpdate').kendoDateTimePicker({ format: getDateFormat(), timeFormat: getTimeFormat(), interval: 30, value: new Date($('.MSAcceptCommentsFolloUpdate').val()) });
            }
        }
    });
}

function PrepareAcceptUMActivityGrid(listReferenceId) {
    var html = "";
    $('#tdTableForUMActivities').html('');
    $.ajax({
        type: "GET",
        url: baseURL + '/Dashboard/GetUMActivity',
        dataType: "json",
        data: {
            listReferenceId: listReferenceId,
            TimeDictionaryobj: timeZone
        },
        success: function (data) {
            if (data.success) {
                html += '<table class="DBGrid accept_comment_popup_grid width100P">';
                html += '<tr><th align="left" scope="col">Member Name</th>';
                html += '<th align="left" scope="col">Auth ID</th>';
                html += '<th align="left" scope="col">Auth Type</th>';
                html += '<th align="left" scope="col">Activity Type</th>';
                html += '<th align="left" scope="col">Activity Priority</th>';
                html += '<th scope="col" class="Tb215Px">Follow up Date</th>';
                html += '<th align="left" scope="col">Due Date</th>';
                html += '<th align="left" scope="col">Referral Notes</th></tr>';
                $.each(data.activityList, function (key, item) {
                    var prior = item.ActivityPriority && item.ActivityPriority != 'null' ? item.ActivityPriority : 'N/A';
                    var Comments = item.ReferralNotes && item.ReferralNotes !== 'null' ? item.ReferralNotes : 'N/A';
                    var followupDate = item.ActivityLogFollowupDateString && item.ActivityLogFollowupDateString != 'null' ? kendo.toString(kendo.parseDate(item.ActivityLogFollowupDateString)) : 'N/A';
                    var dueDate = item.DueDate && item.DueDate != 'null' ? kendo.toString(kendo.parseDate(item.DueDate)) : 'N/A';
                    var followupDateGrid = $.fn.apply12To24hrFormat(StandardTimeFormat(followupDate));
                    var dueDateGrid = $.fn.apply12To24hrFormat(StandardTimeFormat(dueDate));
                    var strCheck = '<input type="button" style="float:right;margin-right:-5px; margin-top:-2px;" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnUMCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                    html += '<tr><td>' + $.fn.replaceAndEscapeHtmlExt(item.PatientFullName) + '</td>';
                    html += '<td>' + item.AuthorizationId + '</td>';
                    html += '<td>' + $.fn.replaceAndEscapeHtmlExt(item.AuthType) + '</td>';
                    html += '<td>' + $.fn.replaceAndEscapeHtmlExt(item.ActivityTypeName) + '</td>';
                    html += '<td>' + $.fn.replaceAndEscapeHtmlExt(prior) + '</td>';
                    html += '<td class="Tb205Px">';
                    html += '<input type="text" data-PatientId="' + item.PatientId + '" data-DueDate="' + dueDate + '"';
                    html += ' data-ActLogId="' + item.ActivityLogId + '"  data-QueueId="' + item.QueueId + '"';
                    html += ' class="UMAcceptCommentsFolloUpdate width93P" id = "txtUMAcceptCommentsFolloUpdate_' + key + '"';
                    html += ' value = "' + followupDateGrid + '" /> ' + strCheck + '</td>';
                    html += '<td>' + dueDateGrid + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(Comments) + '</td></tr>';
                });
                html += '</table>';
                $('#tdTableForUMActivities').html('').AhsAppend(html);
                $('.UMAcceptCommentsFolloUpdate').kendoDateTimePicker({ format: getDateFormat(), timeFormat: getTimeFormat(), interval: 30 });
            }
        }
    });
}


function AcceptUMActivity(dataParams) {
    $.ajax({
        type: "GET",
        url: baseURL + "/Dashboard/AcceptReferenceForUMActivity",
        data: dataParams,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.success) {
                var fromWLM = $('#hdnIsFromWLM').val();
                $('#btnCloseUMRequestReceivedAcceptComments').trigger('click');
                CustomAlert(data.msg);
                $('#tdTableForUMActivities').html('');
                if (fromWLM === '1') {
                    $("#UMPendingActivitiesGrid").data("kendoGrid").dataSource.read();
                }
                else {
                    var isScheduleVisibleDel = $('#popUpGlobalMySchedule').is(':visible');
                    if (isScheduleVisibleDel) {
                        var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                        if (currentView == "Week") {
                            $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                            loadGlobalMySchedule();
                        }
                        else {
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                    }
                    if (!isScheduleVisibleDel && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }

                    if ($("#id1frame").contents().find('[id*=btnImgRRec]').length > 0) {
                        $("#id1frame").contents().find('[id*=btnImgRRec]').trigger('click');
                    }
                    if (isMAL) {
                        $('#btnRequestReceivedSearchMAL').trigger('click');
                        $('#btnTCALSearchMAL').trigger('click');
                    }
                    else if ($("#btnRequestReceivedSearch").length > 0)
                        $('#btnRequestReceivedSearch').trigger('click');
                }
            }
            else
                CustomAlert(data.msg);
        }

    });
}
function CompleteMSActivityFrmActivityLog(patientFollowUpId, patientId) {
    loader(1);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/MemberService/CompleteActivity?ActId=" + patientFollowUpId + '&PatientId=' + patientId,
        onLoad: function () {
            if (enableDomLogs) {
                DomUtils.logDomData('Member Info >> Activity Record >> Call Log Registry >> Perform');
            }
        },
        popUpHeader: "General Activity Outcome",
        closeButton: '#btnCloseEditActivityForm',
        modalWidth: MODAL_WIDTH.MEDIUM
    });
    loader(0);
}

function pendingActivityComplete(pfid, isScriptInactive) {
    $.ajax({
        type: "GET",
        url: baseURL + "/Config/CheckIfActivityPerformed?moduleId=1&refId=" + pfid,
        dataType: "json",
        success: function (data) {
            if (data.result == 1) {
                CustomAlert("Activity already been performed/ deleted.");
                refreshGridsBasedOnVisibility(); //PROD-12752
            }
            else {
                $('#hdnIsFrmPendingActivities').val("1");
                completesetactivity(pfid, 0, true, null, isScriptInactive);
            }
        }
    });

}

function checkScriptProviderReview(scriptId, patientId, patientFollowUpId, formId, isCompletePendingActivity, scriptFormId) {
    $.ajax({
        url: baseURL + "/Assessment/CheckIsScriptProviderReview?ScriptId=" + scriptId + "&patientId=" + patientId,
        type: "GET",
        datatype: "JSON",
        success: function (data) {
            if (data == "True") {
                var action = CustomConfirm('Assessment is in pending provider review. Would you like to proceed further?');
                if (action == true) {
                    CheckScriptChanges(scriptId, patientId, patientFollowUpId, formId, isCompletePendingActivity, scriptFormId, null);
                }
            }
            else {
                CheckScriptChanges(scriptId, patientId, patientFollowUpId, formId, isCompletePendingActivity, scriptFormId);
            }
        },
        error: function () {
            scriptPerformActivityData = undefined;
            CustomAlert('Error occurred!');
        }
    });
}
function GetTemplateContentForSelectedEmail() {
    $(document).off('click', '.clsChkCaseConfSendEmail').on('click', '.clsChkCaseConfSendEmail', function () {
        GetTemplateCntForSlctdEmail();
    });
    $(document).off('change', '#ddlEmailTmplCaseConf').on('change', '#ddlEmailTmplCaseConf', function () {
        GetTemplateCntForSlctdEmail();
    });
}
function GetTemplateCntForSlctdEmail() {
    loader(1);
    $listchkbox = $('.clsChkCaseConfSendEmail');
    var listCareTeamId = "";
    $.each($listchkbox, function (key, item) {
        if ($(item).is(':checked')) {
            listCareTeamId += $(item).attr('Id').split('_')[1] + "|";
        }
    });
    var patientId = $('#hdnCaseConfPerformPatientId').val();
    var description = $('#hdnCaseConfCompDescription').val();
    $('#hdnCaseConfMemIdAndCareTeamId').val(listCareTeamId);
    $.ajax({
        type: "GET",
        url: baseURL + '/Home/GetTemplateForSelectedEmail?patientId=' + patientId + '&prevSelectedMembers=' + listCareTeamId + '&description=' + description + '&tmplId=' + $('#ddlEmailTmplCaseConf').val(),
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var editor = $("#caseConfeditor").data("kendoEditor");
                editor.value(data.templateContent);
            }
            loader(0);
        },
        error: function () {
            loader(0);
        }
    });
}
function SubmitOpenAuthAddActivityForm(obj) {
    $(obj).attr('disabled', 'disabled');
    //UM Validations Start
    var AuthFollowupDate = $('#ActivityLogFollowupDate').val();
    var AuthDueDate = "";
    if ($('#hdnOpenAuthDetails').val() !== undefined && $('#hdnOpenAuthDetails').val().split('|')[0] !== 'null') {
        AuthDueDate = new Date($('#hdnOpenAuthDetails').val().split('|')[0]);
        AuthDueDate = AuthDueDate.getMonth() + 1 + "/" + AuthDueDate.getDate() + "/" + AuthDueDate.getFullYear();
    }
    var AuthLOB = $('#hdnOpenAuthDetails').val() !== undefined ? $('#hdnOpenAuthDetails').val().split('|')[1] : "";
    var PostValidationData = {
        DATA_KEY: "VALIDATE_CLIENT_UM_RULES", SP_VA_LOB_NAME: AuthLOB, SP_VA_AUTH_DUE_DATE: AuthDueDate, SP_VA_AUTH_Followup_DATE: AuthFollowupDate, SP_VA_AUTH_STATUS: "", SP_VA_IS_AUTH: 1
    };
    HANDLER_URL = "api/Route/GetUMResult";
    AjaxInit(PostValidationData, function (validate) {
        if (validate !== "NR") {
            $(obj).removeAttr('disabled');
            CmnStatusMessageDisp('validationMessageActivity', validate, 'Error');
        }
        else//UM Validations End
        {
            IsConfirm = false;
            if (ValidationForOpenAuthActivity()) {
                if (IsConfirm) {
                    $().ConfirmationBox({ Title: 'ADD', Content: 'Follow up date is greater than due date. Would you still prefer to  schedule this activity?', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }], ButtonAlign: 'center' }, function (CVR) {
                        if (CVR) {
                            SaveUmActivityFinal(obj);
                        } else {
                            $(obj).removeAttr('disabled');
                        }
                    });
                }
                else {
                    SaveUmActivityFinal(obj);
                }
            }
            else {
                $(obj).removeAttr('disabled');
            }
        }
    });
}
function SaveUmActivityFinal(obj) {
    showFaxMsg = true;
    var btnvalue = $(obj).attr('value');
    $("#ValidationError").html("");
    loader(1);
    var chkdChkBx = $('#chkGroupActivityUM').is(':checked');
    var staffIds = $('#ddlStaffIdsIdhdn').val();
    var deptIds = $("#ddlDepartmentUMIdhdn").val();
    var datastring = $("#OpenAddAuthactivityForm form").serialize();
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/PostOpenAuthAddActivity?IsChecked=" + chkdChkBx + "&StaffIds=" + staffIds + "&DeptIds=" + deptIds,
        data: datastring,
        dataType: "json",
        success: function (data) {
            if (data.success === 'Success') {
                if (btnvalue === "Save") {
                    CmnStatusMessageDisp('validationMessageActivity', 'Activity added successfully!', 'Success');
                }
                else {
                    CmnStatusMessageDisp('ErrorMessage', 'Activity added successfully!', 'Success');
                }
                var ficoObject = { eventSource: "HOMEAUTHACTIVITYSAVE", parentConrolId: "", moduleName: "UM", eventType: "POST" };
                ficoRealTimeValidation(ficoObject);
                ClearOpenAuthAddActivityForm();
                $(obj).removeAttr('disabled');
                loader(0);

                if (isMAL) {
                    RefreshGridOnActionPerformed("TCAL", "UM");
                    RefreshGridOnActionPerformed("REQREC", "UM");
                } else {
                    if (!$('.fax_container').is(':visible')) {
                        $('#btnMyReqRfsh').trigger('click');
                    }
                    $("#_myCalendarPartialViewContainer").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                }
                if ($(obj).attr('id') === 'btnSubmitCloseActivityForm') {
                    $('#closebutton').trigger('click');
                }
            }
            else {
                $(obj).removeAttr('disabled');
                loader(0);
                CmnStatusMessageDisp('validationMessageActivity', data.model.ErrorMessage, 'Error');
                $("#ActivityLogDesc").val();
            }
        },
        error: function () {
            $(obj).removeAttr('disabled');
            loader(0);
            CmnStatusMessageDisp('validationMessageActivity', 'Error Occured', 'Error');
        }
    });
}
function SubmitUpdateAuthAddActivityForm(obj) {

    IsConfirm = false;
    if (ValidationForOpenAuthActivity()) {
        if (IsConfirm == true) {
            $().ConfirmationBox({ Title: 'EDIT', Content: 'Scheduled date is greater than due date. Would you still prefer to reschedule this activity?', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }], ButtonAlign: 'center' }, function (CVR) {
                if (CVR == true) {
                    updateUmActivityFinal(obj);
                }
            });
        }
        else {
            updateUmActivityFinal(obj);
        }
    }
}
function updateUmActivityFinal(obj) {

    var btnvalue = $(obj).attr('value');
    loader(1);
    $("#ValidationError").html("");
    var chkdChkBx = $('#chkGroupActivityUM').is(':checked');
    var staffIds = $('#ddlStaffIdsIdhdn').val();
    var deptIds = $("#ddlDepartmentUMIdhdn").val();
    var datastring = $("#OpenAddAuthactivityForm form").serialize();
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/PostOpenAuthAddActivity?IsChecked=" + chkdChkBx + "&StaffIds=" + staffIds + "&DeptIds=" + deptIds,
        data: datastring,
        dataType: "json",
        success: function (data) {
            if (data.success === 'Success') {
                loader(0);
                $('#ActId', '#OpenAddAuthactivityForm').val(data.model.ActId);
                $('#QueueId', '#OpenAddAuthactivityForm').val(data.model.QueueId);
                if (btnvalue === "Update") {
                    CmnStatusMessageDisp('validationMessageActivity', 'Activity Updated successfully.!', 'Success');
                }
                else {
                    CmnStatusMessageDisp('ErrorMessage', 'Activity Updated successfully.!', 'Success');
                }

                if (isMAL) {
                    RefreshGridOnActionPerformed("TCAL", "UM");
                    RefreshGridOnActionPerformed("REQREC", "UM");
                    RefreshGridOnActionPerformed("REQREJ", "UM");
                }
                else {
                    $("#ActivityLogDesc").val();
                }
                var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
                var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                if (isGlobalCalShown || isGlobalMySchedule) {
                    loadGlobalMySchedule();
                }
                if ($(obj).attr('id') === 'btnUpdateCloseActivityForm') {
                    $('#closebutton').trigger('click');
                    $("#OpenPerformactivityForm #ErrorMessage").text('Activity Updated successfully.!');
                }
                $('#myCalendarHeader #btnMyCalRfsh').trigger('click');
                $("#ReqRejGrid").data("kendoGrid").dataSource.read();
                $("#btnReqRejGridTotalCountrefresh").trigger("click");
            }
            else {
                loader(0);
                CmnStatusMessageDisp('ErrorMessage', data.model.ErrorMessage, 'Error');
            }
        },
        error: function () {
            //alert('error handling here');
        }
    });
}
function ValidationForOpenAuthActivity() {
    const timevalidation = IS_12HRS_FORMAT ? /^(0?[1-9]|1[012])(:[0-5]\d)(:?\d?\d?) [APap][mM]$/ : /^([0?1][0-9]|2[0-3])(:[0-5]\d)(:?\d?\d?)$/;
    let isValid = true;

    A11yForms.clearFormFieldValidation();

    if ($('#selectActivityType').val() === '-1') {
        A11yForms.showFormFieldError('selectActivityType', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#selectPriority').val() === '-1') {
        A11yForms.showFormFieldError('selectPriority', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#ActivityLogFollowupDate').val() === '') {
        A11yForms.showFormFieldError('ActivityLogFollowupDate', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#hdnSelectAssignToDDL').val() === '' || $('#txtActivityLogAssignTo').val() === '') {
        let checked = $('#chkGroupActivityUM').is(':checked');
        if (!checked) {
            A11yForms.showFormFieldError('txtActivityLogAssignTo', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    }

    if ($('#ActivityLogDesc').val().trim() === "") {
        A11yForms.showFormFieldError('ActivityLogDesc', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if ($('#ActivityLogFollowupDate').val() !== "") {
        let followupDate = $('#ActivityLogFollowupDate').val();
        let onlyDate = $('#ActivityLogFollowupDate').val().split(' ')[0];

        if (!date_regex.test(onlyDate) || !timevalidation.test(followupDate.split(' ')[2] !== undefined ? followupDate.split(' ')[1] + ' ' + followupDate.split(' ')[2] : followupDate.split(' ')[1])) {
            A11yForms.showFormFieldError('ActivityLogFollowupDate', A11yForms.ERROR_MESSAGES.VALID_DATETIME);
            isValid = false;
        } else {
            // do nothing (this is here for Sonar)
        }
    }

    if ($.trim($('#ActivityLogDueDate').val()) !== "") {
        let duedate = $('#ActivityLogDueDate').val();
        let endDueDateStr1 = duedate.split(' ')[0];
        let endDateStr1 = $('#ActivityLogFollowupDate').val().split(' ')[0];
        let endDueDate1 = new Date(endDateStr1);
        let endDueYear1 = endDueDate1.getFullYear();
        let d1 = new Date();
        let n1 = d1.getFullYear();
        let endYear110 = n1 + 10;

        if (!date_regex.test(endDueDateStr1) || !timevalidation.test(duedate.split(' ')[2] !== undefined ? duedate.split(' ')[1] + ' ' + duedate.split(' ')[2] : duedate.split(' ')[1])) {
            A11yForms.showFormFieldError('ActivityLogDueDate', A11yForms.ERROR_MESSAGES.VALID_DATETIME);
            isValid = false;
        } else if (endDueYear1 > endYear110) {
            endYear110 += 1;
            A11yForms.showFormFieldError('ActivityLogDueDate', 'Due Date should be less than year ' + endYear110);
            isValid = false;
        } else {
            let hdnFollowupDate = currentFollowupdate;
            let flag = $('#ActivityLogDueDate').is(":disabled");

            if (Date.parse(hdnFollowupDate) > Date.parse(duedate) && flag === false) {
                A11yForms.showFormFieldError('ActivityLogDueDate', "Due date should not be less than today's date.");
                isValid = false;
            } else if (new Date($('#ActivityLogFollowupDate').val()) > new Date($('#ActivityLogDueDate').val())) {
                IsConfirm = true;
            } else {
                // do nothing (this is here for Sonar)
            }
        }
    }

    if ($('#chkGroupActivityUM').is(':checked')) {
        let staffIds = $('#ddlStaffIdsIdhdn').val();
        if (staffIds === undefined || staffIds === "") {
            A11yForms.showFormFieldError('ddlStaffIds', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    }

    if ($('#selectScheduledType').val() === 0 && $('#selectScript') === -1) {
        A11yForms.showFormFieldError('selectScript', A11yForms.ERROR_MESSAGES.REQUIRED);
        isValid = false;
    }

    if (!isValid) {
        A11yAlerts.createErrorAlert('#validationMessageActivity');
    }

    return isValid;
}

function ClearOpenAuthAddActivityForm() {
    if ($("#selectActivityType").data("kendoDropDownList") != undefined && $("#selectActivityType").data("kendoDropDownList") != null)
        $("#selectActivityType").data("kendoDropDownList").value(-1);
    $("#selectPriority").data("kendoDropDownList").value(-1);
    $("#selectProviderType").data("kendoDropDownList").value(-1);
    $('#ActivityLogFollowupDate').val($.fn.apply12To24hrFormat(currentFollowupdate));
    $('#ActivityLogDueDate').val('');
    $('#txtActivityLogAssignTo').val(GetHtmlDecode(careStaffFullName + "-" + rolenameval));
    $('#hdnSelectAssignToDDL').val(CurrentUserId);
    $('#ActivityLogDesc').val('');
    $('#divDepartment').hide();
    $('#divCareStaff').hide();
    $('#divCareStaffBydept').hide();
    if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
        $('#divIdCareStaff').hide();
        $('#divIdExCareStaff').show();
        if ($("#ddlExCareStaff").data("kendoDropDownList") != undefined && $("#ddlExCareStaff").data("kendoDropDownList") != null)
            $("#ddlExCareStaff").data("kendoDropDownList").value(-1);
    }
    else {
        $('#divIdCareStaff').show();
        $('#divIdExCareStaff').hide();
    }
    $("#lstDeptIds").val(-1);
    $("#selOpenAuthStaffIds").val(-1);
    $('#chkGroupActivityUM').attr('checked', false);
    $('#ddlDepartment').val(-1);
    //loadDropDownSync(baseURL + "/Home/BindUmDeptUsers", 'selOpenAuthStaffIds');
}

function onLoadOpenAuthPerformActivityUM() {
    var DecisionValue = "";
    loadDropDown(baseURL + '/Master/BindDecisionType?careStaffId=' + getMemberId().MemberId + '&authNo=' + $('#AuthNo').val() + '&isActive=true', 'selectDecisionType', BindDecisionStatus, undefined, 'DecisionID', 'DecisionName', undefined, true);
    loadDropDown(baseURL + '/Master/BindHoldCodesType?DecisionId=' + $('#selectDecisionType').val(), 'selectHoldCodesId', BindHoldCode, undefined, 'DecisionStatus', 'DecisionStatusCodeName', undefined, true);
    $(document).off('change', '#selectDecisionType').on('change', '#selectDecisionType', function () {
        loadDropDown(baseURL + '/Master/BindHoldCodesType?DecisionId=' + $('#selectDecisionType').val(), 'selectHoldCodesId', BindHoldCode, undefined, 'DecisionStatus', 'DecisionStatusCodeName', undefined, true);
        DecisionValue = $('#selectDecisionType option:selected').val();

        if (DecisionValue !== "2" && DecisionValue !== "10") {
            $('#trDtRow').hide();
            $('#trDrRow').hide();
        }
        else {
            $('#trDtRow').show();
            $('#trDrRow').show();
            var DenialTypeId = $('#selectDenialTypeId').data("kendoDropDownList");
            var DenialReasonId = $('#selectDenialReasonId').data("kendoDropDownList");
            if (ToValue(DenialTypeId, null) !== null) {
                DenialTypeId.value("-1");
            }
            if (ToValue(DenialReasonId, null) !== null) {
                DenialReasonId.value("-1");
            }
        }
    });
    loadDropDown(baseURL + '/Master/BindDenialTypes/', 'selectDenialTypeId', null, undefined, 'DenialTypeId', 'DenialType', undefined, true);
    $(document).on('change', '#selectDenialTypeId', function () {
        loadDropDown(baseURL + '/Master/BindDenialReasonType?DenialTypeId=' + $('#selectDenialTypeId').val(), 'selectDenialReasonId', null, undefined, 'DenialReasonId', 'DenialReason', undefined, true);
    });

    // CODE FOR Add ACTIVITY ............... START...............
    $('#btnAddPenActAuth').click(function () {
        let patientId = $(this).attr('data-patientid');
        $('#popUpDialog2').CMNPopup({
            pvUrl: baseURL + "/Home/OpenAuthAddActivity?PatientName=" + $('#PatientNameUM').html() + "&AuthNo=" + $('#AuthNo').val() + "&AuthId=" + $('#lnkAuthId').html() + "&PatientId=" + $('#PatientId').val(),
            onLoad: function () {
                $('#HdnPatientId').val(patientId);
                onLoadOpenAuthAddAct();
                A11yModal.trapFocusInModal('popUpDialog2');
            },
            popUpHeader: "Add Activity",
            popLevel: 1,
            closeButton: '#closebutton',
            modalWidth: MODAL_WIDTH.MEDIUM,
            onClose: function () {
                $('#popUpDialog2').html('');
            }
        });
    });
    //........................END.......................................

    $('#btnUmViewSave').click(function () {
        SaveUMActivityForm();
    });
    $('#btnUmViewSaveComplete').click(function () {
        SaveUMSaveCompleteActivityForm();
    });
}

function SaveUMActivityForm() {
    $("#btnUmViewSave").attr("disabled", true);
    var COMPLETE_ACTIVITY = 0;
    $('#DecisionTypeText').val($('#selectDecisionType option:selected').text());
    $('#HoldCodesText').val($('#selectHoldCodesId option:selected').text());
    $('#DenialType').val($('#selectDenialTypeId option:selected').text());
    $('#DenialReason').val($('#selectDenialReasonId option:selected').text());
    $('#ConfidentialTypeId').val($('#selectAHNIsConfidential').val());
    $("#txtAuthNote").val(escapeHtml($("#txtAuthNote").val().replace(/</g, "//&lt;").replace(/>/g, "&gt;//")));
    var datastring = $("#OpenPerformactivityForm form").serialize();
    $.ajax({
        type: "POST",
        url: baseURL + "/Authorizations/PostUMPerformActivity?COMPLETEACTIVITY=" + COMPLETE_ACTIVITY,
        data: datastring,
        dataType: "json",
        success: function (data) {
            if (data.success === 'Success') {
                CustomAlert('Activity Saved successfully.');
                $("#closePopUp").trigger('click');
                var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
                var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                if (isGlobalCalShown || isGlobalMySchedule) {
                    loadGlobalMySchedule();
                }
                else if (!isGlobalMySchedule && $("#_myCalendarPartialViewContainer").is(":visible")) {
                    $("#_myCalendarPartialViewContainer").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                }
                if ($('#UMPendingActivitiesGrid').is(':visible')) { $("#UMPendingActivitiesGrid").data("kendoGrid").dataSource.read(); }
                RefreshGridOnActionPerformed("TCAL", "UM");
            }
            else {
                CustomAlert(data.msg);
            }
            $("#btnUmViewSave").attr("disabled", false);
        },
        error: function () {
            //alert('error handling here');
            $("#btnUmViewSave").attr("disabled", false);
        }
    });
}

function ValidationForOpenAuthPerformActivity() {
    $('span.validationMessage').remove();
    var flag = true;
    if ($('#selectDecisionType').val() == -1) {
        $('#selectDecisionType').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        flag = false;
    }
    else {
        $('#selectDecisionType').find('.requiredfields').hide();
    }
    if ($('#selectHoldCodesId').val() == -1) {
        $('#selectHoldCodesId').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        flag = false;
    }
    else {
        $('#selectHoldCodesId').find('.requiredfields').hide();
    }
    return flag;
}
function SaveUMSaveCompleteActivityForm() { 
    if (ValidationForOpenAuthPerformActivity()) {
        $("#btnUmViewSaveComplete").attr("disabled", true);
        var COMPLETE_ACTIVITY = 1;
        $('#DecisionTypeText').val($('#selectDecisionType option:selected').text());
        $('#HoldCodesText').val($('#selectHoldCodesId option:selected').text());
        $('#DenialType').val($('#selectDenialTypeId option:selected').text());
        $('#DenialReason').val($('#selectDenialReasonId option:selected').text());
        $('#ConfidentialTypeId').val($('#selectAHNIsConfidential').val());
        $("#txtAuthNote").val(escapeHtml($("#txtAuthNote").val().replace(/</g, "//&lt;").replace(/>/g, "&gt;//")));
        var datastring = $("#OpenPerformactivityForm form").serialize();
        $.ajax({
            type: "POST",
            url: baseURL + "/Authorizations/PostUMPerformActivity?COMPLETEACTIVITY=" + COMPLETE_ACTIVITY,
            data: datastring,
            dataType: "json",
            success: function (data) {
                if (data.success === 'Success') {
                    var rulePostAuthActivityObj = { eventSource: "UMAUTHACTIVITYPERFORM", moduleName: "UM", eventType: "POST", AuthNo: data.model.AuthNo, patientId: data.model.PatientId, activityLogId: data.model.ActId, async: true };
                    ficoRealTimeValidation(rulePostAuthActivityObj);
                    CustomAlert('Activity Saved & Completed successfully.');
                    $("#closePopUp").trigger('click');
                    if (!dashboardWidgets.isMyMemberExpand) {
                        bindAlertHeader();
                    }
                    var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
                    var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                    if (isGlobalCalShown || isGlobalMySchedule) {
                        loadGlobalMySchedule();
                    }
                    else if (!isGlobalMySchedule && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }
                    else {
                        // do nothing (this is here for Sonar)
                    }
                    if ($('#MvcMainBody #TodaysCareActLogDivId').length > 0) {
                        $("#ActivityLogMemberActivitiesGrid").data("kendoGrid").dataSource.read();
                    }
                    if ($.trim($('#MyMemberHeaderName').html()) == 'Pending Auth Activities') {
                        readDatasourcefromGrid("PendingActivityGrid", false);
                    }
                    // $("#closePopUp").trigger('click');
                    if ($('#UMPendingActivitiesGrid').is(':visible')) { $("#UMPendingActivitiesGrid").data("kendoGrid").dataSource.read(); }
                    RefreshGridOnActionPerformed("TCAL", "UM");
                    if ($("#UmAuthActivities").length > 0) {
                        //  $("#UmAuthActivities").data("kendoGrid").dataSource.read();
                        AuthActivity_Get(false, true);
                    }
                }
                else {
                    CustomAlert(data.msg);
                }
                $("#btnUmViewSaveComplete").attr("disabled", false);
            },
            error: function () {
                //alert('error handling here');
                $("#btnUmViewSaveComplete").attr("disabled", false);
            }
        });
    }
}


function onLoadMyView(patId) {
    //var patId = $('#patientForViewSummary').val()
    $("#divViewAdditionalInformation").load(baseURL + "/Home/MemberAdditionalDetails?patientId=" + patId);
    $("#divViewPatientDetails").load(baseURL + "/Home/ViewPatientDetails?patientId=" + patId);
    //Ph Member Info
    $("#divViewMemberInfo").load(baseURL + "/Home/ViewMemberInfo?patientId=" + patId);
    $("#divViewOpportunity").load(baseURL + "/Common/ViewOpportunity");
    $("#divViewCarePlan").load(baseURL + "/Common/ViewCarePlan");
    $("#divViewCondition").load(baseURL + "/Common/ViewCondition");
    $("#divViewMemberPrograms").load(baseURL + "/Common/ViewMemberPrograms");
    $("#divViewClainBasedMedication").load(baseURL + "/Common/ViewClainBasedMedication", function () { loader(0); });
}

function CaseConfSendEmail() {
    $(document).off('click', '#btnCaseConfSendEmail').on('click', '#btnCaseConfSendEmail', function () {
        $('span.requiredfields').remove();
        var editor = $("#caseConfeditor").data("kendoEditor");
        var groupid = $('#hdnCaseConfCompGroupId').val();
        var toAddresses = "";
        var mailContent = "";
        var listSelectedEmail = "";
        var additionalMails = $.trim($('#caseConfSendEmailAdditionalEmails').val());
        $listchkbox = $('.clsChkCaseConfSendEmail:checked');

        $.each($listchkbox, function (key, item) {
            if ($(item).is(':checked')) {
                listSelectedEmail += $(item).data('emailid') + ",";
            }
        });
        if ($('#ddlEmailTmplCaseConf').val() > 0) {
            loader(1);
            toAddresses = listSelectedEmail + additionalMails;
            mailContent = editor.value();
            if ($.trim(toAddresses)) {
                $.ajax({
                    type: "POST",
                    url: baseURL + '/Common/SendEmailAndSaveFile?toAddresses=' + toAddresses,
                    async: true,
                    data: JSON.stringify({ 'mailContent': mailContent, 'groupId': groupid }),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {
                        $('#btnCaseConfSendEmailPopupClose').trigger('click');
                        if (!data.success) { CustomAlert('Error occurred,try again'); }
                        else
                            CustomAlert('Email has been sent successfully!');
                        loader(0);
                    },
                    error: function () {
                        loader(0);
                    }
                });
            } else {
                loader(0);
                CustomAlert('Please select atleast one participants or enter a email to send an email');
            }
        }
        else
            $('#ddlEmailTmplCaseConf').closest('td').append('<span class="requiredfields" style="color:red">*</span>');
    });
}

function onLoadBulkLetter() {
    var chkboxes = $('#MyMembersGridNew').find('td input[type="checkbox"]:checked:visible');
    var patIds = '';
    $.each(chkboxes, function (key, item) {
        if ($(item).is(':checked')) {
            patIds += (key == 0 ? "" : ",") + $(item).next("input[type='hidden']").val();
            //patIds += $(item).attr('Id').split('_')[1] + ",";
        }
    });
    $('#blkLtrsDevXPatIds').val(patIds);
    //loadDropDown(baseURL + '/Home/LoadBulkLetterLang/', 'selBlkLtrsLang');
    //$(document).off('change', '#selBlkLtrsLang').on('change', '#selBlkLtrsLang', function () {
    //    loadDropDown(baseURL + '/Home/LoadBulkLetterTmpl?LanguageID=' + $(this).val(), 'selBlkLtrsTmpl')
    //});
    //$(document).off('change', '#selBlkLtrsTmpl').on('change', '#selBlkLtrsTmpl', function () {
    //    $.ajax({
    //        type: "GET",
    //        url: baseURL + '/Home/LoadTmplContent?tmplId=' + $(this).val(),
    //        dataType: "json",
    //        success: function (data) {
    //            if (data.success) {
    //                var editor = $("#bulkLettersEditor").data("kendoEditor");
    //                editor.value(data.templateContent);
    //            }
    //        }
    //    });
    //    $('#blkLtrsTmplId').val($(this).val());
    //});
    //blkLtrsPrintQueue();
}

function ValidationForCalendarActionReferral() {
    $('span.validationMessage').remove();
    $msg = $('#validationMessageReferComplaint');
    $msg.html('');

    if ($("#chkAgEditWorkQueueActivity").is(":checked") == true) {
        var staffIds = $('#ddlAGEditWQStaffIdsIdhdn').val();
        if (staffIds == '') {
            $('#divAGEditWQCareStaffBydept').append('<span class="validationMessage"  style="color:red">*</span>');
            return false;
        }
    }
    else {
        if ($('#selectAssignToAgDDL').val() == -1) {
            $('#divAGEditAssignTo').append('<span class="validationMessage"  style="color:red">*</span>');
            return false;
        }
    }
    return true;
}
function UpdateAgActivity() {
    loader(1);
    var referTo = $('#selectAssignToAgDDL').val();
    var referComments = "";
    var actionDetailsId = $('#ActionDetailsId').val();
    var isWorkQueue = $("#chkAgEditWorkQueueActivity").is(":checked");
    var deptIds = ToValue($('#ddlAGEditWQDepartmentIdhdn').val(), 0);
    var staffIds = ToValue($('#ddlAGEditWQStaffIdsIdhdn').val(), 0);
    var scheduledDate = $("#ScheduledDate").val();
    var duedate = $("#DueDate").val();
    var patientId = $('#PatientId').val();
    var comptype = $.trim($('#AgActdivCompType').text());
    let datastring = { actionDetailsId: actionDetailsId, deptId: deptIds, staffId: staffIds, referComments: referComments, referTo: referTo, patientId: patientId  };
    if (formatDate(new Date(duedate)) >= formatDate(new Date(scheduledDate))) {
        if (ValidationForCalendarActionReferral()) {
            $.ajax({
                type: "POST",
                url: baseURL + '/Activity/ReferAgainAGActivity?careStaffId=' + getMemberId().MemberId + '&scheduledDate=' + scheduledDate + "&IsWorkQueue=" + isWorkQueue + "&IsCal=" + true + "&complaintType=" + comptype,
                data: datastring,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        loader(0);
                        CustomAlert("Activity updated successfully");
                        if (isMAL) {
                            RefreshGridOnActionPerformed("TCAL", "AG");
                        };
                        $("#_myCalendarPartialViewContainer").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                            if ($("#popUpGlobalMySchedule").is(':visible')) {
                                $('.k-scheduler-toolbar').filter(':first').remove();
                                $('.k-scheduler-layout').filter(':first').remove();
                            }
                        });
                        $('#closebutton').trigger('click');
                    }
                    else {
                        loader(0);
                        CustomAlert(data.msg);
                    }
                },
                error: function () {
                    loader(0);
                }
            });
        }
        else { loader(0); }
    }
    else {
        loader(0);
        CmnStatusMessageDisp("divErrorMessageCR", "Scheduled date should be less than Due date.", "Error");
    }

}
function CreateAutoComDropCheck(selectid, url, ddlid, tbid) {
    var width = $('#' + selectid).width();
    var htm = "";
    htm = htm + "<div id='" + ddlid + "val1' class='droptextshow' style='display:none'  onclick='hidedrop(this)'>Select</div>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' val=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' val=''/>";
    var i = 0;
    $.getJSON(url, function (data) {
        if (data.length > 0) {
            var values = $("#" + ddlid + "hdn").val().split(',');
            var texts = $("#" + ddlid + "hdntxt").val().split(',');
            htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px' tabindex='" + tbid + "'>*** Prevoius Selected Items***";
            $.each(values, function (ind, item) {
                htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + item + "' onchange='clicked(this,0)' checked='checked' /><div id='" + ddlid + "spn' title='" + texts[ind] + "' onclick='spnclicked(this,0)'>" + texts[ind] + "</div><br/>";
            });
            htm = htm + "***</div>";
            htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px' tabindex='" + tbid + "'>";
            $.each(values, function (ind, item) {
                $.each(data, function (key, val) {
                    if (item != val.Value)
                        htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val.Value + "' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + val.Text + "' onclick='spnclicked(this,0)'>" + val.Text + "</div><br/>";
                });
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).AhsAppend(htm);
    });
}


function checkctrl(selectid, val) {
    var arrele = val.split(',');
    $.each(arrele, function (index, value) {
        var ele = $("input[type = 'checkbox'][value = '" + value + "']");
        ele.attr('checked', 'checked');
        ele.trigger('change');
    });
}

// Drop Check With Smart Search
function textChangedSmart(ctrl) {
    var elements = $(ctrl);
    var str = elements.data("id");
    $("#" + str + "chk").show();
    var count = 0;
    $("." + str).each(function (index) {
        var e1 = $(this).next();
        var str1 = e1.text();
        var patt = new RegExp(elements.val().toLowerCase());
        var res = patt.test(e1.text().toLowerCase());
        if (res) {
            $(this).show();
            e1.show();
            e1.next().show();
            count++;
        }
        else {
            $(this).hide();
            e1.hide();
            e1.next().hide();
        }
    });
    if (count == 0) { $("#" + str + "chkchk").show(); $("#" + str + "chkchk").text('No records'); }
    else { $("#" + str + "chkchk").hide(); }
}
function showdropSmart(ctrl) {
    var eleid = ctrl.id;
    eleid = eleid.replace("val", "");
    if ($(eleid).val() == "") {
        $("#" + eleid + "chk").show();
        $("#" + eleid + "chk").children().show();
    }
    else {
        textChangedSmart(ctrl);
    }
    $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 20), left: $('#' + eleid + "chk").offset().left });

}
function spnclickedSmart(ctrl, controlType) {
    if (controlType == undefined) controlType = "checkbox";
    var eleid = ctrl.id.replace('spn', '');
    var chkboxes = $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked');
    var ele = $(ctrl).prev("input[type=" + controlType + "]");
    if (ele.is(':checked') && controlType != "radio") {
        ele.prop('checked', false);
    } else {
        ele.prop('checked', true);
    }
    clickedSmart(ctrl, controlType)
}
function clickedSmart(ctrl, controlType) {
    if ($(".selectallid").is(":checked") == true && $(ctrl).is(":checked") == false)
        $(".selectallid").prop('checked', false);
    if (controlType == undefined) controlType = "checkbox";
    var eleid = ctrl.id.replace('spn', '');
    $("#" + eleid + "val").val('');
    ddlcolumnselectedshowSmart(eleid, controlType);
}
function ddlcolumnselectedshowSmart(eleid, controlType) {
    if (controlType == undefined) controlType = "checkbox";
    var chkboxes = $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked');
    var totalchkboxes = $("#" + eleid + "chk").find('input[type=' + controlType + ']');

    if (chkboxes.length > 0) {
        if ($("#" + eleid + "CheckAll").length) {
            if (chkboxes.length == totalchkboxes.length)
                $("#" + eleid + "CheckAll").prop('checked', true);
            else
                $("#" + eleid + "CheckAll").prop('checked', false);
        }
        var itm = "";
        var itmtxt = "";

        $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').each(function () {
            var arry = itm.split(',');
            var nummm;
            var valaaa = jQuery.inArray($(this).val(), arry, nummm);
            if (valaaa == -1) {
                if (itm.length > 0) {
                    //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                    itm = itm + "," + $(this).val();
                    itmtxt = itmtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
                else {
                    itm = $(this).val();
                    itmtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
            }
        });
        $("#" + eleid + "hdn").val(itm);
        $("#" + eleid + "hdntxt").val(itmtxt);
        $("#" + eleid + "val").attr('placeholder', chkboxes.length + " item(s) Checked");
        $("#" + eleid + "chkchk").AhsSetHtml('');
        $("#" + eleid + "chkchk").hide();
    }
    else {
        $("#" + eleid + "val").val("");
        $("#" + eleid + "val").attr('placeholder', $("#" + eleid + "val").data("ph"));
        $("#" + eleid + "hdn").val('');
        $("#" + eleid + "hdntxt").val('');
        $("#" + eleid + "chkchk").AhsSetHtml('');
        $("#" + eleid + "chkchk").hide();
    }

    if (eleid === "ddlResolutionCategoryId") {
        $("#ddlResolutionCategory").trigger('change');
    }
}
function GCPPtextChanged(ctrl) {
    var eleid = ctrl.id;
    var elements = $(ctrl);
    var str = elements.data("id");
    $("#" + str + "chk").show();
    var count = 0;

    $("." + str).each(function (index) {
        var e1 = $(this).next();
        var str1 = e1.text();
        var patt = new RegExp(elements.val().toLowerCase());
        var res = patt.test(e1.text().toLowerCase());
        if (res) {
            $(this).show();
            e1.closest('.clsParentCtrl').show();
        }
        else {
            $(this).hide();
            e1.closest('.clsParentCtrl').hide();
        }
    });

    eleid = eleid.replace('val', '');
    var chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:checked:visible').not('.selectallid');
    var totalchkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:visible').not('.selectallid');
    if ($('.selectallid', "#" + eleid + "chk").length) {
        if (chkboxes.length == totalchkboxes.length && totalchkboxes.length != 0)
            $('.selectallid', "#" + eleid + "chk").prop('checked', true);
        else
            $('.selectallid', "#" + eleid + "chk").prop('checked', false);
    }
}

function textentered(ctrl) {
    var eleid = ctrl.id;
    eleid = eleid.replace("val", "");
    var eletext = $(ctrl).val();
    var url = $("#" + eleid + "hdnurl").val();
    if (eletext.length > 0) {
        getlist(eletext, url, eleid);
    }
    else {
        $("#" + eleid + "chkchk").html('');
        $("#" + eleid + "chkchk").hide();
        $("#" + eleid + "chk").find("input").show();
        $("#" + eleid + "chk").find("div").show();
        $("#" + eleid + "chk").find("br").show();
    }
}
function showcheckeditem(url, eleid, elhval) {
    var ele = elhval.split(',');
    var numm;
    var htmlm = " **** Previously Selected Items **** <br />";
    $.getJSON(url, function (data) {
        if (data.length > 0) {
            $.each(data, function (key, val) {
                var valaa = jQuery.inArray(val.Value, ele, numm);
                if (valaa != -1) {
                    htmlm = htmlm + "<input type='checkbox' id='" + eleid + "' value='" + val.Value + "' onchange='clicked(this,0)' checked='checked'/><div id='" + eleid + "spn' title='" + val.Text + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + val.Text + "</div><br/>";
                }
            });
            htmlm = htmlm + "<br />*******************************";
        }
        else {
            htmlm = htmlm + "No Records";
            htmlm = htmlm + "<br />*******************************";
        }
        $("#" + eleid + "chkchk").html('');
        $("#" + eleid + "chkchk").append(htmlm);
        $("#" + eleid + "chkchk").show();

    });

}
function showGCPPdrop(ctrl) {
    var eleid = ctrl.id;
    var eleclass = $(ctrl).parent()[0].className;
    var setOffsetTop = /insideSelect/i.test(eleclass);
    var parenteleid = eleid.replace("Idval", "");
    var widthList = $('#' + parenteleid).attr('data-CtrlListWidth');
    var width = $('#' + parenteleid).width();
    if (widthList != undefined)
        width = widthList;
    //var isProviderSpecialty = ((/ProviderSpeciality/i.test(eleid) && /AuthDiv/i.test(eleid)) || (/RadioList_CustField/i.test(eleid) && /AuthDiv/i.test(eleid)) || (/ChkList_CustField_/i.test(eleid) && /AuthDiv/i.test(eleid)) || (/ddlDepartment/i.test(eleid)) || (/ddlStaffIds/i.test(eleid)));
    eleid = eleid.replace("val", "");
    $("#" + eleid + "chk").attr('style', 'width:' + width + 'px !important;');
    $("#" + eleid + "chk").show();
    if ($("#" + eleid + "val").val() == "") {
        $("#" + eleid + "chk").children().show();
    }
    if ($(ctrl).val() == "Select")
        $(ctrl).val('');

    var chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:visible:checked').not('.selectallid').not('.clsPPChild');
    var totalchkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:visible').not('.selectallid').not('.clsPPChild');
    if ($('.selectallid', "#" + eleid + "chk").not('.clsPPHeader').length) {
        if (chkboxes.length == totalchkboxes.length && totalchkboxes.length != 0)
            $('.selectallid', "#" + eleid + "chk").not('.clsPPHeader').prop('checked', true);
        else
            $('.selectallid', "#" + eleid + "chk").not('.clsPPHeader').prop('checked', false);
    }
    var chkPPboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:visible:checked').not('.selectallid').not('.clsGCChild');
    var totalPPchkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:visible').not('.selectallid').not('.clsGCChild');
    if ($('.selectallid', "#" + eleid + "chk").not('.clsGCHeader').length) {
        if (chkPPboxes.length == totalPPchkboxes.length && totalPPchkboxes.length != 0)
            $('.selectallid', "#" + eleid + "chk").not('.clsGCHeader').prop('checked', true);
        else
            $('.selectallid', "#" + eleid + "chk").not('.clsGCHeader').prop('checked', false);
    }

    if (setOffsetTop) {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 37), left: $('#' + eleid + "chk").offset().left });
    }
    else {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 22), left: $('#' + eleid + "chk").offset().left });
    }
}
function ddlGCPPcolumnselectedshow(eleid, iscount, controlType, ignoreContent) {
    if (controlType == undefined) controlType = "checkbox";
    var chkboxes = $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').not(".selectallid").not(ignoreContent);
    if (ignoreContent == '.clsGCChild') {
        var totalchkboxesVisible = $("#" + eleid + "chk").find('input[type=' + controlType + ']:not(:disabled)').not('.selectallid').not(ignoreContent);
    } else {
        var totalchkboxesVisible = $("#" + eleid + "chk").find('input[type=' + controlType + ']:visible').not('.selectallid').not(ignoreContent);
    }
    var totalchkboxes = $("#" + eleid + "chk").find('input[type=' + controlType + ']').not(".selectallid").not(ignoreContent);

    var chkboxesVisible = $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked:visible').not('.selectallid').not(ignoreContent);
    if (ignoreContent != undefined) {
        if (chkboxes.length > 0) {

            if (eleid == "ddlCareorganization") {
                // $('#btnGoCareOrg').attr('disabled', false);
                if ($('#ddlSearchBy option:selected').text() != "TIN") {
                    $('#btnHideCareOrg').hide();
                    $('#btnGoCareOrg').show();
                } else {
                    $('#btnHideCareOrg').hide();
                    $('#btnGoCareOrg').hide();
                }

            }

            if ($("#" + eleid + "CheckAll").length) {
                if (chkboxes.length == totalchkboxes.length)
                    $("#" + eleid + "CheckAll").prop('checked', true);
                else
                    $("#" + eleid + "CheckAll").prop('checked', false);
            }
            var ignoreHeader = '.clsPPHeader';
            if (ignoreContent == '.clsPPChild') { ignoreHeader = '.clsPPHeader'; }
            else { ignoreHeader = '.clsGCHeader'; }

            if ($('.selectallid', "#" + eleid).not(ignoreHeader).length) {
                if (chkboxesVisible.length == totalchkboxesVisible.length) {
                    if (ignoreContent == '.clsPPChild') { $('.selectallid', "#" + eleid).not('.clsPPHeader').prop('checked', true); }
                    else { $('.selectallid', "#" + eleid).not('.clsGCHeader').prop('checked', true); }
                }
                else {
                    if (ignoreContent == '.clsPPChild') { $('.selectallid', "#" + eleid).not('.clsPPHeader').prop('checked', false); }
                    else { $('.selectallid', "#" + eleid).not('.clsGCHeader').prop('checked', false); }
                }

            }
            var itm = ""; var itmtxt = ""; var itmPP = ""; var itmPPtxt = "";

            $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').not('.selectallid').not('.clsPPChild').each(function () {
                var arry = itm.split(',');
                var valaaa = jQuery.inArray($(this).val(), arry);
                if (valaaa == -1) {
                    if (itm.length > 0) {
                        //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                        itm = itm + "," + $(this).val();
                        itmtxt = itmtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                    }
                    else {
                        itm = $(this).val();
                        itmtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                    }
                }
            });
            $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').not('.selectallid').not('.clsGCChild').each(function () {
                var arry = itmPP.split(',');
                var valaaa = jQuery.inArray($(this).val(), arry);
                if (valaaa == -1) {
                    if (itmPP.length > 0) {
                        //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                        itmPP = itmPP + "," + $(this).val();
                        itmPPtxt = itmPPtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                    }
                    else {
                        itmPP = $(this).val();
                        itmPPtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                    }
                }
            });
            if (itmtxt != "" && itm != "") {
                $("#" + eleid + "hdn").val(itm);
                $("#" + eleid + "hdntxt").val(itmtxt);
            }
            if (itmPPtxt != "" && itmPP != "") {
                $("#" + eleid + "hdnPP").val(itmPP);
                $("#" + eleid + "hdnPPtxt").val(itmPPtxt);
            }

            if ($('.selectallid', "#" + eleid).not(ignoreHeader).length === 0) {//to handle for multicheckboxes without select all option in CM section
                $("#" + eleid + "val").val("");
            }
            if (iscount) {
                $("#" + eleid + "val").attr('placeholder', itm);
            }
            else {
                var gcChk = $("#" + eleid + "chk").find('.clsGCChild:checked');

                if (gcChk.length >= 1 && gcChk.length <= 3) {
                    // $("#" + eleid + "val").attr("placeholder",chkboxes.length + " Item Selected");
                    if (itm == "Empty")
                        itmtxt = "  ";
                    $("#" + eleid + "val").attr('placeholder', itmtxt);
                }
                else {
                    $("#" + eleid + "val").attr('placeholder', gcChk.length + " items Checked");
                }
            }
        }
        else {
            if (eleid == "ddlCareorganization") {
                //$('#btnGoCareOrg').attr('disabled', true);
                if ($('#ddlSearchBy option:selected').text() != "TIN") {
                    $('#btnHideCareOrg').show();
                    $('#btnGoCareOrg').hide();
                }
                else {
                    $('#btnHideCareOrg').hide();
                    $('#btnGoCareOrg').hide();
                }
                if ($('#dvServiceLoc').is(":visible") && $('#ddlSearchBy option:selected').text() != "TIN") {
                    CreateDropCheck('ddlServiceLocations', baseURL + '/PopulationHealth/BindServiceLocations?OrgFilterIdval=', 'ddlServiceLocations', 0);
                }
                if ($('#dvNPI').is(":visible") && $('#ddlSearchBy option:selected').text() != "TIN") {
                    CreateDropCheck('ddlGlobalSearchNpi', baseURL + '/PopulationHealth/BindNpi?OrgFilterIdval=', 'ddlGlobalSearchNpi', 0);
                }
            }

            if ($("#" + eleid + "CheckAll").length)
                $("#" + eleid + "CheckAll").prop('checked', false);

            // $("#" + eleid + "val").val("");
            if (ignoreContent == '.clsPPChild') {
                $("#" + eleid + "val").attr('placeholder', 'Select');
                $("#" + eleid + "hdn").val('');
                $("#" + eleid + "hdntxt").val('');
            }
            if (ignoreContent == '.clsGCChild') {
                $("#" + eleid + "hdnPP").val('');
                $("#" + eleid + "hdnPPtxt").val('');
            }
        }
    }
}

function BindChkToHiddenCtrls(ctrlid, iscount, controlType) {
    if (controlType == undefined) controlType = "checkbox";
    var eleid = ctrlid;
    var chkboxes = $("#" + eleid + "chk").find('input[type="' + controlType + '"]:checked').not('.selectallid');
    if (chkboxes.length > 0) {
        var itm = ""; var itmtxt = ""; var itmPP = ""; var itmPPtxt = "";
        $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').not('.selectallid').not('.clsPPChild').each(function () {
            var arry = itm.split(',');
            var nummm;
            var valaaa = jQuery.inArray($(this).val(), arry, nummm);
            if (valaaa == -1) {
                if (itm.length > 0) {
                    //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                    itm = itm + "," + $(this).val();
                    itmtxt = itmtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
                else {
                    itm = $(this).val();
                    itmtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
            }
        });
        $("#" + eleid + "chk").find('input[type=' + controlType + ']:checked').not('.selectallid').not('.clsGCChild').each(function () {
            var arry = itmPP.split(',');
            var valaaa = jQuery.inArray($(this).val(), arry);
            if (valaaa == -1) {
                if (itmPP.length > 0) {
                    //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                    itmPP = itmPP + "," + $(this).val();
                    itmPPtxt = itmPPtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
                else {
                    itmPP = $(this).val();
                    itmPPtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
            }
        });
        if (itmtxt != "" && itm != "") {
            $("#" + eleid + "hdn").val(itm);
            $("#" + eleid + "hdntxt").val(itmtxt);
        }
        if (itmPPtxt != "" && itmPP != "") {
            $("#" + eleid + "hdnPP").val(itmPP);
            $("#" + eleid + "hdnPPtxt").val(itmPPtxt);
        }
        if (iscount) {
            $("#" + eleid + "val").attr("value", itm);
        }
        else {
            var gcChk = $("#" + eleid + "chk").find('.clsGCChild:checked');
            if (gcChk.length >= 1 && gcChk.length <= 3) {
                if (itm == "Empty")
                    itmtxt = "  ";
                $("#" + eleid + "val").val("");
                $("#" + eleid + "val").attr('placeholder', itmtxt);
            }
            else {
                if (eleid != 'divDiagnosisAndServiceCodes') {
                    $("#" + eleid + "val").val("");
                    $("#" + eleid + "val").attr('placeholder', gcChk.length + " items Checked");
                }
                else if (gcChk.length == 4) {
                    $("#" + eleid + "chk").find('.clsGCChild:checked').prop("checked", false);
                    $("#" + eleid + "chk #divDiagnosisAndServiceCodestxt").val("");
                }
            }
        }
    }
    else {
        $("#" + eleid + "val").attr("placeholder", "Select");
        //$("#" + eleid + "val").val("");
    }

}
function getscriptmode(sid, icount) {
    var pardata = { scriptID: sid, count: icount };
    $.ajax({
        url: baseURL + "/Home/GetScriptMode",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) { $('#hdnflag').val(data); },
        error: function (error) { }
    });
}
function fireNopatMethod(pid, pval) {
    if (checkUnsentMsgWfChatBox(true)) {
        if (typeof hideHaven === 'function') { hideHaven(); }
        var pardata = { fid: pid, objval: pval };
        $.ajax({
            url: baseURL + "/Home/SetFireMethodNoPat",
            type: "POST",
            datatype: "JSON",
            data: pardata,
            success: function (data) {
                $("#DivMemberSummaryMenu").hide();
                $('#DivAddAuthorizationMenu').hide();
                DevUtils.logDebug('Hiding memberInfoMenu 6');
                $('#lnkMemberInfo, #memberInfoMenu').hide();
                $('#divAction').hide();
                $('#divCarePlan').hide();
                $('#divCareNotes').hide();
                $('#divSdoh').show();
                SetControlDisplay(1);
                $('.ah-required-note.is-visible').removeClass('is-visible');
            }
        });
    }
}
function Access_CMMenu_BasedOn_Modules() {
    $('#lnkMemberInfo, #memberInfoMenu').show();
    if (((iscmval == 'True' || loggedInUserModuleId == '1') && (isumval == 'True' || loggedInUserModuleId == '3') && (isagval == 'True' || loggedInUserModuleId == '5')) ||
        ((iscmval == 'True' || loggedInUserModuleId == '1') && (isumval == 'True' || loggedInUserModuleId == '3')) ||
        ((iscmval == 'True' || loggedInUserModuleId == '1') && (isagval == 'True' || loggedInUserModuleId == '5')) ||
        (iscmval == 'True' || loggedInUserModuleId == '1') ||
        (isMTMval == 'True')) {
        if (ActionView) {
            $('#divAction').show();
        }
        else {
            $('#divAction').hide();
        }
        if (isMTMval == 'True') {
            $('#divCarePlan').hide(); $('#divCareNotes').hide();
        }
        else {
            $('#divCarePlan').show();
            $('#divCareNotes').show();
            $('#divSdoh').hide();
        }
    }
    else {
        $('#divAction').hide();
        $('#divCarePlan').hide();
        $('#divCareNotes').hide();
    }
}
function loadMemberdetails(ctrltoclc, access, childloc) {
    var setheight = '';
    LoadMemberSummaryMenu(1, access);
    var objval = $("#selectPatientAccessed").val();
    DevUtils.logDebug('GCHomeCommonRefs.loadMemberdetails()', 'MEMBER_ACCESSED_DROPDOWN', { objval: objval }, 'purple');

    if (Appid == 0) {
        if (setheight == '' || setheight == null)
            setheight = '800';
        $('#id1frame').height(setheight + 'px');
        setTimeout(function () { CallAllCtrls(2, 0, '~/App_Pages/CM/Manage/MemberDetailsNew.ascx', '', '800'); }, 15);
    }
    else {
        $("#MvcMainBody").load(baseURL + "/Home/MemberDetailsMvc?patientId=" + objval, function () {
            if (ctrltoclc == "CarePlan") { selectTab("CarePlan"); }
            else if (ctrltoclc == "MTM") { selectTab("MTM", "btnClickMTM"); }
            else if (ctrltoclc == "ActivitySummary") {
                if (childloc != null && childloc != '' && childloc != undefined) {
                    childctrlname = childloc;
                }
                selectTab("ActivitySummary");
            }
            else if (ctrltoclc == 'Documents') {
                selectTab('Documents');
            }
            else if (ctrltoclc == 'Medications') {
                selectTab('Medications');
            }
            else if (ctrltoclc === 'Programs') {
                selectTab('Programs');
            } else if (ctrltoclc === 'MemberAlerts') {
                selectTab('MemberAlerts');
            }
            else if (ctrltoclc === undefined) {
                $("#divMemberBody").find(".RaSubLink, .ah-tablist").each(function () {
                    if (ctrltoclc === undefined && ($(this).find('li').length > 0 || $(this).find('button').length > 0)) {
                        let tabId = '';
                        let classList = $(this).attr('class').split(" ");

                        for (const className of classList) {
                            if (className.indexOf('Lt_') >= 0) {
                                tabId = className.replace('Lt_li', '');
                                ctrltoclc = tabId;
                            }
                        }

                        selectTab(ctrltoclc, null, objval);
                    }
                });
            }
            else if (ctrltoclc == 'ServicePlan') {
                selectTab('ServicePlan');
            }
            else {
                if (IsMemberPage === '') {
                    DevUtils.logDebug('GCHomeCommonRefs.loadMemberdetails() *** triggering MemberDetailsTab click ***', 'MEMBER_ACCESSED_DROPDOWN', null, 'purple');
                    $('#MemberDetailsTab').trigger('click', objval);
                } else {
                    IsMemberPage = '';  // NOSONAR (complaining to make declaration of IsMemberPage explicity, but it is already declared in GCHomeCommon.js)
                }
            }

            if (isMTMval == 'False' && (isumval == 'True' || loggedInUserModuleId == '3')) {
                $('#liAuthorization, #pnAuthorizationsSection').show();
            }
            else {
                $('#liAuthorization, #pnAuthorizationsSection').hide();
            }

            if (isMTMval == 'False' && (isagval == 'True' || loggedInUserModuleId == '5')) {
                $('#liComplaints, #pnComplaintSection').show();
            }
            else {
                $('#liComplaints, #pnComplaintSection').hide();
            }
            if (isMTMval == 'True') {
                $('#liMTM, #pnMemberMTMSection').show();
            }
            else {
                $('#liMTM, #pnMemberMTMSection').hide();
                $('#lnkSumaryTimeLineTab').hide();
                $('#lnkDrugInteractionsTab').hide();
                $('#lnkMTMInterventionsTab').hide();

            }
            SetControlDisplay(4);
        });
        loader(0);
    }
}
function memberAccessCheck(patientId, isRefreshCache) {
    let cachePatientAccessedInsertKey = "patientAccessedInsert_" + patientId;
    let _data = (!isRefreshCache && cacheData(cachePatientAccessedInsertKey)) || null;
    if (_data === null) {
        var url = baseURL + "/Home/patientAccessedInsert?PatientId=" + patientId;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            success: function (data) {
                if (data !== null) {
                    MemberAccessedCheck = data.toString();
                    if (MemberAccessedCheck === "2") {
                        $(".Glb_MemAccessed,.Glb_MemAccessDevide").show();
                    }
                    else {
                        $(".Glb_MemAccessed,.Glb_MemAccessDevide").hide();
                    }

                    cacheData({ key: cachePatientAccessedInsertKey, value: MemberAccessedCheck, maxage: 120 }, true);
                }
                else {
                    $(".Glb_MemAccessed,.Glb_MemAccessDevide").hide();
                }

            },
        });
    } else {
        if (_data === "2") {
            $(".Glb_MemAccessed,.Glb_MemAccessDevide").show();
        }
        else {
            $(".Glb_MemAccessed,.Glb_MemAccessDevide").hide();
        }
    }
}
function fireMethodNavigateToPatient(fid, objid, path, objval, setheight, ctrltoclc, pfid, isActivityLog) {
    AppContextManager.PatientContext.setPatientId(objval);
    DevUtils.logDebug('GCHomeCommonRefs.fireMethodNavigateToPatient()', 'MEMBER_ACCESSED_DROPDOWN', { objval: objval }, 'purple');
    loader(1);
    CallingIframeJsFunction(null);
    var pardata = { fid: fid, objid: objid, path: path, objval: objval };
    $.ajax({
        url: baseURL + "/Home/GetFireMethodRes",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            scriptPerformActivityData = undefined;
            var res = data.split('|');
            if (res[0] == "true" && fid == 1) {
                isMAL = false;
                $("#ctrlval").val(path);
                $("#btnPopUpGlobalMyScheduleClose").trigger('click');
                setpatinfo(objval);
                if (path != "" && pfid == null) {
                    RemoveLocalStorage(1);
                    SetControlDisplay(3);
                    $('#MvcMainBody').html('');
                    MemberAccessedCheck = res[1];
                    // write logic to open the alerts grid for acknowledge for carestaff having role.
                    loadMemberdetails(ctrltoclc, MemberAccessedCheck, objval);
                }

            }
            else if (res[0] == "false" && fid == 1) {
                $("#DivMemberSummaryMenu").hide();
                $('#DivAddAuthorizationMenu').hide()
                DevUtils.logDebug('Hiding memberInfoMenu 7');
                $('#lnkMemberInfo, #memberInfoMenu').hide();
                $('#divAction').hide();
                $('#divCarePlan').hide();
                $('#divCareNotes').hide();
                SetControlDisplay(isMAL ? 4 : 1);
                CustomAlert("You Can't Access this Patient");
                var PAccddl = $("#selectPatientAccessed").data("kendoDropDownList");
                PAccddl.text("Member Accessed");
                loader(0);
            }
        },
        error: function (error) { }
    });
}
function ClickFirePlan(pid) {
    var str = pid, ctrlname = 'CarePlan';
    clearFields();
    fireMethod(1, Appid, '~/App_Pages/CM/Manage/MemberDetailsNew.ascx', pid, '800', ctrlname);
}
function setpathforctrl(pno, path, val, info, setheight, ctrl, srMode, PHPatientId, RefId, RefType, isFromPH) {
    if (pno == '21') {
        let scptFormActivityId = $("#hdnScptCareActivityTypeId").length > 0 ? $("#hdnScptCareActivityTypeId").val() : $('#ddlCareActivitymvc').val();
        funloadScriptForms(scptFormActivityId, info, isFromPH);
    }
    else {
        let activityId = $("#hdnScptCareActivityTypeId").length > 0 ? $("#hdnScptCareActivityTypeId").val() : $('#CareActivityTypeId').val();
        var pardata = { id: pno, path: path, value: val, addinfo: info, srMode: srMode, PHPatientId: PHPatientId, RefId: RefId, RefType: RefType, careActivityType: $("#ddlCareActivitymvc option:selected").text(), careActivityTypeID: activityId, workFlowIds: $('#ddlRequiredActivitiesIdhdn').val() };//GFID-815
        $.ajax({
            url: baseURL + "/Home/SetPath",
            type: "POST",
            data: pardata,
            success: function (data, textStatus, jqXHR) {
                if (ctrl == 2) {
                    if (path.indexOf("RunScript") > 0 || path.indexOf("ActivityLog") > 0) {
                        callscriptfunction();
                    }
                    $('#id1frame').height(setheight + 'px');
                    $('#id1frame').attr('src', baseURL + "/Application.aspx");
                    runScriptButtonVisibility();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) { }
        });
    }
}
function ClearTotalAppointmentForm() {
    $('#ddlCareTeamProv').val(-1);
    if ($('#ddlTypeOfAppointment option').length > 1)
        $('#ddlTypeOfAppointment').val(1);
    else
        $('#ddlTypeOfAppointment').val(-1);
    $('#AppointmentReason').val('');
    $('#AppointmentNotes').val('');
    $('#ddlAppointmentPriority').val(-1);
    $('#ddlAppointmentStatus').val(-1);
    $('#PhysicianCode').val('');
    $('#ProviderName').val('');
    $('#ProviderType').val('');
    $('#CellPhone').val('');
    $('#City').val('');
    $('#ProviderEmail').val(''); $('#CareplanId').val('');
}

function updateEmailNotificationStatus(appointmentId, status) {
    var Url = baseURL + '/Home/UpdateEmailNotificationStatus?appointmentId=' + appointmentId + '&status=' + status;
    $.ajax({
        type: "POST",
        url: Url,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.success) {
                status = true;
            }
        }
    });
}

function AddOrEditCareGiver1(url) {
    var status = false;
    var proxyflag = 0;
    var primaryflag = 0;
    if ($('#chkHealthProxy1').is(':checked')) {
        proxyflag = 1;
    }
    if ($('#chkIsPrimary1').is(':checked')) {
        primaryflag = 1;
    }
    var chkMemberPortalAccessCareGiverAdd = $("#chkMemberPortalAccessCareGiver").is(":checked");
    var careStaffId = getMemberId().MemberId;
    var patientId = $('#selectPatientAccessed').val();
    if (CareGiverValidation1()) {

        var datastring = $("#AddCareGivers form").serialize();
        $.ajax({
            type: "POST",
            url: baseURL + url + "?IsProxy=" + proxyflag + "&IsPrimary=" + primaryflag + "&MemberPortalAccessStatus=" + chkMemberPortalAccessCareGiverAdd + "&careStaffId=" + careStaffId + "&patientId=" + patientId,
            data: datastring,
            dataType: "json",
            async: false,
            success: function (data) {
                if (data.success) {
                    status = false;
                    switch (data.flag) {
                        case 1:
                            status = true;
                            $('#dvCareGiversAddEdit').html('');
                            if (!$('.caregiverCustCls').is(':visible')) {
                                $('.portletHead').show();
                                $('#careGiversModalButtons').show();
                                A11yModal.recalculateTabStops('popUpDialog1');
                            }
                            break;
                        case 0:
                        case -1:
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Unable to add caregiver, please try again.');
                            break;
                        case -2:
                            $('#AddCareGivers', "#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Active Caregiver Record With Same Data Already Exists.');
                            break;
                        case -3:
                            $('#AddCareGivers', "#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Inactive Caregiver Record With Same Data Already Exists.');
                            break;
                        case -4:
                            $('#AddCareGivers', "#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Inactive Caregiver Record With Overlapping Dates Already Exists.');
                            break;
                        case -5:
                            $('#AddCareGivers', "#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Active Caregiver Record With Overlapping Dates Already Exists.');
                            break;
                        case -6:
                            $('#AddCareGivers', "#popUpDialog1").animate({ scrollTop: 0 }, 'slow');
                            A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'The start and end dates of the date ranges fall outside the dates of the caregiver record in care team.');
                            break;
                    }
                }
                else {
                    status = false;
                    A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation', 'Unable to add caregiver, please try again.');
                }
            },
        });
    }
    return status;
}


function CareGiverValidation1() {
    A11yForms.clearFormFieldValidation();
    let currentDate = new Date(Dateconvert(currentDateByTimeZone));
    let isValid = true;
    isValid &= A11yForms.validateFormField('txtEditDtaPCPFirstName1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCPLastName1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    let isValidBirthYearString = A11yForms.validateFormField('txtEditDtaPCGDOB1', null, [A11yForms.VALIDATIONS.DATE]);
    let birthDate = new Date($('#txtEditDtaPCGDOB1').val());
    if (isValidBirthYearString && (birthDate > currentDate)) {
        A11yForms.showFormFieldError('txtEditDtaPCGDOB1', 'Cannot be in the future');
        isValidBirthYearString = false;
    }
    isValid &= isValidBirthYearString;
    let fromDate = new Date($('#txtCrGvrStartDate').val());
    let endDate = new Date($('#txtCrGvrEndDate').val());
    let isValidFromDate = A11yForms.validateFormField('txtCrGvrStartDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATE]);
    let isValidEndDate = A11yForms.validateFormField('txtCrGvrEndDate', null, [A11yForms.VALIDATIONS.DATE]);
    isValid &= isValidFromDate;
    isValid &= isValidEndDate;
    if (isValidEndDate && isValidFromDate && (fromDate > endDate)) {
        A11yForms.showFormFieldError('txtCrGvrStartDate', 'Start date should precede End date');
        isValid = false;
    }
    isValid &= A11yForms.validateFormField('ddlEditDtaPCGGender1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    var relationshipVal = A11yForms.validateFormField('ddlEditDtaPCGRelationship1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    isValid &= relationshipVal;
    if (relationshipVal && $('#ddlEditDtaPCGRelationship1').find('option:selected').text().toUpperCase() === 'OTHERS') {
        isValid &= A11yForms.validateFormField('txtPCGRelationship1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    }
    isValid &= A11yForms.validateFormField('txtEditDtaPCGAddress1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGCity1', null, [A11yForms.VALIDATIONS.REQUIRED]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGZIP1', null, [A11yForms.VALIDATIONS.ZIP]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGHomePh1', null, [A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGCellPh1', null, [A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGAltPhone1', null, [A11yForms.VALIDATIONS.PHONE]);
    isValid &= A11yForms.validateFormField('txtEditDtaCGFax1', null, [A11yForms.VALIDATIONS.FAX]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGEmail1', null, [A11yForms.VALIDATIONS.EMAIL]);
    isValid &= A11yForms.validateFormField('txtEditDtaPCGAltEmail1', null, [A11yForms.VALIDATIONS.EMAIL]);
    if (!isValid) {
        A11yAlerts.createErrorAlert('#divAddEditCareGiversValidation');
    }
    return isValid;
}
function showdrop1(ctrl) {
    var eleid = ctrl.id;
    eleid = eleid.replace("val", "");
    $("#" + ctrl.id).hide();
    $("#" + eleid + "val1").show();
    $("#" + eleid + "chk").show();
}
function hidedrop1(ctrl) {
    var eleid = ctrl.id;
    eleid = eleid.replace("val1", "");
    $("#" + eleid + "val").show();
    $("#" + ctrl.id).hide()
    $("#" + eleid + "chk").hide();
}

function uncheckCarePlanCheckBoxItems() {
    var unChkItems = $('#hdnFullCarePlanSelectedIds').val();
    var grdChkChkdItems = $('#GridFullCarePlan').find($(".clschkFullCarePlan:checked"));
    var chkHeadChk = 0;
    if (unChkItems != '' && unChkItems != null && unChkItems != 'undefined') {
        var unChkItemsSplit = unChkItems.split(',');
        $.each(grdChkChkdItems, function (key, item) {
            var grdChkItem = grdChkChkdItems[key];
            $.each(unChkItemsSplit, function (index) {
                if (unChkItemsSplit[index] == grdChkItem.getAttribute('data-cplids')) {
                    grdChkItem.checked = false;
                    chkHeadChk = 1;
                }
            });
        });
        if (chkHeadChk > 0) {
            $('#GridFullCarePlan .clschkFullCarePlanHead').prop('checked', false);
        }
        else {
            $('#GridFullCarePlan .clschkFullCarePlanHead').prop('checked', true);
        }
    }
}

function onLoadOpenComplaintPerformActivityAG() {
    // CODE FOR Add ACTIVITY ............... START...............
    $('#btnAddPenActComplaint').click(function () {
        var patientId = $(this).attr('data-patientId');
        $('#popUpDialog2').CMNPopup({
            pvUrl: baseURL + "/Complaint/OpenComplaintAddActivity?PatientName=" + $('#PatientName').val() + "&ComplaintId=" + $('#ComplaintRecordId').val() + "&ComplaintTypeId=" + $('#ComplaintTypeId').val() + "&ComplaintRecordNo=" + $('#ComplaintRecordNo').val(),
            onLoad: function () {
                $('#ComplaintCurrent_PatientId').val(patientId);
                onLoadOpenComplaintAddAct();
            },
            popUpHeader: "Add Activity",
            popLevel: 1,
            closeButton: '#closebutton',
            modalWidth: MODAL_WIDTH.MEDIUM
        });
    });
    //........................END.......................................

    $('#btnAgViewSave').click(function () {
        SaveAGActivityForm(0);
    });
    $('#btnAgViewSaveComplete').click(function () {
        SaveAGActivityForm(1);
    });

}

function onLoadOpenComplaintAddAct() {
    $('#OpenAddComplaintactivityForm #ActivityScheduleDate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 10, value: new Date($('#OpenAddComplaintactivityForm #ActivityScheduleDate')) });
    if ($('#OpenAddComplaintactivityForm #ActionDate').val() != null && $('#OpenAddComplaintactivityForm #ActionDate').val() != "") {
        $('#OpenAddComplaintactivityForm #ActionDate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 10, value: new Date($('#OpenAddComplaintactivityForm #ActionDate')) });
    }
    else {
        $('#OpenAddComplaintactivityForm #ActionDate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 10 });
    }
    loadDropDown(baseURL + '/Common/BindComplaintActivityTypes?ComplaintId=' + $('#ComplaintRecordId').val() + '&ComplaintTypeId=' + $('#ComplaintTypeId').val(), 'selectAGActivityType', undefined, undefined, undefined, undefined, undefined, true);
    loadDropDown(baseURL + '/Common/BindAGActivityPriority/', 'selectAGActivityPriority', undefined, undefined, undefined, undefined, undefined, true);
    loadDropDown(baseURL + '/Common/BindComplaintLevels?ComplaintId=' + $('#ComplaintRecordId').val(), 'selectAGLevelDDL', $('#ComplaintLevelId').val(), undefined, undefined, undefined, undefined, true);
    $('#btnSubmitComplaintActivityForm, #btnSubmitCloseComplaintActivityForm').click(function () {
        SubmitOpenComplaintAddActivityForm(this);
    });
    $(document).off('change', '#selectComplaintScheduledType').on('change', '#selectComplaintScheduledType', function () {
        DisableCareStaffAddActivity();
    });
    $('#ActivityScheduleDate').val(currentdate);
    //$(document).off('change', '#selectAGActivityType').on('change', '#selectAGActivityType', function () {
    //    LoadActivityLevels();
    //});
}

function DisableCareStaffAddActivity() {
    var val = $("#selectComplaintScheduledType").val();
    A11yAlerts.remove();
    var ddlSelectedActivityTypeId = ($("#selectAGActivityType").val() || "-1");
    if (val == 2) {
        EnableDisableKendoDropDownValue($("#selectAGAssignToDDL"), true);
        SetKendoDropDownValue($("#selectAGAssignToDDL"), ddlSelectedActivityTypeId === "-1" ? -1 : CurrentUserId);
        $("#ActionDate").val($("#ActivityScheduleDate").val());
        if ($("#chkAgWorkQueueActivity").is(":checked")) {
            $("#chkAgWorkQueueActivity").prop("checked", false);
        }
        $("#divAGWorkQueue").hide();
        $("#divAgWorkQueueChecked").hide();
        $('#divAGAssignTo').show();
        $('#divAGAssignToDDL').removeAttr('title');

        var ddlSelectedActTypeId = ($("#selectAGActivityType").val() || "-1");
        if (ddlSelectedActTypeId !== '-1' && $('#selectAGAssignToDDL').val() === '-1') {
            A11yAlerts.createWarningAlert('#validationMessageComplaintActivity', 'You already have an activity of the same type assigned to you.');
        }
    }
    else {
        EnableDisableKendoDropDownValue($("#selectAGAssignToDDL"), ddlSelectedActivityTypeId == "-1" ? true : false);
        if (ddlSelectedActivityTypeId == "-1") {
            $('#divAGAssignToDDL').attr('title', 'Please select the activity type before assigning it to the user.');
        }
        $("#divAGWorkQueue").show(); $("#ActionDate").val('');
    }
}
function SaveAGActivityForm(SourceObj) {
    $("#btnAgViewSave").attr("disabled", true);
    $("#btnAgViewSaveComplete").attr("disabled", true);
    $('#ResolutionCategory').val($('#selectResolutionCategory option:selected').text());
    $('#ResolutionSubCategory').val($('#selectResolutionSubcategory option:selected').text());
    $('#ConfidentialTypeId').val($('#selectAGAHNIsConfidential').val());
    $("#txtComplaintNote").val(escapeHtml($("#txtComplaintNote").val()));
    var datastring = $("#OpenPerformCompaintactivityForm form").serializeArray();
    var patientId = null;
    var complaintRecordId = null;
    var activityLogId = null;
    datastring.forEach(function (item) {
        if (item.name === 'PatientName') {
            item.value = $.fn.replaceAndEscapeHtmlExt(item.value);
        }
        if (item.name === 'ResolutionCategory' || item.name === 'ResolutionSubCategory') {
            item.value = escapeHtml(item.value);
        }
        if (item.name === 'PatientId') {
            patientId = item.value;
        }
        if (item.name === 'ComplaintRecordId') {
            complaintRecordId = item.value;
        }
        if (item.name === 'ActionDetailsId') {
            activityLogId = item.value;
        }
    });
    $.ajax({
        type: "POST",
        url: baseURL + "/AGComplaint/PostAGPerformActivity?COMPLETEACTIVITY=" + SourceObj,
        data: datastring,
        dataType: "json",
        success: function (data) {
            if (data.success = 'Success') {
                if (SourceObj == 0) {
                    CustomAlert('Activity Saved successfully.');
                    $("#closePopUp").trigger('click');
                }
                else {
                    CustomAlert('Activity Saved & Completed successfully.');
                    $("#closePopUp").trigger('click');
                    if ($.trim($('#MyMemberHeaderName').html()) == 'Pending Complaint Activities') {
                        readDatasourcefromGrid("PendingComplaintActivities", false);
                    }
                    if ($('#AGPendingActivitiesGrid').is(':visible')) { $("#AGPendingActivitiesGrid").data("kendoGrid").dataSource.read(); }

                }
                var ficoPostObject = { eventSource: "AGMDRACTIVITYSAVECOMPLETE", patientId: patientId, complaintNo: complaintRecordId, activityLogId: activityLogId, moduleName: "AG", eventType: "POST", isAsync: true };
                ficoRealTimeValidation(ficoPostObject);

                if (isMAL) {
                    RefreshGridOnActionPerformed("TCAL", "AG");
                }
                else {
                    var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
                    var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                    if (isGlobalCalShown || isGlobalMySchedule) {
                        loadGlobalMySchedule();
                    }
                    else {
                        $("#_myCalendarPartialViewContainer").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }
                }
            }
            else {
                $("#btnAgViewSave").attr("disabled", false);
                $("#btnAgViewSaveComplete").attr("disabled", false);
            }
        },
        error: function () {
            //alert('error handling here');
            $("#btnAgViewSave").attr("disabled", false);
            $("#btnAgViewSaveComplete").attr("disabled", false);
        }
    });

}
function SubmitOpenComplaintAddActivityForm(obj) {
    let btnId = $(obj).attr('id');

    GetClientTime('', function (ResultClientTime) {
        if (validationForOpenComplaintActivity(ResultClientTime)) {
            loader(1);
            var patientId = $('#ComplaintCurrent_PatientId').val();
            var datastring = $("#OpenAddComplaintactivityForm form").serialize();
            var AssignedTo = $("#selectAGAssignToDDL").val();
            var Type = $("#selectComplaintScheduledType").val();
            var ActivityTypeId = $("#selectAGActivityType").val();
            var LevelId = $("#selectAGLevelDDL").val();
            var chkdChkBx = $('#chkAgWorkQueueActivity').is(':checked');
            var staffIds = $('#ddlAGWQStaffIdsIdhdn').val();
            var deptId = $('#ddlAGWQDepartmentIdhdn').val();
            var ActivityPriorityId = "";
            if ($("#selectAGActivityPriority").val() != "-1")
                ActivityPriorityId = $("#selectAGActivityPriority").val();
            showFaxMsg = true;
            $.ajax({
                type: "POST",
                url: baseURL + "/AGComplaint/PostOpenComplaintAddActivity?AssignedTo=" + AssignedTo + "&Type=" + Type + "&ActivityTypeId=" + ActivityTypeId + "&LevelId=" + LevelId + "&IsWorkQueue=" + chkdChkBx + "&StaffId=" + staffIds + "&DeptId=" + deptId + "&PriorityId=" + ActivityPriorityId + "&MemberId=" + memberidval + "&PatientId=" + patientId,
                data: datastring,
                dataType: "json",
                success: function (data) {
                    if (data.success === 'Success') {
                        loader(0);
                        var ficoObject = { eventSource: "HOMEAGACTIVITYSAVE", parentConrolId: "", moduleName: "AG", eventType: "POST", isAsync: true };
                        ficoRealTimeValidation(ficoObject);
                        ClearOpenComplaintAddActivityForm();
                        if (btnId === 'btnSubmitComplaintActivityForm') {
                            $("#chkAgWorkQueueActivity").removeAttr('onclick').prop("disabled", true);
                            EnableDisableKendoDropDownValue($("#selectAGAssignToDDL"), true);
                            SetKendoDropDownValue($("#selectAGAssignToDDL"), -1);
                            $('#divAGAssignToDDL').attr('title', 'Please select the activity type before assigning it to the user.');
                            $('#chkAgWorkQueueActivity').attr('title', 'Please select the activity type before assigning it to the workqueue.');
                            A11yAlerts.createSuccessAlert('#validationMessageComplaintActivity', 'Activity added successfully.');
                        } else {
                            A11yAlerts.createSuccessAlert('#ErrorMessage', 'Activity added successfully.');
                        }

                        if ($.trim($('#MyMemberHeaderName').html()) == 'Pending Complaint Activities') {
                            readDatasourcefromGrid("PendingComplaintActivities", false);
                        }
                        $("#_myCalendarPartialViewContainer").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });

                        if (btnId === 'btnSubmitCloseComplaintActivityForm') {
                            $('#closebutton').trigger('click');
                        }
                    }  else {
                        loader(0);
                        A11yAlerts.createErrorAlert('#validationMessageComplaintActivity', data.model.ErrorMessage);
                    }
                },
                error: function () {
                    A11yAlerts.createErrorAlert('#validationMessageComplaintActivity', A11yAlerts.ALERT_MSG.ERROR_OCCURRED);
                }
            });
        }
    });
}
function ClearOpenComplaintAddActivityForm() {
    $('#ActivityScheduleDate').val(currentdate);
    $('#txtActivityLogAssignTo').val(GetHtmlDecode(careStaffFullName + "-" + rolenameval));
    $('#hdnSelectAssignToDDL').val(CurrentUserId);
    $('#selectComplaintScheduledType').val(1);
    $('#ActionDate').val('');
    $('#txtAGActNotes').val('');
    $("#selectAGAssignToDDL").removeAttr("disabled");
    $("#chkAgWorkQueueActivity").prop("checked", false);
    $("#divAGWorkQueue").show();
    $('#divAgWorkQueueChecked').hide();
    $('#divAGAssignTo').show();
    $('#ddlAGWQStaffIds').html('');
    loadDropDown(baseURL + '/Common/BindAGActivityPriority/', 'selectAGActivityPriority', undefined, undefined, undefined, undefined, undefined, true);
    loadDropDown(baseURL + '/Common/BindComplaintActivityTypes?ComplaintId=' + $('#ComplaintRecordId').val() + '&ComplaintTypeId=' + $('#ComplaintTypeId').val(), 'selectAGActivityType', undefined, undefined, undefined, undefined, undefined, true);
    loadDropDown(baseURL + '/Common/BindComplaintLevels?ComplaintId=' + $('#ComplaintRecordId').val(), 'selectAGLevelDDL', $('#ComplaintLevelId').val(), undefined, undefined, undefined, undefined, true);
}

function validationForOpenComplaintActivity(resultClientTime) {
    let isValid = true;

    A11yForms.clearFormFieldValidation();

    isValid &= A11yForms.validateFormField('selectAGActivityType', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('ActivityScheduleDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATETIME]);
    isValid &= A11yForms.validateFormField('ActionDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATETIME]);
    isValid &= A11yForms.validateFormField('selectAGLevelDDL', null, A11yForms.VALIDATIONS.REQUIRED);

    if ($('#chkAgWorkQueueActivity').is(':checked')) {
        let StaffIds = $('#ddlAGWQStaffIdsIdhdn').val();
        if (StaffIds === '') {
            A11yForms.showFormFieldError('ddlAGWQStaffIds', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    } else {
        isValid &= A11yForms.validateFormField('selectAGAssignToDDL', null, A11yForms.VALIDATIONS.REQUIRED);
    }

    if (!isValid) {
        A11yAlerts.createErrorAlert('#validationMessageComplaintActivity');
    } else {
        let scheduleDate = $('#ActivityScheduleDate').val();
        let dueDate = $('#ActionDate').val();

        if ($('#selectComplaintScheduledType').val() === '2' && dueDate != null && scheduleDate != null) {
            if ((new Date(dueDate) < new Date(resultClientTime).addDays(-7)) || (new Date(scheduleDate) < new Date(resultClientTime).addDays(-7))) {
                A11yAlerts.createErrorAlert('#validationMessageComplaintActivity', 'You cannot add completed activities with scheduled date or due date prior to a week.');
                isValid = false;
            } else if (new Date(scheduleDate) > new Date(resultClientTime)) {
                A11yAlerts.createErrorAlert('#validationMessageComplaintActivity', 'You cannot add completed activities with scheduled date in the future.');
                isValid = false;
            } else {
                // do nothing this is here for Sonar
            }
        }

        if (new Date(scheduleDate) > new Date(dueDate)) {
            A11yAlerts.createErrorAlert('#validationMessageComplaintActivity', 'Due date should be greater than the scheduled date.');
            isValid = false;
        }

        if ($("#selectComplaintScheduledType").val() === '2' && $('#selectAGAssignToDDL').val() === '-1' && $('#selectAGActivityType').val() !== "-1") {
            A11yAlerts.createWarningAlert('#validationMessageComplaintActivity', 'You already have an activity of the same type assigned to you.');
            isValid = false;
        }
    }

    return isValid;
}
function redirectToAuthPage(PatientId, AuthId, AuthClassId, AuthNo, PatientFName, PatientLName) {
    SetAuthDatanew(PatientId, AuthId, AuthClassId, AuthNo, PatientFName, PatientLName);
}
function ProgramValidation() {
    $('#spnmessageprogram').html('');
    var Startdate = $('#txtStartDate').val();
    var EndDate = $('#txtEndDate').val();
    var msgcount = 0;

    //if (RadioValue == 'Pending') {
    //    if (new Date(Startdate).getTime() <= new Date().getTime()) {
    //        msgcount = 1;
    //        $('#spnmessageprogram').html('Start date must be beyond the today\'s date for pending record');
    //    }
    //} 

    if (EndDate != null || EndDate != '' || EndDate != 'Undefined') {
        if (new Date(Startdate).getTime() > new Date(EndDate).getTime()) {
            $('#spnmessageprogram').html('Start date must be less than the End date');
            msgcount = 1;

        }
    }
    if ($('#ddlLOB option:selected').val() == -1 && (ProgramType == 'addLob' || ProgramType == 'addplan' || ProgramType == 'addprogram')) {
        var obj = $('#ddlLOB').closest('td').find('.validationMessage');
        if (obj.length != 0) {
            obj.hide();
        }
        msgcount = 1;
    }
    if ($('#ddlBenefitPlan option:selected').val() == -1 && (ProgramType == 'addplan' || ProgramType == 'addprogram')) {
        var obj = $('#ddlBenefitPlan').closest('td').find('.validationMessage');
        if (obj.length != 0) {
            obj.hide();
        }
        msgcount = 1;
    }
    if ($('#ddlProgAddAC').val() == '' && ProgramType == 'addprogram') {
        var obj = $('#ddlProgAddAC').closest('td').find('.validationMessage');
        if (obj.length != 0) {
            obj.hide();
        }
        msgcount = 1;
    }

    if ($('#ddlProgramStatusName option:selected').val() == -1) {
        msgcount = 1;
    }

    if ($('#ddlClosureReason option:selected').val() == -1) {
        msgcount = 1;
    }
    if ($('#ddlReferralType option:selected').val() == -1 && ProgramType == 'addprogram') {
        msgcount = 1;
    }

    if ($('#txtStartDate').val() == "") {
        var obj = $('#txtStartDate').closest('td').find('.validationMessage');
        if (obj.length != 0) {
            obj.hide();
        }
        msgcount = 1;
    }
    var isPlanVisible = $("#tdPlanName").is(":visible");
    var isProgramVisible = $("#tdProgramName").is(":visible");

    //G8CAL-319
    if (EndDate == "" && !isPlanVisible) {
        $('#spnmessageprogram').html('Please enter valid end date');
        msgcount = 1;
    }
    else if (EndDate == "" && isPlanVisible && !isProgramVisible && isEndDateMandatory == "True") {
        $('#spnmessageprogram').html('Please enter valid end date');
        msgcount = 1;
    }
    else if ((EndDate == "" && isProgramVisible && $('#txtPlanEndDate').val() != "")) {
        $('#spnmessageprogram').html('Program dates are not in Plan/Program date range (Start Date: ' + escapeHtml($('#txtPlanStartDate').val()) + ' , End Date: ' + escapeHtml($('#txtPlanEndDate').val()) + ')');
        msgcount = 1;
    }
    else if (EndDate == "" && isProgramVisible && isEndDateMandatory == "True" && $('#txtPlanEndDate').val() == "") {
        $('#spnmessageprogram').html('Program dates are not in Plan/Program date range');
        msgcount = 1;
    }
    //else if (EndDate == "" && isProgramVisible && isEndDateMandatory == "False" && $('#txtPlanEndDate').val() != "") {
    //    $('#spnmessageprogram').html('Program dates are not in Plan/Program date range (Start Date: ' + escapeHtml($('#txtPlanStartDate').val()) + ' , End Date: ' + escapeHtml($('#txtPlanEndDate').val()) + ')');
    //    msgcount = 1;
    //}
    else if (isProgramVisible && $('#txtPlanEndDate').val() != "") {
        //  else if (EndDate != "" && isProgramVisible && $('#txtPlanEndDate').val() != "") {
        if (new Date($('#txtPlanEndDate').val()) < new Date(EndDate)) {//compare end <=, not >=
            $('#spnmessageprogram').html('Program dates are not in Plan/Program date range (Start Date: ' + escapeHtml($('#txtPlanStartDate').val()) + ' , End Date: ' + escapeHtml($('#txtPlanEndDate').val()) + ')');
            msgcount = 1;
        }
    }
    if (isNaN(Startdate) == false || isValidDate(Startdate) == false) {
        $('#spnmessageprogram').html('Please enter valid start date');
        msgcount = 1;
        return;
    }

    if (EndDate != null && EndDate != "" && EndDate != 'Undefined') {
        if (isNaN(EndDate) == false || isValidDate(EndDate) == false) {
            $('#spnmessageprogram').html('Please enter valid end date');
            msgcount = 1;
            return;
        }
    }
    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}

function SaveProgramData(Obj, planProgIds) {
    var type = ProgramType;
    var lob = $('#ddlLOB option:selected').val();
    var plan = $('#ddlBenefitPlan option:selected').val();
    if ($('#hdnProgAddAC').length > 0)
        var program = $('#hdnProgAddAC').val();
    var reason = $('#ddlClosureReason option:selected').val();
    var status = $('#ddlProgramStatusName option:selected').val();
    var referral = $('#ddlReferralType option:selected').val();
    var startdate = $('#txtStartDate').val();
    var enddate = $.trim($('#txtEndDate').val());
    var isPending = $('input:radio[name=AddStatus]:checked').val();
    var datastring = $("#ProgramFormId").serialize();
    var PlanProgIds = planProgIds == undefined ? '' : planProgIds;

    plan = plan == undefined ? '-1' : plan;
    program = program == undefined ? '-1' : program;

    $.ajax({
        type: "POST",
        url: baseURL + "/Program/SaveProgram?type=" + type + '&lob=' + lob + '&plan=' + plan + '&program=' + program + '&reason=' + reason + '&refertype=' + referral + '&startdate=' + startdate + '&enddate=' + enddate + '&isPending=' + isPending + '&status=' + status + '&planProgIds=' + PlanProgIds + '&patientId=' + $('#selectPatientAccessed').val(),
        dataType: "json",
        data: datastring,
        success: function (data) {
            loader(0);
            var msg = data.success;
            var ptype = data.ptype;
            if (ptype == '0' || ptype == 'undefined') {
                $('#spnmessageprogram').AhsSetHtml(msg);
                CmnStatusMessageDisp('spnprogmessage', 'Program record within same dates already exists.', 'Error');
            }
            else {
                if (Obj == undefined || Obj == '') {
                    $("#programsAddEdit").html("");
                    $('#programsAddEdit').hide();
                    $('#programView').show();

                    if ($('#btnToggleView').hasClass('TileView')) {
                        if (!$("#btnShowActivePrograms").is(':visible')) {
                            $("#btnShowActivePrograms").trigger('click');
                        }
                        else {
                            $("#btnShowAllPrograms").trigger('click');
                        }
                    }
                    else {
                        $('#ProgramsGrid').data('kendoGrid').dataSource.read();
                    }
                    if (!(window.top.$(".InAuthPage").is(":visible"))) {
                        LoadMemberSummaryMenuEligibilityDetails();
                    }
                    $(window).scrollTop(0);
                    if (ptype == 1) {
                        CmnStatusMessageDisp('spnprogmessage', 'Record Added Successfully', 'Success');
                    }
                    else {
                        CmnStatusMessageDisp('spnprogmessage', 'Record Updated Successfully', 'Success');
                        logPatientMismatch(data.patientIdPassed, "HomeController.cs - SaveProgram", datastring, data.patientIdInSession); //UHC-4434
                    }

                } else {
                    CmnStatusMessageDisp('spnprogmessage', 'Record Updated Successfully', 'Success');
                    if (enddate != null && enddate != '') {
                        var psdate = new Date(enddate);
                        psdate = psdate.setDate(psdate.getDate() + 1);
                        var NewDate = new Date(psdate);
                        var ProgramSDate = (NewDate.getMonth() + 1) + "/" + (NewDate.getDate()) + "/" + NewDate.getFullYear();
                        $('#txtStartDate').val(ProgramSDate);
                    }
                    $('#ddlProgramStatusName').val(-1);
                    $('#ddlClosureReason').find('option').remove().end();
                    $('#ddlClosureReason').append($('<option></option>').val("-1").html("Select"));
                    $('#txtEndDate').val('');
                    ProgramType == 'addprogram';
                    varClosureId = null; $('#StrUpdate').val('');
                    $('#MemBenfProgId').val('');
                    $('#btnSaveAndCopyProgram').attr('disabled', true).css('opacity', 0.5);
                    $('#btnSaveProgram').val('Save');
                }
            }

        }
    });
}
function Validatedata() {
    var msgcount = 0;
    $('.ValMsg').html('');
    if ($('#chkGroupActivity').is(':checked')) {
        if ($('#ddlRefMemStaffIdshdn').val() == null || $('#ddlRefMemStaffIdshdn').val() == "") {
            msgcount = 1;
            $('#ddlRefMemStaffIdshdn').closest('td').find('.requiredfields').show();
        } else {
            $('#ddlRefMemStaffIdshdn').closest('td').find('.requiredfields').hide();
        }
    }
    else {
        if ($('#hdnCareStaffReferMember').val() == "" || $.trim($('#selectCareStaffReferMember').val()) == "") {
            msgcount = 1;
            $('#selectCareStaffReferMember').closest('td').find('.requiredfields').show();
        } else {
            $('#selectCareStaffReferMember').closest('td').find('.requiredfields').hide();
        }
    }
    if ($('#selectReasonForreference').val() < 0) {
        msgcount = 1;
        $('#selectReasonForreference').closest('td').find('.requiredfields').show();
    } else {
        $('#selectReasonForreference').closest('td').find('.requiredfields').hide();

    }
    if ($.trim($('#ReferNotes').val()).length <= 0) {
        msgcount = 1;
        $('#ReferNotes').closest('td').find('.requiredfields').show();
    } else {
        $('#ReferNotes').closest('td').find('.requiredfields').hide();
    }
    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}

function SetReqRecHeightAndWidth() {
    //if ($('#btnReqsecCollapse').is(":visible")) {
    //    // alert('Expand');
    //    $('#ReqRecGrid').css({ "height": "430px" });
    //    $('#ReqRecGrid').find(".k-grid-content").css({ "height": "380px" });
    //}
    //else if ($('#btnReqsecExpand').is(":visible")) {
    //    // alert('Not Expand');
    //    $('#ReqRecGrid').css({ "height": "166px" });
    //}
    //else {
    //    // alert('None');
    //    $('#ReqRecGrid').css({ "height": "166px" });
    //    $('#ReqRecGrid .k-grid-content').css({ "height": "115px" });

    //}
}
//PROD-19169,19172 - Start
function GetAGUMAlertSearchDetails(SearchOptionValue, SearchVal, PatientId, Module) {
    PatientId = ToValue(PatientId, -1);
    var patientData = { patientVal: PatientId, searchName: SearchOptionValue, searchValue: SearchVal }; //BCBSKC-2828 - Inconsistent behaviour on search
    var dataProfileConfig = false;
    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: patientData,
        success: function (data) {
            if (data != undefined) {
                var resp = data.ToJson()[0];
                if (resp != null && resp != undefined) {
                    PatientId = resp.Patientid;
                    dataProfileConfig = resp.Canaccess;
                    if (SearchOptionValue === 'SCA_ID' && ToValue(PatientId, null) === null) {
                        CustomAlert("No records found");
                        return false;
                    }
                }
            }
            if (dataProfileConfig) {
                $.ajax({
                    type: "POST",
                    url: baseURL + "/Home/UMAGQuickSearchIndicatorAlertCount?searchName=" + SearchOptionValue + "&searchValue=" + SearchVal + "&patientId=" + PatientId,
                    dataType: "json",
                    success: function (data) {
                        if (data[0].CountAlert > 0 && $('#selectPatientAccessed').val() != PatientId) {
                            $("#hdnTotalAlertsCount").val(data[0].CountAlert);
                            $('#DivPatientAlerts').html('');//if alerts pop up is opened at member level and after if clicked on any member alerts grid is not binding
                            $('#popUpDialog3').CMNPopup({
                                pvUrl: baseURL + "/CommonDefaultSessionState/PatientAlerts?patientId=" + data[0].PatientId,
                                popUpHeader: "Alerts",
                                modalWidth: MODAL_WIDTH.MEDIUM,
                                popLevel: 1,
                                onClose: function () {
                                    if ($('#hdnIsPatientAlertsPopup').length > 0) {
                                        if (($("#hdnAcknowledgedAlertCount").val() != '' && $("#hdnAcknowledgedAlertCount").val() == 0) || $("#hdnTotalAlertsCount").val() == '0') {
                                            if (Module === 'UM') {
                                                clearPreAuthCache();
                                                GetAuthDetails(SearchOptionValue, SearchVal);
                                            }
                                            else if (Module === 'AG') {
                                                if (SearchOptionValue === 'COMPLAINT_ID') {
                                                    GetComplaintDataByNumber(SearchVal);
                                                }
                                                else if (SearchOptionValue === 'INTERNAL_CLAIM_ID') {
                                                    loadComplaintPopUp(SearchVal, SearchOptionValue, PatientId);
                                                }
                                                else {
                                                    //to fix sonar
                                                }
                                            }
                                            else {
                                                //to fix sonar
                                            }
                                        }
                                        else {
                                            A11yAlerts.createWarningAlert('#GCHomeAlertAckMandatory', 'Alert acknowledgement is mandatory to access a member.');
                                        }
                                        $("#hdnTotalAlertsCount").val('');
                                        $("#hdnAcknowledgedAlertCount").val('');
                                        $('#popUpDialog3').html('');
                                        acknowledgedAlertIds = [];
                                    }
                                }
                            });
                        }
                        else {
                            if (Module === 'UM')
                                GetAuthDetails(SearchOptionValue, SearchVal);
                            else if (Module === 'AG') {
                                if (SearchOptionValue === 'COMPLAINT_ID') {
                                    GetComplaintDataByNumber(SearchVal);
                                }
                                else if (SearchOptionValue === 'INTERNAL_CLAIM_ID') {
                                    loadComplaintPopUp(SearchVal, SearchOptionValue, PatientId);
                                }
                                else {
                                    //to fix sonar issue
                                }
                            }
                            else {
                                //to fix sonar issue
                            }
                        }
                    },
                    error: function () {
                        CustomAlert("Error Encountered");
                    }
                });
                $('#hdnIsDropdownChange').val('');
            }
            else {
                CustomAlert("You Can't Access this Patient");
            }
        },
        error: function (err) {
            console.log(err);
        }
    });
}
//PROD-19169,19172 - End
function GetAuthDetails(SearchName, SearchValue, ActivityLogId) {
    umPreAuthInjectedDraft = false;
    umPreAuthInjectedAccTabs = { 2: false, 3: false, 4: false };
    umPreAuthDraftIconArmed = { 2: false, 3: false, 4: false };

    loader(1);
    $.ajax({
        type: "POST",
        url: baseURL + "/Authorization/GetAuthDetails?SearchValue=" + SearchValue + "&SearchName=" + SearchName,
        dataType: "json",
        success: function (data) {
            if (data.success && data.success == true) {
                isMAL = false;
                if ($("#MvcMainBody .InAuthPage").length === 0) {
                    $('#MvcMainBody').html('');
                }
                loader(0);
                var authRecord = data.val;
                if (SearchName === "SCA_ID") {
                    isRedirectToDecision[authRecord[0].AuthNo] = 1;
                }
                SetAuthDatanew(authRecord[0].PatientId, authRecord[0].AuthId, authRecord[0].ClassId, authRecord[0].AuthNo, ActivityLogId, authRecord[0].FirstName, authRecord[0].LastName);
            }
            else { CustomAlert("No records found"); loader(0); }
        },
        error: function () {
        }
    });
}
function GetComplaintDataByNumber(ComplaintRecordNo) {
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/GetComplaintDetailsByNumber?ComplaintRecordNo=" + ComplaintRecordNo,
        dataType: "json",
        success: function (data) {
            loader(0);
            if (data.success && data.success == true) {
                var DataItemVal = data.val;
                if (DataItemVal[0].Flag == 1) {
                    isMAL = false;
                    SetComplaintData(DataItemVal[0].PatientId, DataItemVal[0].ComplaintRecordId, DataItemVal[0].ComplaintTypeId, null, null, null);
                }
                else {
                    CustomAlert("You can not access this Complaint");
                }
            }
            else { CustomAlert("No records found"); }
        },
        error: function () {
        }
    });
}

function selectedDaysInAdlDays(parEle, haveWeeks) {
    var count = 0;
    var AddDays = $(parEle).find('#txtSrPlADays').val();
    var weekday = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    var Days = $(parEle).find('#ddlDayNameshdn').val();//Selected Days in Days DropDown
    Days = (Days != null && Days != "") ? Days.substring(0, Days.length - 1).split(',') : Days
    var Weeks = $(parEle).find('#txtSrPlWeeks').val();
    var fromDate = new Date($($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val());
    var calStartDate = fromDate;//
    if (haveWeeks == 1) {//haveWeeks = 1 means contain weeks,haveWeeks = 0 contain only additional Days
        var TotalDays = (Weeks * 7);
        TotalDays = TotalDays - 1;
        calStartDate = new Date(fromDate.setDate(fromDate.getDate() + TotalDays));
    }

    if (Days != null && Days.length > 0) {
        //If weeks had given our chacking should start from end date.So checking start from next day of end date.for this reason incrementing one
        //If weeks not given our chacking should start from Start Date.In this case checking start from StartDate.In below loop incrementing one day if we do like this Starting day will miss.so if weeks not avilable then decrementing one day to consider from StartDate

        if (haveWeeks == 0) {
            calStartDate = new Date(calStartDate.setDate(calStartDate.getDate() - 1));
        }
        for (var i = 0; i < AddDays; i++) {//Looping every day and checking this day is in selected days list
            calStartDate = new Date(calStartDate.setDate(calStartDate.getDate() + 1));
            var DayName = weekday[calStartDate.getDay()];//Getting day name of selected day
            var result = jQuery.inArray(DayName, Days);
            if (result != -1)
                count++;
        }
    }
    return count;
}

//Checking array has same values
function ArrayValuesAllEqual(arr) {
    for (var i = 0; i < arr.length - 1; i++) {
        if (arr[i] != arr[i + 1]) {
            return false;
        }
    }
    return true;
}

function GetFormattedDate(date) {
    var unFormattedDate = new Date(date);
    var month = unFormattedDate.getMonth() + 1; var day = unFormattedDate.getDate();
    FormattedDate = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + unFormattedDate.getFullYear();
    FormattedDate = new Date(FormattedDate).getTime();
    return FormattedDate
}

function ValForTmCrPlBaerForm() {
    let isValid = true;

    A11yForms.clearFormFieldValidation();
    isValid &= A11yForms.validateFormField('selTmCrPlBarrierType', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('txtTmCrPlBrerText', null, A11yForms.VALIDATIONS.REQUIRED);
    isValid &= A11yForms.validateFormField('selTmCrPlBarrierStatus', null, A11yForms.VALIDATIONS.REQUIRED);

    if (!isValid) {
        A11yAlerts.createErrorAlert('#barrierAlertMsg', null, true);
    }

    return isValid;
}

function onLOBDataBound($select) {
    if (globalLOBList == "") {
        $.ajax({
            type: "GET",
            url: baseURL + '/CarePlan/GetLOBDBDetails/',
            async: false,
            success: function (data) {
                globalLOBList = data;
                var optionsHtmlString = "";
                $select.html('');
                optionsHtmlString += '<option value="-1"> Select </option>';
                $.each(data, function (key, val) {
                    optionsHtmlString += '<option value="' + val.Value + '">' + val.Text + '</option>';
                });
                $select.AhsAppend(optionsHtmlString);
            }
        });
    } else {
        var optionsHtmlString = "";
        $select.html('');
        optionsHtmlString += '<option value="-1"> Select </option>';
        $.each(globalLOBList, function (key, val) {
            optionsHtmlString += '<option value="' + val.Value + '">' + val.Text + '</option>';
        });
        $select.AhsAppend(optionsHtmlString);
    };
}

function MergeServicePlanGrid(gridId) {
    var $gridId = $('#' + gridId);
    var tContent = $gridId.find('table tbody tr');
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    var mergeRow = 0; // 0 -> Auth Id column after a11y converted th index
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 2; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('th');
            $.each($currentTd, function (index, th) {
                $currentArray[index] = th.textContent;
            });

            var $prevTd = $(tContent[row + 1]).find('th');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, th) {
                    $prevArray[index] = th.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {
                if ($prevArray[mergeRow] == $currentArray[mergeRow] && ($.trim($prevArray[mergeRow]) !== 'N/A' && $.trim($currentArray[mergeRow]) !== 'N/A')) {
                    $.each($currentArray, function (index2, value) {
                        switch (index2) {
                            case mergeRow:
                                //Merging of columns should happen here
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                $($currentTd[index2]).addClass('brdAll');
                                break;
                            default:
                                $prevArray[index2] = value;
                                break;
                        }
                    });
                } else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
        }
    }
}

function codeSPRTTP() {
    var tl = $('.hOverCodeSPRCls');
    $.each(tl, function (key, itm) {

        var htmlStr = "";
        htmlStr += '<p><span style=font-weight:bold>Code</span></p>';
        if ($(itm).data('code') != null && $(itm).data('code') != '') {
            var y = $(itm).data('code');
            var x = y.toString().split(',');
            $.each(x, function (key, item) {
                htmlStr += '<div >' + item + '</div>';
            });
        } else {
            htmlStr += '<div >N/A</div>';
        };
        var pos1 = $(itm).offset();
        $(itm).aToolTip({
            tipContent: htmlStr
        });
    });
    //prod-1475
    if ($('#aToolTip').is(':visible')) {
        $('#aToolTip').hide();
    }
    //prod-1475
};

function codeSPATTP() {
    var tl = $('.hOverCodeSPACls');
    $.each(tl, function (key, itm) {

        var htmlStr = "";
        htmlStr += '<p><span style=font-weight:bold>Code</span></p>';
        if ($(itm).data('code') != null && $(itm).data('code') != '') {
            var y = $(itm).data('code');
            var x = y.toString().split(',');
            $.each(x, function (key, item) {
                htmlStr += '<div >' + item + '</div>';
            });
        } else {
            htmlStr += '<div >N/A</div>';
        };
        var pos1 = $(itm).offset();
        $(itm).aToolTip({
            tipContent: htmlStr
        });
    });
    //prod-1475
    if ($('#aToolTip').is(':visible')) {
        $('#aToolTip').hide();
    }
    //prod-1475
};
function codeSPRUBTTP() {
    var tl = $('.hOverUBSPRCls');
    $.each(tl, function (key, itmUB) {
        if ($(itmUB).data('code') != null && $(itmUB).data('code') != '') {
            var y = $(itmUB).data('code');
            var x = y.split(',');
            var htmlStr = "";
            $.each(x, function (key, itemUB) {
                if (key % 2 == 0) {
                    htmlStr += '<span style=font-weight:bold>' + itemUB + '</span>';
                } else {
                    if (itemUB != null) {
                        htmlStr += itemUB + '<p></p>';
                    } else {
                        htmlStr += 'N/A<p></p>';
                    };
                };
            });
        } else {
            htmlStr += '<div >N/A</div>';
        };
        var pos1 = $(itmUB).offset();
        $(itmUB).aToolTip({
            tipContent: htmlStr
        });
    });
    //prod-1475
    if ($('#aToolTip').is(':visible')) {
        $('#aToolTip').hide();
    }
    //prod-1475
};
function ValidationForExCrTm() {
    var msgcount = 0;
    $('#lblAddProviderStatus').html('');
    $('span.validationMessage').remove();
    if ($('#ddlExtCrTmRole').val() == -1) {
        msgcount = 1;
        $('#tdRoleCrTmExCrPr').closest('td').find('.requiredfields').show();
    } else {
        $('#tdRoleCrTmExCrPr').closest('td').find('.requiredfields').hide();
    }
    if ($('#ddlExtCrTmRoleForMember').val() == -1) {
        msgcount = 1;
        $('#tdRoleCrTmExCrPrFOrMember').closest('td').find('.requiredfields').show();
    } else {
        $('#tdRoleCrTmExCrPrFOrMember').closest('td').find('.requiredfields').hide();
    }
    if ($('#ExCrTmFormId #ProviderName').val() == "" && ($('#ExCrTmFormId #txtExtFirstName').val() == "" && $('#ExCrTmFormId #txtExtCrTmLastName').val() == "")) {
        CustomAlert('Please Enter Provider Name or First Name and Last Name');
        msgcount = 1;
        extCareTeamMandatoryFieldsToggle(true);
    } else {
        extCareTeamMandatoryFieldsToggle(false);
    }
    if ($('#ExCrTmFormId #ProviderName').val() == "" && ($('#ExCrTmFormId #txtExtFirstName').val() != "" && $('#ExCrTmFormId #txtExtCrTmLastName').val() == "")) {
        extCareTeamMandatoryFieldsToggle(false);
        $('#ExCrTmFormId #txtExtCrTmLastName').closest('td').find('.requiredfields').show();
        msgcount = 1;
    }
    if ($('#ExCrTmFormId #ProviderName').val() == "" && ($('#ExCrTmFormId #txtExtFirstName').val() == "" && $('#ExCrTmFormId #txtExtCrTmLastName').val() != "")) {
        extCareTeamMandatoryFieldsToggle(false);
        $('#ExCrTmFormId #txtExtFirstName').closest('td').find('.requiredfields').show();
        msgcount = 1;
    }
    if ($('#txtExtCrTmAPhone').val() != "") {
        if (!$('#txtExtCrTmAPhone').val().match(PhoneandFaxformat)) {
            $('#tdAltPhCrTmExCrPr').append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    }
    if ($('#txtExtCrTmCPhone').val() != "") {
        if (!$('#txtExtCrTmCPhone').val().match(PhoneandFaxformat)) {
            $('#tdAltPhCrTmExCrPrCPhone').append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    }
    if ($('#txtExtCrTmEmail').val() != "") {
        if (!ValidateEmail($('#txtExtCrTmEmail').val())) {
            $('#txtExtCrTmEmailMsg').append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    }
    var DateExppro = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20|21)\d{2}$/;
    var dateValidation = true; var fromDate = $('#txtExtCrTmFromDate').val(); var toDate = $('#txtExtCrToDate').val();
    //uhg-3283
    if (fromDate == '') {
        $('.requiredfields.clsExtCrTmFromDate').css({ 'font-size': 'Large', 'font-weight': 'bold' });
        $('.requiredfields.clsExtCrTmFromDate').text('*');
        $('.requiredfields.clsExtCrTmFromDate').show();
        dateValidation = false;
    }
    else {
        $('.requiredfields.clsExtCrTmFromDate').hide();

    }
    if (fromDate.length > 0) {
        $('.requiredfields.clsExtCrTmFromDate').show();
        $('.requiredfields.clsExtCrTmFromDate').css({ 'font-size': 'small', 'font-weight': 'normal' });
        if (!funisValidDate(fromDate, '1')) {
            $('.requiredfields.clsExtCrTmFromDate').text('Invalid date');
            dateValidation = false;
        }
        else if (!fromDate.match(DateExppro)) {
            $('.requiredfields.clsExtCrTmFromDate').text('Invalid format');
            dateValidation = false;
        }
        else {
            $('.requiredfields.clsExtCrTmFromDate').hide();
        }
    }
    if (toDate.length > 0) {
        $('.requiredfields.clsExtCrTmToDate').show();
        $('.requiredfields.clsExtCrTmToDate').css({ 'font-size': 'small', 'font-weight': 'normal' });
        if (!funisValidDate(toDate, '0')) {
            $('.requiredfields.clsExtCrTmToDate').text('Invalid date');
            dateValidation = false;
        }
        else if (!toDate.match(DateExppro)) {
            $('.requiredfields.clsExtCrTmToDate').text('Invalid format');
            dateValidation = false;
        }
        else {
            $('.requiredfields.clsExtCrTmToDate').hide();
        }
    }
    if (fromDate.length > 0 && dateValidation == false) {
        msgcount = 1;
    }
    if (toDate.length > 0 && dateValidation == false) {
        msgcount = 1;
    }
    if ($.trim(toDate) != "" && dateValidation == true) {
        var StartDate = new Date($('#txtExtCrTmFromDate').val());
        var EndDate = new Date($('#txtExtCrToDate').val());
        if (StartDate > EndDate) {
            CustomAlert('Start Date should be less than or equal to End Date');
            msgcount = 1;
        }
    }
    if ($('#txtExtCrTmZip').val()) {
        $('#spanZipMessage').remove();
        if (!$('#txtExtCrTmZip').val().match(WorkZipExp)) {
            msgcount = 1;
            $('#txtExtCrTmZip').closest('td').append('<span class=validationMessage id=spanZipMessage style=color:red;Font-weight:Bold;><br/>Please enter a valid zip code of 5 or 9 digits.</span>');
        }
    }
    if (!$('#trNewProviderAddress').is(':hidden') && !ValidationForExCrTmMulAdrs()) {
        msgcount = 1;
    }
    if (msgcount == 1 || dateValidation == false) {
        $('#btnExCrTmSave').removeAttr('disabled');
        return false;
    }
    else {
        return true;
    }
}

function getIcdVersion(Startdate, IcdDate, IcdCode, VersionHide, ErrorMess, TypeHealth, VersionOnDates) {
    var msgcount = true;
    var pardata = { icdCode: IcdCode, VersionICD: VersionOnDates };
    $.ajax({
        url: baseURL + "/Health/FindVersionBasedOnCode",
        dataType: "json",
        type: "POST",
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(pardata),
        async: false,
        processData: false,
        cache: false,
        success: function (data) {
            if ((new Date(Startdate) > new Date(IcdDate) && data.value !== 10) || (new Date(Startdate) <= new Date(IcdDate) && data.value !== 9)) {
                if (TypeHealth === "Visits") {
                    A11yAlerts.createErrorAlert('#' + ErrorMess, 'Choose valid ICD Codes based on the service dates.');
                    msgcount = false;
                } else if (TypeHealth === "UnfiedMedicationDiagnosis") {
                    msgcount = false;
                } else {
                    A11yAlerts.createErrorAlert('#' + ErrorMess, 'Choose valid ICD codes based on the visit date.');
                    msgcount = false;
                }
            }
            $('#' + VersionHide).val(data.value);
        },
        error: function (xhr) {
            msgcount = false;
        }
    });
    return msgcount;
}

function onICDTTP() {
    var tl = $('.hOverPrimaryDiagDescVProfileCls');
    $.each(tl, function (key, itm) {
        var htmlStr = "";
        htmlStr += '<p><span style=font-weight:bold>ICD Code Description</span></p>';
        if ($(itm).data('code') != null && $(itm).data('code') != '') {
            var y = $(itm).data('code');
            var x = y.split('$');
            $.each(x, function (key, item) {
                htmlStr += '<div >' + (key + 1) + '. ' + item + '</div>';
            });
        } else { htmlStr += '<div >N/A</div>'; }
        var pos1 = $(itm).offset();
        $(itm).aToolTip({ tipContent: htmlStr });
    });
}
function ActiveInteractionCollection(actIntList) {
    var htm = "";
    if (actIntList.length > 0) {
        $.each(actIntList, function (key, item) {
            htm += '<tr><td><p><b>';
            if (item.IsSLevelVisible) {

                htm += '<span>' + item.PrimaryDesc + '</span>';
            }
            if (item.IsDrugDetailVisible) {
                htm += '<span class="primaryColor" data-pndc="' + item.PrimaryNdc + '"data-rndc="' + item.RelatedNdc + '" style="text-underline-position:below">' + item.PrimaryDesc + '</span>';
            }
            htm += '</b>' + ' ' + 'interact with <b>' + item.RelatedDesc + '</b>.';


            if (item.IsSLevelVisible) {
                htm += '<span>Severity:</span> <b><span>' + item.SLevel + '</span></b>';
            }
            htm += '<b>- Active Ingredient</b> </p> </td> </tr>';
        });

    }

    return htm;
}
function DrugDiseaseInteractionCollection(actIntList) {
    var htm = "";
    if (actIntList.length > 0) {
        $.each(actIntList, function (key, item) {

            //htm += '<tr><td><p><b>';

            //htm += item.Ln + '</b>' + item.PrimaryNdc + ' ' + 'is contraindicated when <b>' + item.RelatedDesc + '</b>' + 'is related to <b>' + item.PrimaryDesc + '</b>' + ', which appears as an inferred indication.';

            htm += '<tr><td><p>' + item.ContraindicationAlert + '</p> </td> </tr>';
            if (item.SLevel == "1")
                IsSlevel1 = true;
        });

    }
    //htm += ' </p> </td> </tr></table></div>';
    return htm;
}
function DuplicateInteractionCollection(actIntList) {
    var htm = "";
    htm += '<div ><span>Therapeutic Duplication Interactions</span>  </div><div class="tdSpace"></div><div id="MemberIdentifiersDiv" style="width: 96%; margin-top: 8px;"><table border="0" cellpadding="0" cellspacing="0" width="98%" style="margin: 5px;" class="DBGrid">';
    htm += '<tr><th scope="col">Therapeutic Duplication Details</th></tr>';
    if (actIntList.length > 0) {
        $.each(actIntList, function (key, item) {

            htm += '<tr><td><p><b>';

            htm += item.Ndc1Name + '</b>' + item.Ndc1 + ' ' + 'are members of the class <b>' + item.DptClassDesc + '</b>';
        });
        htm += ' </p> </td> </tr>';
    }
    htm += ' </table></div>';
    return htm;
}

function ActiveInactiveInteractionCollection(actIntList) {
    var htm = "";
    if (actIntList.length > 0) {
        $.each(actIntList, function (key, item) {

            htm += '<tr><td><p><b>';
            if (item.IsSLevelVisible) {

                htm += '<span>' + item.PrimaryDesc + '</span>';
            }
            if (item.IsDrugDetailVisible) {
                htm += '<span class="primaryColor" data-pndc="' + item.PrimaryNdc + '"data-rndc="' + item.RelatedNdc + '" style="text-underline-position:below">' + item.PrimaryDesc + '</span>';
            }
            htm += '</b>' + ' ' + 'interact with <b>' + item.ShicDesc + '</b>' + ', an inactive ingredient in' + '<b>' + item.RelatedDesc + '</b>';


            if (item.IsSLevelVisible) {
                htm += '<span>Severity:</span> <b><span>' + item.SLevel + '</span> Active - Inactive Ingredient</b>';
            }
            htm += '<b>- Active - Inactive Ingredient</b> </p> </td> </tr>';
        });

    }

    return htm;
}

function InactiveInteractionCollection(actIntList) {
    var htm = "";
    if (actIntList.length > 0) {
        $.each(actIntList, function (key, item) {

            htm += '<tr><td><p><b>';
            if (item.IsSLevelVisible) {
                htm += '<span>' + item.PhicDesc + '</span>';
            }
            if (item.IsDrugDetailVisible) {
                htm += '<span class="primaryColor" style="text-underline-position:below">' + item.PhicDesc + '</span>';
            }
            htm += '</b>' + ' ' + 'an inactive ingredient in <b>' + item.PrimaryDesc + '</b>' + ', interact with' + '<b>' + item.ShicDesc + '</b> an inactive ingredient in <b>' + item.RelatedDesc + '</b>.';
            if (item.IsSLevelVisible) {
                htm += '<span>Severity:</span> <b><span>' + item.SLevel + '</span></b>';
            }
            htm += '<b>- Inactive Ingredient</b> </p> </td> </tr>';
        });

    }

    return htm;
}

function TmCrPlShHdBtn(cat, leng) {
    var notesIconShw;
    if (roleConfig != null && roleConfig.length != 0) {
        notesIconShw = $.greproleext(roleConfig, function (ele, _ind) {
            return ele.UniqueName === "AHS_CM_CPL_NOTES";
        });
    } // To display notes button in care plan section based on role
    $('.CrplTmCrPlBtnShHdCls').hide();
    $('#btnCrPlRvwNotification').hide();
    var allChkBoxChkdChBxCrTm = $('#TmCrPlRecAndCurGroupGrid table input[type="checkbox"]:checked').not('.clsChkCrPlTmCrPlHead,.clsChkCPSignOff');
    var isRecommendedExistsVal = false;
    $.each(allChkBoxChkdChBxCrTm, function () {
        if (($(this).data('catname') || '').toUpperCase() === "RECOMMENDED") {
            isRecommendedExistsVal = true;
            return false;
        }
    });
    $('#actionMenu-phOnly').show();
    $('.cplRestore').hide();
    switch (cat) {
        case "RECOMMENDED":
            $('.cplAdd').show();
            $('.cplDelete').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('.ToggleSignNew').show();
            $('#btnCrPlTmCrPlCarePlanHistory').show();
            $('.cpChngStatus').show();
            $('.cpChngPriority').show();
            if (notesIconShw != undefined && notesIconShw.length > 0) {
                if (notesIconShw[0].IsView != false) {
                    if (notesIconShw[0].IsAdd != true) {
                        $('.careplan-notesNew').show();
                        $('.careplan-notesNew').attr('title', 'You do not have access to Add Notes');
                    }
                    else {
                        $('#btnCrPlTmCrPlGroupNotes').show();
                    }
                }
            } else
                $('#btnCrPlTmCrPlGroupNotes').show();
            $('.cpChngStatus').show();
            $('#SignOffText').html('Sign Off');
            $('.cntxtSignOff').prop('value', 'Sign Off');
            break;
        case "CURRENT":
            $('#SignOffText').html('Undo Sign Off');
            $('.cntxtSignOff').val('Undo Sign Off');
            $('.cplAdd').show();
            $('.cplDelete').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('.ToggleSignNew').show();
            $('.cplEmail').show();
            $('#btnCrPlTmCrPlCarePlanHistory').show();
            $('.cpChngStatus').show();
            $('.cpChngPriority').show();
            $('#btnCrPlTmCrPlAddGrpActivity').show();
            if ($('#hdnIsCrPlvwNotificationAvailable').val() == '1') //PROD-7498
                $('#btnCrPlRvwNotification').show();
            if (notesIconShw != undefined && notesIconShw.length > 0) {
                if (notesIconShw[0].IsView != false) {
                    if (notesIconShw[0].IsAdd != true) {
                        $('.careplan-notesNew').show();
                        $('.careplan-notesNew').attr('title', 'You do not have access to Add Notes');
                    }
                    else {
                        $('#btnCrPlTmCrPlGroupNotes').show();
                    }
                }
            } else
                $('#btnCrPlTmCrPlGroupNotes').show();
            break;
        case "COMPLETED":
            $('.cplAdd').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('#btnCrPlTmCrPlCarePlanHistory').show();
            $('#btnCrPlTmCrPlAddGrpActivity').show();
            $('#actionMenu-phOnly').hide();
            break;
        case "DELETED":
            $('.cplAdd').show();
            $('.cplRestore').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('#btnCrPlTmCrPlCarePlanHistory').show();
            $('#actionMenu-phOnly').hide();
            break;
        case "UAS":
            $('.cplDelete').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('.ToggleSignNew').show();
            break;
        default:
            var gridName = '#TmCrPlRecAndCurGroupGrid';
            if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
                gridName = '#TmCrPlRecAndCurGroupListView';
            }
            if ($(gridName).find('.current').length > 0 && $('#hdnIsCrPlvwNotificationAvailable').val() === '1' && !isRecommendedExistsVal) //PROD-7498
            {
                $('.cpActionContainer  #btnCrPlRvwNotification').show();
            }
            else {
                $('#btnCrPlRvwNotification').hide();
            }
            $('.cplAdd').show();
            $('.cplDelete').show();
            $('#btnCrPlTmCrPlMyCarePlan').show();
            $('.ToggleSignNew').show();
            $('#btnCrPlTmCrPlCarePlanHistory').show();
            $('.cplEmail').show();
            $('.cpChngStatus').show();
            $('.cpChngPriority').show();
            if (notesIconShw != undefined && notesIconShw.length > 0) {
                if (notesIconShw[0].IsView != false) {
                    if (notesIconShw[0].IsAdd != true) {
                        $('.careplan-notesNew').show();
                        $('.careplan-notesNew').attr('title', 'You do not have access to Add Notes');
                    }
                    else {
                        $('#btnCrPlTmCrPlGroupNotes').show();
                    }
                }
            } else
                $('#btnCrPlTmCrPlGroupNotes').show();
            break;
    }
    if (leng && leng >= 2) {
        $('.cplAdd').hide();
        $('#btnCrPlTmCrPlMyCarePlan').hide();
        $('#btnCrPlTmCrPlCarePlanHistory').hide();
    }
    else if (leng && leng == 1) {
        $('.cplAdd').hide();
        $('#btnCrPlTmCrPlMyCarePlan').hide();
    }
    EmailConfigApply({ SectionName: "Team Care Plan", ClassName: ".cplEmail" });
}
/*Context menu visibility*/
function TmCrPlMenuDisEnb(obj, hiddenVal) {
    var $EditCP = $('#btnCrPlTmCrPlVisibleEditCP');
    var $ReOpenCP = $('#btnCrPlTmCrPlReOpen');
    var $AddBarrier = $('#btnCrPlTmCrPlAddBarrier');
    var $AddActivity = $('#btnCrPlTmCrPlAddActivity');
    var $AddStrengths = $('#btnCrPlTmCrPlAddStrengths');
    var $ActivityHistory = $('#btnCrPlTmCrPlActivityHistory');
    var $HistoryDetails = $('#btnCrPlTmCrPlHistoryDetails');
    var $Notes = $('#btnCrPlTmCrPlNotes');
    var $SignOff = $('#btnCrPlTmCrPlSignOff');
    var $RunScript = $('#btnCrPlTmCrPlRunScript');
    var $AppointmentDetails = $('#btnCrPlTmCrPlAppointmentDetails');
    var $ViewDetails = $('#btnCrPlTmCrPlMultiView');
    var TargetedIntervention = $('#btnCrPlTmCrPlTargeterdIntervention'); //UHC-4324
    var $AddIntervention = $("#btnAddIntervention");
    $EditCP.prop('disabled', false);
    $ReOpenCP.prop('disabled', false);
    $AddBarrier.prop('disabled', false);
    $AddStrengths.prop('disabled', false);
    $ActivityHistory.prop('disabled', false);
    $HistoryDetails.prop('disabled', false);
    $Notes.prop('disabled', false);
    $SignOff.prop('disabled', false);
    $RunScript.prop('disabled', false);
    $AppointmentDetails.prop('disabled', false);
    $ViewDetails.prop('disabled', false);
    $AddIntervention.prop('disabled', false);
    TargetedIntervention.prop('disabled', true); //UHC-4324
    switch (obj) {
        case "RECOMMENDED":
            $ReOpenCP.prop('disabled', true);
            $AddBarrier.prop('disabled', true);
            $AddStrengths.prop('disabled', true);
            $ViewDetails.prop('disabled', true);
            $ActivityHistory.prop('disabled', true);
            globalCplCategory = "Recommended";
            break;
        case "CURRENT":
            globalCplCategory = "CURRENT";
            $ReOpenCP.prop('disabled', true);
            TargetedIntervention.prop('disabled', false); //UHC-4324
            break;
        case "CLOSED":
        case "COMPLETED":

            $EditCP.prop('disabled', true);
            $HistoryDetails.prop('disabled', false);
            $SignOff.prop('disabled', true);
            $RunScript.prop('disabled', true);
            $AddIntervention.prop('disabled', true);
            globalCplCategory = "COMPLETED";
            break;
        case "DELETED":
            $EditCP.prop('disabled', true);
            $ReOpenCP.prop('disabled', true);
            $AddBarrier.prop('disabled', true);
            $AddStrengths.prop('disabled', true);
            $AddActivity.prop('disabled', true);
            $ViewDetails.prop('disabled', true);
            $ActivityHistory.prop('disabled', true);
            $Notes.prop('disabled', true);
            $SignOff.prop('disabled', true);
            $RunScript.prop('disabled', true);
            $AppointmentDetails.prop('disabled', true);
            $AddIntervention.prop('disabled', true);
            globalCplCategory = "DELETED";
            break;
        case "UAS":
            $EditCP.prop('disabled', true);
            $ReOpenCP.prop('disabled', true);
            $AddBarrier.prop('disabled', true);
            $AddStrengths.prop('disabled', true);
            $ViewDetails.prop('disabled', true);
            $AddActivity.prop('disabled', true)
            $Notes.prop('disabled', true);
            $SignOff.prop('disabled', true);
            $RunScript.prop('disabled', true);
            $AppointmentDetails.prop('disabled', true);
            $HistoryDetails.prop('disabled', true);
            $AddIntervention.prop('disabled', true);
            globalCplCategory = "UAS";
            break;

    }
    DisableEnableCntxtmenuItems(obj);
}
//function to disable context menu links based on roles permissions
function DisableEnableCntxtmenuItems(categoryName) {
    var isMtmIntervention = false;
    let uniqueCarePlanName = "AHS_CM_TEAM_CARE_PLAN";
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; }
    if (isFromUM === "True") {
        uniqueCarePlanName = "AHS_UM_QUICK_LINKS_CARE_PLAN";
    }
    switch (categoryName) {
        case "RECOMMENDED":
        case "CURRENT":
            if (isMtmIntervention) {
                $('#btnCrPlTmCrPlVisibleEditCP').ApplyRoleConfig({ Id: "btnCrPlTmCrPlVisibleEditCP", UniqueName: "AHS_MTM_INTERVENTIONS", IsFrom: "Edit", IsRemoveElement: false });
                $('#btnCrPlTmCrPlSignOff').ApplyRoleConfig({ Id: "btnCrPlTmCrPlSignOff", UniqueName: "AHS_MTM_INTERVENTIONS", IsFrom: "Edit", IsRemoveElement: false });
            }
            else {
                $('#btnCrPlTmCrPlVisibleEditCP').ApplyRoleConfig({ Id: "btnCrPlTmCrPlVisibleEditCP", UniqueName: uniqueCarePlanName, IsFrom: "Edit", IsRemoveElement: false });
                $('#btnCrPlTmCrPlSignOff').ApplyRoleConfig({ Id: "btnCrPlTmCrPlSignOff", UniqueName: uniqueCarePlanName, IsFrom: "Edit", IsRemoveElement: false });
            }
            $('#btnCrPlTmCrPlRunScript').ApplyRoleConfig({ Id: "btnCrPlTmCrPlRunScript", UniqueName: uniqueCarePlanName, IsFrom: "Add", IsRemoveElement: false });
        case "CLOSED":
        case "COMPLETED":
            var roleLevelConfigs = $.greproleext(roleConfig, function (ele, _ind) {
                return ele.UniqueName === uniqueCarePlanName;
            });
            if (roleLevelConfigs !== null && roleLevelConfigs.length > 0 && (roleLevelConfigs[0].IsAdd || roleLevelConfigs[0].IsEdit)) {
                $(".cpAddActivity").prop('disabled', false);
            }
            else {
                $(".cpAddActivity").prop('disabled', true);
            }
            break;
    }
}

/*Clear datasource of grid*/
function ClearGrid(id, isClear) {
    var $gridId = ["#TmCrPlCarePlanGrid", "#UASScript"];
    if (isClear) {
        $.each($gridId, function (index, val) {
            if (val != id) {
                $(val).data("kendoGrid").dataSource.data([]);
            }
        });
    }
}

function SendMailToExCrTm(keyid, PatientphysicianID) {
    if ($.trim($('#ExCrTmFormId #ProviderName').val()) != "" || $.trim($('#ExCrTmFormId #txtExtFirstName').val() + " " + $('#ExCrTmFormId #txtExtCrTmLastName').val()) != "") {
        var datastring = { toAddress: $('#ExCrTmFormId #txtExtCrTmEmail').val(), provName: $('#ExCrTmFormId #ProviderName').val() == "" ? $('#ExCrTmFormId #txtExtFirstName').val() + " " + $('#ExCrTmFormId #txtExtCrTmLastName').val() : $('#ExCrTmFormId #ProviderName').val(), PatientPhysicianID: PatientphysicianID }
        loader(1);
        $.ajax({
            type: "GET",
            url: baseURL + "/CareTeam/SendEmailExtCareTeam?Pid=" + keyid,
            data: datastring,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                if (data.success) {
                    CustomAlert('Email has been sent successfully to the Provider!');
                }
                loader(0);
            },
            error: function () {
                CustomAlert('Email has not been sent to the Provider');
                loader(0);
            }
        });
    }
}
function submitCrPlTmCrPlFrm() {
    $('#dvViewNotes').html('');
    var isMtmIntervention = false;
    var previousAssignOwner = $('#hdnAssignOwner').val();
    var activityPopup = false;
    modifyCrPlPopUpBtnId();
    $('#btnCrPlTmCrPlSave').prop("disabled", true);
    $("#lblAddProviderStatus").html('');
    $('span.error_text').removeClass('error_text');
    $('.validationMessages').remove();
    $('.clsIntEndDate,.clsIntStartDate').trigger('change');
    $('.valueRequired').removeAttr('style').removeClass('valueRequired');
    var lobBenId = $('#LobBenId').val() === '' ? $('#selCrPlTmLobId1 .memberEligibility.active').attr('data-lobbenid') : $('#LobBenId').val();
    var memBenfPlanId = $('#MemBenfPlanId').val() === '' ? $('#selCrPlTmLobId1 .memberEligibility.active').attr('data-membenfplanid') : $('#MemBenfPlanId').val();
    var isCPOrphan = $.fn.setFalseOnUndefinedOrNull($('#hdnCPIsOrphan').val());
    if (valForCrPlFormTmCrPl("UPDATE", true, isCPOrphan)) {
        loader(1);
        var datastring = "LobBenId=" + lobBenId + "&MemBenfPlanId=" + memBenfPlanId + "&ConditionId=" + $('#hdnEditSelectConditionId').val();
        datastring += "&OppId=" + $('#hdnEditSelectOpportunityId').val() + "&CarePlanId=" + $('#CarePlanId').val() + "&SourceTypeId=" + $('#SourceTypeId').val();
        datastring += "&GoalGroupId=" + $('#hdnEditSelectGoalGroupId').val() + "&GoalName=" + $('#selCrPlTmGoalId').val() + "&GoalId=" + $('#hdnEditSelectGoalId').val();
        datastring += "&InterventionName=" + $('#InterventionName').val() + "&InterventionId=" + $('#InterventionId').val();
        datastring += "&StartDate=" + $("#txtCrPlTmStartDate").val() + "&EndDate=" + $("#txtCrPlTmEndDate").val() + "&StatusId=" + $('#selCrPlTmStatusId').val();
        datastring += "&CarePlanNotes=" + encodeURIComponent($('#txtBoxNotes #txtNotes').val());
        var noteConfidentialTypeId = $('#formCrPlAddTmCrPl').find('[name*=NoteConfidentialTypeId]:checked').val() || 1;
        datastring += "&NoteConfidentialTypeId=" + noteConfidentialTypeId + "&IsOrphan=" + isCPOrphan;
        var IsIntervAddedManually = $("#txtCrPlTmIntervention").is(":visible");
        var IsGoalAddedManually = $("#txtCrPlTmGoal").is(":visible");
        $('#formCrPlAddTmCrPl select[disabled]').each(function () {
            datastring = datastring + '&' + $(this).attr('name') + '=' + $(this).val();
        });
        var assinOwner = '';

        if ($('#selCrPlTmAssignOwner').val() != '-1' && $('#selCrPlTmAssignOwner').val() != '' && $('#selCrPlTmAssignOwner').val() != null) {
            assinOwner = $('#selCrPlTmAssignOwner').val();
            assignOwnercareStaffFullNameWithRole = $('#selCrPlTmAssignOwner :selected').text();
            assignOwnermemberidval = $('#selCrPlTmAssignOwner').val();
        }
        else {
            assinOwner = '';
        }
        if (assinOwner == previousAssignOwner || assinOwner.length < 1)
            activityPopup = false;
        else
            activityPopup = true;
        if ($('#selCrPlTmGoalGroupId option:selected').text().toLowerCase() == 'mtm goal group') { isMtmIntervention = true; }
        var ruleOgiObject = { eventSource: "CMOGIUPDATE", parentConrolId: "", moduleName: "CM", eventType: "PRE", ogis: ruleUpdateOgiDetailsList(), memBenfPlanId: memBenfPlanId };
        var ruleOgiResponse = ficoRealTimeValidation(ruleOgiObject);
        var isRuleHardValidation = CheckValidationMessages(ruleOgiResponse);
        if (isRuleHardValidation) {
            $('#btnCrPlTmCrPlSave').removeProp("disabled");
            loader(0);
            return;
        }
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/EditCarePlan?isGoalVsbl=" + $('#txtCrPlTmGoal').is(':hidden') + "&isIntvVsbl=true"
                + "&stausId=" + $('#selCrPlTmStatusId').val() + "&isIntvManual=" + IsIntervAddedManually
                + "&isGoalManual=" + IsGoalAddedManually + "&assignOwner=" + assinOwner + "&mtmIntervention=" + isMtmIntervention + "&patientId=" + $('#selectPatientAccessed').val(),
            data: datastring,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $.ajaxSetup({ async: false });
                    $('#TeamCarePlanChildDiv').show();
                    $('#TeamCarePlanAddOrEditDiv').hide();
                    $('#divCarePlanOverview').show();
                    $("#hdnCrPlTmCrPlEditCrPlId").val('');
                    if (isMtmIntervention) { $('.mtmTabSection').show(); }
                    $.ajaxSetup({ async: true });
                    if (data.oppId > 0) {
                        var url = baseURL + "/CarePlan/ResolveGuidingOpportunityFromTCP?CareOpportunityId=" + data.oppId
                        $("#popUpDialog2").html('');
                        $('#popUpDialog2').CMNPopup({
                            pvUrl: url,
                            onLoad: function () {
                                logPatientMismatch(data.patientIdPassed, "CarePlanController.cs - EditCarePlan", datastring, data.patientIdInSession); //UHC-4434
                            },
                            popUpHeader: "Resolve",
                            popLevel: 1
                        });
                    }
                    else {
                        commonIconStyleStatusMsgDisplay('CarePlanSuccessMessage', data.msg, 3000);
                    }
                    $('#atlEditCarePlan').remove();
                    if ($('#selCrPlTmAssignOwner').val() != '-1' && $('#selCrPlTmAssignOwner').prop('disabled') == false && activityPopup) {
                        $().ConfirmationBox({
                            Title: 'ASSIGN ACTIVITY', Top: 180, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                            Content: "Care Plan has been assigned successfully. Do you want to send an activity to inform the assignee?"
                        }, function (response) {
                            $("#ConfirmPopup_Div").hide();
                            if (response) {
                                AddActivityOnCarePlan(data.careplanId);
                            }
                            commonIconStyleStatusMsgDisplay('CarePlanSuccessMessage', 'Assigned successfully.', 3000);
                            $('#btnAssignOwnerCancel').trigger('click');
                            gridShowHideCarePlan(1, 0);
                            logPatientMismatch(data.patientIdPassed, "CarePlanController.cs - EditCarePlan", datastring, data.patientIdInSession); //UHC--4434

                        });
                    }
                    else {
                        gridShowHideCarePlan(1, 0);
                    }
                }
                else {
                    commonIconStyleStatusMsgDisplay('CarePlanErrorMessage', data.msg, 3000);
                    $('#btnCrPlTmCrPlSave').removeProp("disabled");
                }
                loader(0);
                if ((data.oppId == 0 || data.oppId == undefined)) {
                    logPatientMismatch(data.patientIdPassed, "CarePlanController.cs - EditCarePlan", datastring, data.patientIdInSession);
                }
            },
            error: function () {
                $('#btnCrPlTmCrPlSave').removeProp("disabled");
                loader(0);
            }
        });
    }
    else {
        $('#btnCrPlTmCrPlSave').removeProp("disabled");
        commonIconStyleStatusMsgDisplay('CarePlanErrorMessage', "Enter mandatory field(s).", 3000);
        if ($('#selCrPlTmLobId1 .memberEligibility.active').length === 0) {
            CmnStatusMessageDisp('divCarePlanErrorMessageEligibility', "Please select any Active/Inactive eligibility on the member once to save the OGI.");
        }
    }
}

function ruleUpdateOgiDetailsList() {
    var eligibilityDetails = {
        startDate: $('#txtCrPlTmStartDate').val(),
        endDate: $('#txtCrPlTmEndDate').val(),
        status: $('#selCrPlTmStatusId').find(':selected').text()       
    };
    return [eligibilityDetails];
}
function funActiveScriptVersionFlow(scriptidval, patId, scptredval, scptcheckval, scptlastrunScript, formLastRunStatus, hasScriptForm, patientFollowUpId, formId, isCompletePendingActivity, sfId) {
    if (patId == 0) {
        if (scptredval == "true" && scptcheckval == 6) {//new script and mode as forms
            $('#hdnScMode').val(1);
            $('#tblScMode').show();
            $('#trCareActivityType').show();//gfid-815
        }
        else if (scptredval == "false" && scptcheckval == 6) {
            var scriptFormId = $('#ddlScriptsmvc option:selected').attr('id');
            $('#closePopUp').trigger('click');
            if ($('#popUpDialog2').is(':visible'))
                $('#popUpDialog2 #closePopUp').trigger('click');
            CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|");
            $('#tblDecision').hide();
            $('#tblSrMode').hide();
            $('#tblScMode').hide();
        }
        else if (scptredval == "true" && scptcheckval == 5) {
            closeAssessmentPopUpWindow();
            CallAllCtrls(2, scptcheckval, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', scriptidval, '800');
        }
        else if (scptredval == "true" && scptcheckval == 3) { $('#tblDecision').show(); }
        else if (scptredval == "false" && scptcheckval == 4 && (scptlastrunScript == null || scptlastrunScript == "" || scptlastrunScript == "0")) {
            $('#tblDecision').hide(); $('#tblSrMode').show(); $('#trCareActivityType').show(); showValidationIfScptScheduled();
        }//gfid-815 
        else if (scptredval == "false" && (scptcheckval == 4 || scptcheckval == 5)) {
            $('#tblDecision').hide();
            $('#tblSrMode').hide();
            $('#trCareActivityType').hide();//gfid-815
            if (scriptPerformActivityData) {
                CompleteActivityAS(scriptPerformActivityData);
                scriptPerformActivityData = undefined;
            }
            if ($("#hdnPHRunScriptMemberId").val() !== undefined && $("#hdnPHRunScriptMemberId").val() !== null && $("#hdnPHRunScriptMemberId").val().length > 0) {
                var patID = $("#hdnPHRunScriptMemberId").val();
                setpatinfo(patID);
                setactionitems();
                $('#lnkMemberInfo, #memberInfoMenu').show();
            }
            $('#closePopUp').trigger('click');
            closeAssessmentPopUpWindow();
            CallAllCtrls(2, scptcheckval, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', scriptidval, '800');
        }
    }
    else {
        if (scptredval == "false" && scptcheckval == 6) {
            setpatinfo(patId);
            if (scriptPerformActivityData) { CompleteActivityAS(scriptPerformActivityData); scriptPerformActivityData = undefined; }
            $('#closePopUp').trigger('click');
            if ($('#popUpDialog2').is(':visible'))
                $('#popUpDialog2 #closePopUp').trigger('click');
            CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', sfId + "|" + "|" + 0 + "|");
            LoadMemberSummaryMenu(null, null); if (formId != 0 && isCompletePendingActivity) { $("#MvcMainBody").html(''); }
        }
        else if (scptredval == "false" && scptcheckval == 4 && (scptlastrunScript == null || scptlastrunScript == "" || scptlastrunScript == "0")) {
            // $('#tblSrMode').show();
            //Script is in single mode(Eaither single or WorkFlow)
            callingRunScriptPopupActOutcome(patientFollowUpId, isCompletePendingActivity);
        }
        else if (scptredval == "false" && (scptcheckval == 4 || scptcheckval == 5) && hasScriptForm == "0") {
            //if (scptredval == "false" && scptcheckval > 0) {
            //Script is in Pending State so Redirecting to Script page
            //PROD-144224 - to display "Quick access menu" and "Member Info" icons
            if (patId !== null && patId !== '' && patId > 0) {
                setpatinfo(patId);
                $('#lnkMemberInfo, #memberInfoMenu').show();
            }
            if (scriptPerformActivityData) {
                if (scriptPerformActivityData.isReview === 0) {
                    scriptPerformActivityData["isReview"] = false;
                }
                CompleteActivityAS(scriptPerformActivityData);
                scriptPerformActivityData = null;
            }
            closeAssessmentPopUpWindow();
            CallAllCtrls(2, scptcheckval, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', '', '800');

        }
        else if ((scptredval == "false" && hasScriptForm == "1" && formLastRunStatus == "0") || (scptredval == "true" && formLastRunStatus == "0")) {//Script and Form both are not in New status
            //Script is running in first time We need to open Activity OutCome PopUp
            callingRunScriptPopupActOutcome(patientFollowUpId, isCompletePendingActivity);
        }
        else if (formLastRunStatus == "1") {//Form related to that script is pending so Redirecting to Forms Page
            setpatinfo(patId);
            if (scriptPerformActivityData) { CompleteActivityAS(scriptPerformActivityData); scriptPerformActivityData = undefined; }
            closeAssessmentPopUpWindow();
            CallAllCtrls(2, 3, "~/App_Pages/CM/Manage/DocumentsAndForms.ascx", formId, '1170');
            LoadMemberSummaryMenu(null, null); if (formId != 0 && isCompletePendingActivity) { $("#MvcMainBody").html(''); }
        }
    }
}

function callingRunScriptPopupActOutcome(patientFollowUpId, isCompletePendingActivity) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/ActivityOutcome?ActId=" + patientFollowUpId + "&IsCompletePendingActivity=" + isCompletePendingActivity,
        popUpHeader: "Run Script",
        popLevel: 1,
        onClose: function () {
            scriptPerformActivityData = null;
            if ($('#dBADT.TabbedPanelsTab.TabbedPanelsTabSelected').length > 0) {
                if ($('#ddlPHIPNotifications').val() === 'ADT' && $('#ADTrackingGridDiv').is(':visible')) {
                    $("#ADTrackingGrid").data("kendoGrid").dataSource.read();
                }
                else {
                    if ($('#ddlPHIPNotifications').val() === 'IP Notifications' && $('#PHIPNotificationsGridDiv').is(':visible')) {
                        $("#PHIPNotificationsGrid").data("kendoGrid").dataSource.read();
                    }
                }
            }
        },
        onLoad: function () {
            $("#activityoutcomeForm").scrollTop(0);
            $("#divAddActivityOutcome table tr#trReqAct").hide();
        },
        closeButton: '#btnCancelActivityOC',
        modalWidth: MODAL_WIDTH.MEDIUM
    });
}

function SetCookie(name, value) {
    var cookievalue = value;
    document.cookie = cookievalue;
}
function deleteCookie(name) {
    SetCookie(name, "");
}
function PrintActivitySummaryScriptTbl(List, isExport = false) {
    var htm = "";
    var optionhtm = "";
    var subOptionhtm = "";
    var noteshtm = "";
    if (window.top.gridLayoutTileFormatConfig.toLowerCase() === 'true') {
        if (List.length > 0) {
            htm += "<div class=\"srpt-tile-container\">";
            $.each(List, function (_key, item) {
                var VarDate = item.CreatedOn;
                htm += "<div class=\"srpt-tile\">";
                if (VarDate != null) {
                    var s = VarDate;
                    var expDate;
                    if (s.indexOf('/Date(') > -1) {
                        s = s.replace('/Date(', '').replace(')/', '');
                        expDate = new Date(parseInt(s));
                    }
                    else {
                        expDate = new Date(s);
                    }
                    var date = new Date(Date.parse(expDate));
                    VarDate = formatDateWithoutTime(date);
                }
                else { VarDate = "N/A"; }

                htm += "<div class=\"is_flex\"><div class=\"srpt-field-container\">";
                htm += "<label>Script Name</label>";
                htm += "<div class=\"srpt-field-data\">" + (item.ScriptName !== null && item.ScriptName !== "" ? item.ScriptName : "N/A") + "</div>";
                htm += "</div>";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>Question</label>";
                htm += "<div class=\"srpt-field-data\">" + (item.Question !== null && item.Question !== "" ? item.Question : "N/A") + "</div>";
                htm += "</div>";
                if (item.Option !== null && item.Option !== "" && item.Option.indexOf("<table") >= 0) {
                    htm += "</div><div class=\"is_flex\"><div class=\"srpt-field-container\" style = \"width:100%;\">";
                } else {
                    htm += "<div class=\"srpt-field-container\">";
                }
                htm += "<label>Option</label>";
                if (item.Option !== null && item.Option !== "") {
                    if (item.Option.indexOf("data:image") >= 0) {
                        optionhtm = "<img style=\"height:50px;width:100px;\" src=" + item.Option + "></img>";
                    } else if ((item.Option.indexOf("<table") >= 0 && item.Option.indexOf("clsTablePlaceholder") >= 0)) {
                        optionhtm = item.Option.replace("border='0'", "border='1'").replace("clsTablePlaceholder", "clsTablePlaceholder' style='border: 1px solid #ccc!important;");
                    }
                    else if ((item.Option.indexOf("<table") >= 0 && item.Option.indexOf("tblGrid") >= 0)) {
                        optionhtm = item.Option.replace("border='0'", "border='1'").replace("tblGrid", "tblGrid' style='border: 1px solid #ccc!important;").replace("<tr>", "<tr style='background-color:darkgrey;font-weight:bold;'>");
                    } else {
                        optionhtm = item.Option.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                        if (isExport) {
                            optionhtm = scriptResponseNewLines(optionhtm);
                        }
                    }
                } else {
                    optionhtm = "N/A";
                }
                htm += "<div class=\"srpt-field-data\">" + optionhtm + "</div>";
                htm += "</div></div><div class=\"is_flex\">";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>SubOption</label>";
                if (item.SubOption !== null && item.SubOption !== "") {
                    if ((item.SubOption.indexOf("data:image") >= 0)) {
                        subOptionhtm = item.SubOption.split(':')[0] + ':' + "<img style=\"height:50px;width:100px;\" src=" + item.SubOption.substr(item.SubOption.indexOf("data:image")) + "></img>";
                    } else {
                        subOptionhtm = item.SubOption.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                        if (isExport) {
                            subOptionhtm = scriptResponseNewLines(subOptionhtm);
                        }
                    }
                } else {
                    subOptionhtm = "N/A";
                }
                htm += "<div class=\"srpt-field-data\">" + subOptionhtm + "</div>";
                htm += "</div>";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>Script Score</label>";
                htm += "<div class=\"srpt-field-data\">" + (item.ScriptScore !== null && item.ScriptScore !== "" ? item.ScriptScore : "0") + "</div>";
                htm += "</div>";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>Care Notes</label>";
                if (item.CareNotes !== null && item.CareNotes !== "") {
                    noteshtm = item.CareNotes.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                    if (isExport) {
                        noteshtm = scriptResponseNewLines(noteshtm);
                    }
                } else {
                    noteshtm = "N/A";
                }
                htm += "<div class=\"srpt-field-data\">" + noteshtm + "</div>";
                htm += "</div></div><div class=\"is_flex\">";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>Staff Name</label>";
                htm += "<div class=\"srpt-field-data\">" + (item.StaffName !== null && item.StaffName !== "" ? item.StaffName : "N/A") + "</div>";
                htm += "</div>";
                htm += "<div class=\"srpt-field-container\">";
                htm += "<label>Date Entered</label>";
                htm += "<div class=\"srpt-field-data\">" + VarDate + "</div>";
                htm += "</div></div><div class=\"is_flex\">";
                htm += "<div class=\"srpt-suboption-container\" style=\"width:100%;margin-left: 35px;\">";
                if (item.SubOptionDynamicRaw !== '' && item.SubOptionDynamicRaw !== null && item.SubOptionDynamicRaw !== 'null') {
                    var rowdetails = item.SubOptionDynamicRaw;
                    var dynRows = rowdetails.split('‡');
                    var Col = dynRows[0].split('±');
                    htm += "<div class=\"srpt-inside-container\" style=\"margin-top:10px;\">";
                    for (var count = 0; count < dynRows.length; count++) {
                        htm += "<table style=\"border: 1px solid #cccccc;border-radius: 4px;margin-bottom:10px;width:100%\"><tbody>";
                        var itemVal = dynRows[count];
                        var items = itemVal.split('±');
                        var totalCols = Col.length;
                        for (var icountR = 0; icountR < totalCols; icountR += 3) {
                            htm += "<tr>";
                            for (var j = 0; j < 3; j++) {
                                var idx = icountR + j;
                                htm += "<td style='page-break-inside: avoid; padding:5px; vertical-align:top; width:33%;'>";
                                htm += scriptDataResponseTbl(idx, totalCols, Col, items);
                                htm += "</td>";
                            }
                            htm += "</tr>";
                        }
                        htm += "</tbody></table>";
                    }

                    htm += "</div>";
                }
                htm += "</div>";
                htm += "</div></div>";
            });
            htm += "</div>";
        }
        else {
            htm += "</div>";
            htm += "No Records Found";
            htm += "</div>";
        }
    }
    else {
        htm += '<table border="1" cellpadding="0" cellspacing="0" width="98%" style="margin: 5px;" class="DBGrid scriptTbl">';
        htm += '<tr style="background-color: darkgrey;"><td>Script Name</td><td>Question</td><td>Option</td><td>Sub Option</td><td>Script Score</td><td>Care Notes</td><td>Staff Name</td><td>Date Entered</td></tr>';
        if (List.length > 0) {
            $.each(List, function (key, item) {
                var VarDate = item.CreatedOn;

                if (VarDate != null) {
                    var s = VarDate;
                    var expDate;
                    if (s.indexOf('/Date(') > -1) {
                        s = s.replace('/Date(', '').replace(')/', '');
                        expDate = new Date(parseInt(s));
                    }
                    else
                        expDate = new Date(s);
                    var date = new Date(Date.parse(expDate));
                    VarDate = formatDateWithoutTime(date);
                }
                else { VarDate = "N/A"; }
                htm += "<tr>";
                htm += '<td style="width:10%;word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: inherit;">' + (item.ScriptName !== null && item.ScriptName !== "" ? item.ScriptName : "N/A") + '</td>';
                htm += '<td style="width:20%;word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: inherit;">' + (item.Question !== null && item.Question !== "" ? item.Question : "N/A") + '</td>';
                if (item.Option !== null && item.Option !== "") {
                    if (item.Option.indexOf("data:image") >= 0) {
                        optionhtm = '<img style="height:50px;width:100px;" src=' + item.Option + '></img>';
                    } else if ((item.Option.indexOf("<table") >= 0 && item.Option.indexOf("clsTablePlaceholder") >= 0)) {
                        optionhtm = "<div class='div_diagsum'>" + item.Option.replace("border='0'", "border='1'").replace("clsTablePlaceholder", "clsTablePlaceholder' style='border: 1px solid #ccc!important;") + "</div>";
                    }
                    else if ((item.Option.indexOf("<table") >= 0 && item.Option.indexOf("tblGrid") >= 0)) {
                        optionhtm = item.Option.replace("border='0'", "border='1'").replace("tblGrid", "tblGrid' style='border: 1px solid #ccc!important;").replace("<tr>", "<tr style='background-color:darkgrey;font-weight:bold;'>");
                    } else {
                        optionhtm = item.Option.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                        if (isExport) {
                            optionhtm = scriptResponseNewLines(optionhtm);
                        }
                    }
                } else {
                    optionhtm = "N/A";
                }
                htm += '<td style="width:10%;white-space: pre-wrap;">' + optionhtm + '</td>';
                if (item.SubOption !== null && item.SubOption !== "") {
                    if ((item.SubOption.indexOf("data:image") >= 0)) {
                        subOptionhtm = item.SubOption.split(':')[0] + ':' + '<img style="height:50px;width:100px;" src=' + item.SubOption.substr(item.SubOption.indexOf("data:image")) + '></img>';
                    } else {
                        subOptionhtm = item.SubOption.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                        if (isExport) {
                            subOptionhtm = scriptResponseNewLines(subOptionhtm);
                        }
                    }
                } else {
                    subOptionhtm = "N/A";
                }
                htm += '<td style="width:10%; white-space: pre-wrap;">' + subOptionhtm + '</td>';
                htm += '<td style="width:10%">' + (item.ScriptScore != null && item.ScriptScore != "" ? item.ScriptScore : "0") + '</td>';
                if (item.CareNotes !== null && item.CareNotes !== "") {
                    noteshtm = item.CareNotes.replace(/\[:Ä:]/g, '%').replace(/&#10;/g, '<br>');
                        if (isExport) {
                            noteshtm = scriptResponseNewLines(noteshtm);
                        }
                } else {
                    noteshtm = "N/A";
                }
                htm += '<td style="width:10%;word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: inherit;">' + noteshtm + '</td>';
                htm += '<td style="width:20%;word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: inherit;">' + (item.StaffName !== null && item.StaffName !== "" ? item.StaffName : "N/A") + '</td>';
                htm += '<td style="width:10%">' + VarDate + '</td>';
                htm += '</tr>';

                if (item.SubOptionDynamicRaw != '' && item.SubOptionDynamicRaw != null && item.SubOptionDynamicRaw != 'null') {
                    var rowdetails = item.SubOptionDynamicRaw;
                    var dynRows = rowdetails.split('‡');
                    htm += '<tr><td colspan="8">';
                    htm += '<div style="width:96%;margin-left: 20px;"><table border="1" cellpadding="0" cellspacing="0" width="100%" style="border:1px solid #ccc !important;">';
                    htm += '<tr align="left" style="background-color: darkgrey;">';
                    var Col = dynRows[0].split('±');
                    for (var icountR = 0; icountR < Col.length; icountR++) {
                        var Colitem = Col[icountR];
                        if (Colitem != "" && Colitem != undefined) { htm += '<th>' + Colitem.split('†')[0] + '</th>'; }
                    }
                    htm += '</tr>';
                    for (var count = 0; count < dynRows.length; count++) {
                        htm += '<tr>';
                        var itemVal = dynRows[count];
                        var items = itemVal.split('±');
                        for (var icount = 0; icount < items.length; icount++) {
                            var itemCnt = items[icount];
                            if (itemCnt !== "" && itemCnt !== undefined) {
                                var value = decodeURIComponent(itemCnt.split('†')[1]);
                                value = value.replace(/€¶¦validate€¶¦/g, "1SI").replace(/1Üî/g, "1Si").replace(/1Ûï/g, "1sI").replace(/1Ûî/g, "1si").replace(/\[:Ä:]/g, '%');
                                if (value.indexOf("data:image") >= 0) {
                                    value = "<img style='width:60px;' src='" + value + "'/>";
                                }
                                else {
                                    value = value.replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/\[:Ü:]/g, '|');
                                    value = htmlContentAlter(value, true);
                                }
                                htm += '<td>' + (value != null && value != "" ? value : "N/A") + '</td>';
                            }
                        }
                        htm += '</tr>';
                    }
                    htm += '</table></div>'; htm += '</td></tr>';
                }
            });
        }
        else {
            htm += '<tr><td>';
            htm += 'No Records Found';
            htm += '</td></tr>';
        }
        htm += '</table>';
    }
    return htm;
}

function scriptResponseNewLines(response) {
    if (response == null || response.trim() === "") {
        return response;
    }
    var newLineResponse = '';
    var lines = response.replace(/\n/g, '<br>').split('<br>');
    lines.forEach(newLine => {
        newLineResponse += `<div>${newLine.trim() === "" ? "&nbsp;" : newLine}</div>`;
    });
    return newLineResponse;
}

function scriptDataResponseTbl(idx, totalCols, Col, items) {
    var htm = "";
    if (idx < totalCols) {
        var Colitem = Col[idx];
        if (Colitem !== "" && Colitem !== undefined) {
            htm += "<label style='font-weight:bold;'>" + Colitem.split('†')[0] + "</label>";
        }
        var itemCnt = items[idx];
        if (itemCnt !== "" && itemCnt !== undefined) {
            var value = decodeURIComponent(itemCnt.split('†')[1]);
            value = value.replace(/€¶¦validate€¶¦/g, "1SI")
                .replace(/1Üî/g, "1Si")
                .replace(/1Ûï/g, "1sI")
                .replace(/1Ûî/g, "1si")
                .replace(/\[:Ä:]/g, '%');
            if (value.indexOf("data:image") >= 0) {
                value = "<img style='width:60px;' src='" + value + "'/>";
            } else {
                value = value.replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;")
                    .replace(/\[:Ü:]/g, '|')
                    .replace(/&#10;/g, '<br>');
            }
            htm += "<div class=\"srpt-field-data\" style=\"page-break-inside:avoid; display:block\">" + (value !== null && value !== "" ? value : "N/A") + "</div>";
        }
    }
    return htm;

}
function captureActivityOutcome(pfid, isCompletePendingActivity, isScriptInactive) {
    var URL = '';
    if (isDisplayProviderActivities == "True" && ExternalProviderActivityId == 'External') {
        URL = baseURL + "/Home/ExtActivityOutcome?ActId=" + pfid + "&IsCompletePendingActivity=" + isCompletePendingActivity;
    }
    else {
        URL = baseURL + "/Home/ActivityOutcome?ActId=" + pfid + "&IsCompletePendingActivity=" + isCompletePendingActivity + "&isScriptInactive=" + isScriptInactive;
    }

    $('#popUpDialog1').CMNPopup({
        pvUrl: URL,
        popUpHeader: "General Activity Outcome",
        popLevel: 1,
        closeButton: '#btnCancelActivityOC',
        onClose: function () {
            ExternalProviderActivityId = "";
            if ($('#dBADT.TabbedPanelsTab.TabbedPanelsTabSelected').length > 0) {
                if ($('#ddlPHIPNotifications').val() === 'ADT' && $('#ADTrackingGridDiv').is(':visible'))
                    $("#ADTrackingGrid").data("kendoGrid").dataSource.read();
                else if ($('#ddlPHIPNotifications').val() === 'IP Notifications' && $('#PHIPNotificationsGridDiv').is(':visible'))
                    $("#PHIPNotificationsGrid").data("kendoGrid").dataSource.read();
            }
            $('#popUpDialog1').html('');
        },
        modalWidth: MODAL_WIDTH.MEDIUM,
        onLoad: function () {
            if (isScriptInactive) {
                $('#selectActivityOutcomeType').val(2);
                $('#selectActivityOutcomeType').prop("disabled", "disabled");
                $('#selectActivityOutcomeType').trigger('change');
            }
            A11yModal.trapFocusInModal('popUpDialog1');
        },
    });
}

//when you saved it will saved in arry 
function SignatureClientSave(image) {
    var title = $("#ddlSignatureTitle option:selected").text().trim();
    var careStaffName = $("#ddlTitleName option:selected").text().trim();
    var enteredDate = $("#txtEnteredDate").val();
    var credentials = 'N/A';
    var roleId = 0;
    var role = "N/A";
    var isParticiaptedForDBSave = "";
    var isAgreedForDBSave = "";
    var isParticiapted = "";
    var isAgreed = "";

    if ($('input[name=rdoYesNoParticipation]:checked').val()) {
        isParticiaptedForDBSave = $('input[name=rdoYesNoParticipation]:checked').val() === "1" ? true : false;
        isParticiapted = $('input[name=rdoYesNoParticipation]:checked').val() === "1" ? "Yes" : "No";
    }
    if ($('input[name=rdoYesNoAgreement]:checked').val()) {
        isAgreedForDBSave = $('input[name=rdoYesNoAgreement]:checked').val() === "1" ? true : false;
        isAgreed = $('input[name=rdoYesNoAgreement]:checked').val() === "1" ? "Yes" : "No";
    }
    var agreementReason = $("#txtAgreementReason").val();
    if ($("#txtCredentials").length > 0 && $("#txtCredentials").val().trim() != '') {
        credentials = $("#txtCredentials").val().trim();
    }
    arrFullCPSignature = [];
    //UHC-4647
    var careteamId = $("#ddlSignatureTitle option:selected").val();
    if (careteamId != 1)
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/GetRoleByMemberId",
            data: { memberId: $("#ddlTitleName option:selected").val(), careteamId: $("#ddlSignatureTitle option:selected").val() },
            dataType: "json",
            async: false,
            success: function (data) {
                if (data.success && data.value != "") {
                    role = data.value.RoleName;
                    roleId = data.value.RoleId;
                }
                if ($('#hdnIsFullCarePlanSection').val() === "1") {
                    arrFullCPSignature.push({ PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiaptedForDBSave, MemberAgreedFlag: isAgreedForDBSave, SignatureRemarks: agreementReason });
                    arrSignature.push({ CarePlanSignatureId: 0, PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiapted, MemberAgreedFlag: isAgreed, SignatureRemarks: agreementReason });
                    return saveSignature(arrFullCPSignature);
                }
                else {
                    arrSignature.push({ PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiapted, MemberAgreedFlag: isAgreed, SignatureRemarks: agreementReason });
                    SignatureGridBind();
                }
            }
        });
    else {
        if ($('#hdnIsFullCarePlanSection').val() === "1") {
            arrFullCPSignature.push({ PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiaptedForDBSave, MemberAgreedFlag: isAgreedForDBSave, SignatureRemarks: agreementReason });
            arrSignature.push({ CarePlanSignatureId: 0, PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiapted, MemberAgreedFlag: isAgreed, SignatureRemarks: agreementReason });
            return saveSignature(arrFullCPSignature);
        }
        else {
            arrSignature.push({ PatientId: $('#selectPatientAccessed').val(), Signature: image, ParticipantId: $("#ddlTitleName").val(), RoleId: roleId, RoleName: role, ParticipantName: careStaffName, ParticipantTitleName: title, Credentials: credentials, EnteredDate: enteredDate, MemberParticipatedFlag: isParticiapted, MemberAgreedFlag: isAgreed, SignatureRemarks: agreementReason });
            SignatureGridBind();
        }
    }
    return true;
}

function opptStatusChange(val, clsName, classNameOfNotes, gridId) {
    $(".k-widget.k-tooltip.k-tooltip-closable.k-popup.k-group.k-reset.k-state-border-up").hide();
    $(".k-animation-container").css("display", "none");

    var QualityMeasureStatusId = '';
    var QualityActionStatusId = "";

    switch (val) {
        case "Action Planned":
            QualityMeasureStatusId = "4";
            QualityActionStatusId = "1";
            break;
        case "Action Completed":
            QualityMeasureStatusId = "4";
            QualityActionStatusId = "2";
            break;
        case "Not an Issue/Other":
            QualityMeasureStatusId = "4"
            QualityActionStatusId = "4";
            break;
        case "This action completed":
            QualityMeasureStatusId = "3";
            QualityActionStatusId = "2";
            break;
        case "Other Action Scheduled":
            QualityMeasureStatusId = "3";
            QualityActionStatusId = "1";
            break
        case "Not an Issue/Otheri":
            QualityMeasureStatusId = "3";
            QualityActionStatusId = "4";
            break;
        case "Revert to Not Addressed":
            QualityMeasureStatusId = "4";
            QualityActionStatusId = "3";
            break;
        case "Action Verified":
            QualityMeasureStatusId = "9";
            QualityActionStatusId = "5";
            break;
        default:
            QualityMeasureStatusId = "";
            QualityActionStatusId = "";
    }
    var eventMeasureId = clsName.split('|').length > 5 ? clsName.split('|')[6] : 0;
    var isEventMeasure = clsName.split('|').length > 6 ? clsName.split('|')[7] : 0;
    var patientId = clsName.split('|')[1];
    updateOpptSubStatus(memberidval, QualityMeasureStatusId, QualityActionStatusId, classNameOfNotes, clsName.split('|')[2], eventMeasureId, isEventMeasure, patientId );
    setTimeout(function () {
        $("#" + gridId).data("kendoGrid").dataSource.read();
    }, 100);

    $('.Ardo1').prop('checked', false);
    $('.Ardo2').prop('checked', false);
    $('.Ardo3').prop('checked', false);
    $('.IrdoOas').prop('checked', false);
    $('.IrdoTAC').prop('checked', false)
    $('.IrdoNAI').prop('checked', false);
}

function updateOpptSubStatus(CareStaffId, QualityMeasureStatusId, QualityActionStatusId, NotesOfAction, CareOppurtunityId, EventMeasureId, isEventMeasure, patientId) {
    $.ajax({
        url: baseURL + "/PopulationHealth/UpdateStatusBasedOnSubstatusSelected",
        type: "POST",
        async: false,
        data: JSON.stringify({ 'CareStaffId': CareStaffId, 'QualityMeasureStatusId': QualityMeasureStatusId, 'QualityActionStatusId': QualityActionStatusId, 'Notes': NotesOfAction, 'CareOppurtunityId': CareOppurtunityId, 'EventMeasureId': EventMeasureId, 'isEventMeasure': isEventMeasure, 'PatientId': patientId  }),
        dataType: "json",
        traditional: true,
        contentType: "application/json; charset=utf-8",
        beforeSend: function () {
        },
        success: function (data) {
            if (JSON.stringify(data) > 0) {
                CmnStatusMessageDisp('opportunitiesRARMsg', 'Status changed successfully.', 'Success');
            }
            else
                CmnStatusMessageDisp('opportunitiesRARMsg', 'Status changed failed.', 'Error');
        },
        error: function (e) {
            console.log(e);
        }
    });
}


function refreshCareManager() {
    $.ajax({
        type: "POST",
        url: baseURL + "/CommonDefaultSessionState/GetMemberCareManager?isSetSession=true",
        dataType: "json",
        success: function (data) {
            var careManager = data.careManager == undefined || data.careManager == null ? "Not Assigned" : data.careManager;
            if ($(".ExpandedCareManager").length > 0) {
                $(".ExpandedCareManager").AhsSetHtml(careManager);
            }
        }
    });
}

// searching a value existence in comma separated values.
function checkSearchValueInCollection(collection, searchValue) {
    var searchFound = false;
    if (collection != null && searchValue != null && collection != "" && searchValue != "" && collection != undefined && searchValue != undefined) {
        collection.split(',').forEach(function (data) {
            if (data !== null && data.toString().trim() == searchValue.toString().trim()) {
                searchFound = true;
            }
        });
    }
    return searchFound;
}

// My CareTeam Members MVC Convertion
function CreateEligibilityLinks() {
    var link = "<a class='clsMemEligClick' data-clientpatientid='#:clientpatientid#' data-patientid='#:PatientId#' data-lobbenid='#:LobBenId#'>#:LobName#</a>";
    $.each($(".spnEligibility"), function () {
        var ele = $(this).html();
        var pId = $(this).data("patientid");
        var li = ele.split("|");
        var links = "";
        $.each(li, function () {
            var eligiblity = this.split(",");
            links += ", " + link.replace("#:LobBenId#", eligiblity[0]).replace("#:LobName#", eligiblity[1]).replace("#:clientpatientid#", pId).replace("#:PatientId#", pId);
        });
        $(this).html(links.substring(1, links.length));
    });

}
function GetMemberZIP() {
    var res = "";
    $.ajax({
        type: "GET",
        async: false,
        url: baseURL + "/CareTeam/GetMemberZip?PatientId=" + $('#selectPatientAccessed').val(),
        success: function (data) {
            res = data;
        },
        error: function (exception) {
            console.log(exception); loader(0);
        }
    });
    return res;
}
function SaveHealthifyProviderDetails(provId, provName, WrkPhn, City, State, Zip, Address, isPreferredProvider, uuid, email) {
    var isupdatehealthify = 0;
    var datastring = {
        ProviderId: provId,
        ProviderName: provName,
        ProviderTypeName: "Social service provider",
        WorkPhone: WrkPhn,
        City: City,
        State: State,
        Zip: Zip,
        Address: Address,
        Email: email
    }
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/SaveHealthifyProviderDetails/",
        data: JSON.stringify({ isupdate: isupdatehealthify, healthifyid: provId, CareTeamId: 3, model: datastring, spokenLanguages: "ENGLISH", uuId: uuid, isPreferredProvider: isPreferredProvider }),
        contentType: "application/json",
        success: function (data) {
            var result = data.success;
            if (result) {
                $('#popUpDialog1').CMNPopup({
                    pvUrl: baseURL + "/CommonDefaultSessionState/AddAppointment?CareplanId=" + CarePlanId,
                    popUpHeader: "Add Appointment",
                    closeButton: '#closebutton1',
                    onLoad: function () {
                        //$("#lnkAppointmentSocialReferral").hide();
                        //FunFetchHealthifyProviderDetails(uuid, true);
                    },
                    onClose: function () {
                        ClearTableMenu('_myMemberPartialViewContainer', 'divMemberMenu');
                        if ($("#fromAppointment").length == 1)
                            $("#fromAppointment").remove();
                    }
                });
            }
        },
        error: function (exception) {
            console.log(exception);
        }
    });
}
function RemoveExtracolumn(list, value) {
    var separator = ",";
    for (var i = 0; i < list.length; i++) {
        if (list[i] == value) {
            list.splice(i, 1);
            return list.join(separator);
        }
    }
    return list;
}
function applyEleAttributes(element, opt) {
    element.css('opacity', '0.6');
    if (opt.className != undefined) {
        if (opt.IsRemoveElement == undefined || opt.IsRemoveElement == true) {
            element.removeClass(opt.className);
        }
        element.removeAttr('onclick');
        element.off('click');
    }
    else if (opt.Id != undefined) {
        if ($('' + element.selector + ' #' + opt.Id).attr('type') !== undefined && $('' + element.selector + ' #' + opt.Id).attr('type') === "checkbox") {
            $('' + element.selector + ' #' + opt.Id).attr('disabled', true);
        }
        element.removeAttr('id');
        element.removeAttr('onclick');
        element.off('click');
        element.removeAttr('href');  // GCPROD-19307        
    }
    if (opt.IsFrom != undefined) {

        switch (opt.IsFrom) {
            case "Add":
                if (ToValue(opt.CustTitle, '') === '') { element.attr('title', 'You do not have access to Add a record.'); element.css('cursor', 'default'); }
                else { element.attr('title', opt.CustTitle); element.css('cursor', 'default'); }
                break;
            case "Edit":
                if (ToValue(opt.CustTitle, '') === '') { element.attr('title', 'You do not have access to Edit a record.'); element.css('cursor', 'default'); }
                else { element.attr('title', opt.CustTitle); element.css('cursor', 'default'); }
                break;
            case "Delete": element.attr('title', 'You do not have access to Delete a record.'); element.css('cursor', 'default'); break;
            case "View": element.attr('title', 'You do not have access to View a record.'); element.css('cursor', 'default'); break;
            case "Download": element.attr('title', 'You do not have access to Download.'); element.css('cursor', 'default'); break;
            case "Export": element.attr('title', 'You do not have access to Export.'); element.css('cursor', 'default'); break;
            case "Print": element.attr('title', 'You do not have access to Print.'); element.css('cursor', 'default'); break;
            case "Email": element.attr('title', 'You do not have access to send Email.'); element.css('cursor', 'default'); break;
            case "ActInAct": element.attr('title', 'You do not have access to Activate/InActivate records.'); element.css('cursor', 'default'); break;
        }
    }
}
function GetCurrentDateByUserTimeZone() {
    //Date format as per user timezone==========START
    var varCurrentDate = "";
    var datebyUsertimezone = (currentDateByTimeZone.split(" ")[0]).split("-");
    var finalDate = new Date(datebyUsertimezone.reverse().join("/"));
    var month = finalDate.getMonth() + 1;
    var day = finalDate.getDate();
    varCurrentDate = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + finalDate.getFullYear();
    return varCurrentDate;
    //Date Format in MM/DD/YYYY================END
}
//Alert show box with call back function
function AlertShowWithCallBack(message, poplev, callBack) {
    var ObjPopLevel = 1;
    ObjPopLevel = poplev == undefined ? 1 : poplev;
    $('#divAlert' + ObjPopLevel).CMNPopup({
        popUpHeader: "Alert",
        popLevel: ObjPopLevel,
    });
    $('#divAlertMessage' + ObjPopLevel).html(message);
    $('#divAlert' + ObjPopLevel).off('click', '#btnAlertYes' + ObjPopLevel).on('click', '#btnAlertYes' + ObjPopLevel, function () {
        $('#divAlert' + ObjPopLevel + ' #closePopUp').trigger('click');
        if (callBack != undefined) {
            callBack(true);
        }
    });
}

function onSpnMultiSelectClicked(ctrl, iscount) {
    var eleid = ctrl.id.replace('spn', '');
    var chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:checked');
    var ele = $(ctrl).prev("input[type='checkbox']");
    if (ele.is(':checked')) {
        ele.prop('checked', false);
    } else {
        ele.prop('checked', true);
    }
    onChkMultiSelectClicked(ctrl, iscount);
}

function onChkMultiSelectClicked(ctrl, iscount) {
    var eleid = ""; var chkboxes = null;
    if ($(ctrl).hasClass('clschkDDSelectAll') || $(ctrl).hasClass('clschkDDSelectAllSpn')) {
        var $chkElement = null;
        if ($(ctrl).hasClass('clschkDDSelectAllSpn'))
            $chkElement = $(ctrl).prev("input[type='checkbox']");
        else
            $chkElement = ctrl;

        var parentCtrl = $($chkElement).closest('.dropcheck');
        var isChecked = $('.clschkDDSelectAll', parentCtrl).is(':checked');//$('.clschkDDSelectAll').prop('checked');

        // $(parentCtrl).find('input[type="checkbox"]').prop('checked', isChecked);
        if ($(ctrl).parent().parent().attr('id') == 'selectCTProviders')
            $(parentCtrl).find('input[type="checkbox"]').not("[disabled]").prop('checked', isChecked);
        else
            $(parentCtrl).find('input[type="checkbox"]').prop('checked', isChecked);
        chkboxes = $(parentCtrl).find('input[type="checkbox"]:not(".clschkDDSelectAll"):checked');

        eleid = $(parentCtrl).attr('id').replace('chk', '');
    }
    else {
        eleid = ctrl.id.replace('spn', '');
        chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:not(".clschkDDSelectAll"):checked');
        let currSrcChkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:not(".clschkDDSelectAll")'); //variable name change
        //Code for Select All checkboxes in multi select dropdown
        if (chkboxes.length == globalChkBoxLength) {
            $("#" + eleid + "chk").find('.clschkDDSelectAll').prop('checked', true);
        }
        else if ((eleid === "ddlCurrentMedIndicator" || eleid === "ddlMedView") && currSrcChkboxes.length === chkboxes.length) {
            $("#" + eleid + "chk").find('.clschkDDSelectAll').prop('checked', true);
        }
        else {
            $("#" + eleid + "chk").find('.clschkDDSelectAll').prop('checked', false);
        }
    }
    if (chkboxes.length > 0) {
        var itm = "";
        var itmtxt = "";
        var itemTxt = "";
        $("#" + eleid + "chk").find('input[type="checkbox"]:not(".clschkDDSelectAll"):checked').each(function () {
            itemTxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
            if (eleid == 'selectCTProviders') {
                //itemTxt = unescapeHtml($(this).next("#" + eleid + "spn")[0].innerText);
                //PROD-7557---ff 32 
                itemTxt = $(this).next("#" + eleid + "spn")[0].innerText;
                if (itemTxt != undefined) {
                    itemTxt = unescapeHtml(itemTxt);
                } else {
                    itemTxt = unescapeHtml($(this).next("#" + eleid + "spn")[0].textContent);
                }
            }
            var arry = itm.split(',');
            var nummm;
            var valaaa = jQuery.inArray($(this).val(), arry, nummm);
            if (valaaa == -1) {
                if (itm.length > 0) {
                    itm = itm + "," + $(this).val();
                    itmtxt = itmtxt + "," + itemTxt;
                }
                else {
                    itm = $(this).val();
                    itmtxt = itemTxt;
                }
            }
        });
        $("#" + eleid + "hdn").val(itm);
        $("#" + eleid + "hdntxt").val(itmtxt);
        if (iscount) {
            //alert(itm + '    654654');
            $("#" + eleid + "val").val(itm != '' ? itm : 'Select');
        }

        else if (eleid === "ddlMedView" || eleid === "ddlCurrentMedIndicator") {
            let maxLimit = (eleid === "ddlMedView") ? 3 : 2;
            if (chkboxes.length >= 1 && chkboxes.length <= maxLimit) {
                $("#" + eleid + "val").val(itmtxt !== '' ? itmtxt : 'Select');
            } else {
                $("#" + eleid + "val").val("Select All");
            }
        }
        else {
            //alert(itmtxt);
            if (chkboxes.length >= 1 && chkboxes.length <= 3) {
                $("#" + eleid + "val").val(itmtxt != '' ? itmtxt : 'Select');
            }
            else {
                $("#" + eleid + "val").val(chkboxes.length + " items Checked");
            }
        }
    }
    else {
        $("#" + eleid + "val").val("Select");
        $("#" + eleid + "hdn").val('');
        $("#" + eleid + "hdntxt").val('');

    }
}
// End Multi Check with Select all Dropdownlist

function displayCMMenu(type, callBack) {
    if ($("#MvcMainBody .InAuthPage").length > 0) {
        GotoHome('UM', undefined, true, callBack);
    }
    else if ($("#MvcMainBody .InComplaintPage").length > 0) {
        GotoHome('AG', true, undefined, callBack);
    }
    else {
        switch (type) {
            case AdvanceSearchTypeEnum.MemberSearch:
                CallCshtmlCtrls("/AssignCareStaff/FindCareMemberBasic");
                break;
            case AdvanceSearchTypeEnum.ProviderSearch:
                CallCshtmlCtrls("/AdvanceProviderSearch/CommonAdvanceProviderSearch?fromGlobalSearch=true");
                break;
            case AdvanceSearchTypeEnum.PayorSearch:
                CallCshtmlCtrls("/ManagePayor/ManagePayor");
                break;
            default:
                break;
        }
    }
}
// When the span in the Multi select dropdown is clicked
function MultiSelectDropDownSpnClicked(ctrl, iscount) {
    var checkedStatus = $(ctrl).prev('input[type="checkbox"]')[0].checked;
    var eleid = ctrl.id.replace('spn', '');
    var ele = $(ctrl).prev("input[type='checkbox']");
    if (ele != null) {
        if (checkedStatus) {
            ele.prop('checked', false);
        } else {
            ele.prop('checked', true);
        }
    }
    ddlcolumnselectedshow(eleid, iscount);
}
// When the checkbox in the Multi select dropdown is clicked
function MultiSelectDropDownChkClicked(ctrl, iscount) {
    var eleid = ctrl.id.replace('spn', '');
    ddlcolumnselectedshow(eleid, iscount);
}
// This method is using to fire the checked events of the multi select dropdown list when we are checking the items in multi select dropdown list by passing the selected items in Jquery as array of string
function MultiSelectDropDownChkTriggered(ctrl, iscount) {
    ctrl.attr('checked', true);
    var eleid = ctrl.attr('id');
    ddlcolumnselectedshow(eleid, iscount);
}
function MvcAjaxallBackFailed() { loader(0); }

function validateAddEditStrength() {
    var flag = true;
    var StrengthType = $('#selCrPlTmStrengthTypeId').val();
    if (StrengthType == "-1") {
        $('#selCrPlTmStrengthTypeId').next('.valMsg').show(); flag = false;
    } else {
        $('#selCrPlTmStrengthTypeId').next('.valMsg').hide();
    }
    var StrengthName = $.trim($('#txtCrPlTmStrengthName').val());
    if (StrengthName == "") {
        $('#txtCrPlTmStrengthName').next('.valMsg').show(); flag = false;
    } else {
        $('#txtCrPlTmStrengthName').next('.valMsg').hide();
    }
    if ($('#ddlStrengthStatus').val() === "-1") {
        $('#ddlStrengthStatus').next('.valMsg').show(); flag = false;
    } else {
        $('#ddlStrengthStatus').next('.valMsg').hide();
    }
    return flag;
}
var memberPlanUpdated = false;
function ShowCplMultiView(item) {
    var popHeaderName = "Team Care Plan Summary";
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { popHeaderName = "MTM Intervention Summary" };
    chkBxChdCarePlan = chkChecked().checkBox;
    if (chkBxChdCarePlan.length > 0) {
        $('#hdnCrPlTmCrPlHisCrPlId').val($(chkBxChdCarePlan[0]).attr('id').split('_')[1]);
        $('#hdnCrPlTmCrPlCategory').val($(chkBxChdCarePlan[0]).data('hiddenval').split('~')[2]);
        $('#popUpDialog2').CMNPopup({
            pvUrl: baseURL + "/CarePlan/CarePlanMultiView",
            onLoad: function () {
                DisableEnableAccordians("");
                if (item.toUpperCase() == 'BARRIER') {
                    $('#divCplBarrierGridHeader').trigger('click');
                }
                else if (item.toUpperCase() == 'ACTHISTORY') {
                    $('#divCplActHistoryGridHeader').trigger('click');
                }
                else if (item.toUpperCase() == 'CPLNOTES') {
                    $('#divCplNotesGridHeader').trigger('click');
                }
                else if (item.toUpperCase() == 'APPDETAILS') {
                    $('#divCplAppDetailsGridHeader').trigger('click');
                }
                else if (item.toUpperCase() == 'STRENGTHS') {
                    $('#divCplStrengthGridHeader').trigger('click');
                }

                $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
                //ClearCheckBoxes();
            },
            popUpHeader: popHeaderName,
            popLevel: 2,
            closeButton: '#btnCplMultiViewClose',
            triggerBtnId: $('#popUpDialog1').is(':visible') ? 'popUpDialog1' : undefined,
            onClose: function () {
                if (memberPlanUpdated) {
                    $("#TmCrPlRecAndCurGroupGrid").data("kendoGrid").dataSource.read();
                    memberPlanUpdated = false;
                }
                $('#btnCrPlTmCrPlMyCarePlan').show();
                $('.cplAdd').show();
            }
        });
    }

}
function getSelectedCrPlValues(careplanId) {
    var oppName = "", IntName = "", GoalName = "", GoalGroupName = "", CPstatus = "", CPstartdate = "", CPenddate = "";
    var patientId = parseInt($(".clsChkCrPlTmCrPlGrid:checked").data('patientid'));
    if (careplanId != null && careplanId != "" && careplanId != undefined) {
        $.ajax({
            type: "POST",
            //url: baseURL + "/CarePlan/getSelectedCarePlanValue?crPlId=" + careplanId,
            url: baseURL + "/CarePlan/GetCarePlanSummary?carePlanId=" + careplanId + "&patientId=" + patientId,
            success: function (data) {
                oppName = data.oppName;
                GoalGroupName = data.goalGroup;
                GoalName = data.goal,
                    IntName = data.intervention;
                CPstatus = data.status;
                CPstartdate = data.sdate;
                CPenddate = data.edate;
                let CPGoalId = data.goalId;
        var oppNameToShow = oppName.length > 60 ?oppName.substring(0, 57)+ "..." : oppName;
                var GoalGroupNameToShow = GoalGroupName.length > 60 ? GoalGroupName.substring(0, 57) + "..." : GoalGroupName;
                var GoalNameToShow = GoalName.length > 60 ? GoalName.substring(0, 57) + "..." : GoalName;
                var IntNameToShow = IntName.length > 60 ? IntName.substring(0, 57) + "..." : IntName;
                $("#tdCrPlValues").AhsSetHtml("<table style='width:100%'><tr><td style='width:50%'><b>Opportunity : </b><span title=\"" + $.fn.escapeHtmlExt(oppName) + "\">" + $.fn.escapeHtmlExt(oppNameToShow) + "</span></td>" +
                    "<td><b>Goal Group : </b><span title=\"" + $.fn.replaceAndEscapeHtmlExt(GoalGroupName) + "\">" + $.fn.replaceAndEscapeHtmlExt(GoalGroupNameToShow) + "</span></td></tr>" +
                    "<tr><td><b>Goal : </b><span title=\"" + $.fn.replaceAndEscapeHtmlExt(GoalName) + "\" id='cpSumGoalName' >" + $.fn.replaceAndEscapeHtmlExt(GoalNameToShow) + "</span></td>" +
                    "<td><b>Intervention : </b><span title=\"" + $.fn.escapeHtmlExt(IntName) + "\">" + $.fn.escapeHtmlExt(IntNameToShow) + "</span></td></tr>" +
                    "<tr><td><b>Start Date : </b><span title=\"" + CPstartdate + "\">" + CPstartdate + "</span></td>" +
                    "<td><b>Target Date : </b><span title=\"" + CPenddate + "\">" + CPenddate + "</span></td>" +
                    "<tr><td><b>Status : </b><span title=\"" + $.fn.replaceAndEscapeHtmlExt(CPstatus) + "\">" + $.fn.replaceAndEscapeHtmlExt(CPstatus) + "</span></td></tr>" +
                    "<tr><td><input type='hidden' id='hdnCPGoalId' value='" + CPGoalId + "' ></td></tr ></table > ");
            },
            error: function (request, status, error) {
            }
        });
    }

}
//Reset control header check box visibility and button visibility when grid get refreshed
function resetCntrlStateScroll() {
    var grid = $('.clsChkCrPlTmCrPlHead');
    if (grid && grid.length > 0) {
        grid.prop('checked', false);
    }
    grid = $('.clsChkCrPlTmCrPlHead');
    if (grid && grid.length > 0) {
        grid.prop('checked', false);
    }
    var selectedCategory = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text();
    TmCrPlShHdBtn(selectedCategory.toUpperCase().trim(), 0);
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    $('#hdnTmCrPlSignOffId').val('');
    $('#hdnCrPlTmCrPlHisCrPlId').val('');
    $('#hdnCrPlTmCrPlHisCrPlrelId').val('');
}

function carePlanGridMerge(cpgridID) {
    var $gridId = $(cpgridID);
    var tContent = $gridId.find('.a11y-k-grid-container table tbody tr');
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 1; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td,th');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.textContent;
                if (!$(td).hasClass("defaultColumn")) {
                    if (selectedDynColIndices.includes(index)) {
                        $(td).css("display", "");
                    }
                    else {
                        $(td).css("display", "none");
                    }
                }
                if (index === 3 || (index === 11 && selectedDynColIndices.includes(index))) {
                    $(td).attr("style", "word-wrap:break-word;border-left: 1px solid #CCC !important;");
                    if (index === 11 && !(selectedDynColIndices.includes(index + 1))) {
                        $(td).attr("style", "word-wrap:break-word;border-right: 1px solid #CCC !important;border-left: 1px solid #CCC !important;");
                    }
                }
                if (index === 4 || (index === 12 && selectedDynColIndices.includes(index))) {
                    $(td).attr("style", "word-wrap:break-word;border-right: 1px solid #CCC !important;");
                    if (index === 12 && !(selectedDynColIndices.includes(index - 1))) {
                        $(td).attr("style", "word-wrap:break-word;border-left: 1px solid #CCC !important;border-right: 1px solid #CCC !important;");
                    }
                }
            });
            var $prevTd = $(tContent[row + 1]).find('td,th');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {

                //for merging INTERVENTION columns
                //Changed == to === to fix sonar issue
                if ($prevArray[4].trim() === $currentArray[4].trim() &&
                    $prevArray[3].trim() === $currentArray[3].trim() &&
                    $prevArray[11].trim() === $currentArray[11].trim() &&
                    $prevArray[12].trim() === $currentArray[12].trim())  {
                    $.each($currentArray, function (index2, value) {
                        switch (index2) {
                            case 3:
                            case 4:
                            case 11:
                            case 12:
                                //Merging of columns should happen here                                
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                break;
                            default:
                                $prevArray[index2] = value;
                                break;
                        }
                    });
                }               
                else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
            if ((noOfRows - row) % 2 === 0) {
                $(tContent[noOfRows - row - 1]).addClass('cpAltRow');
            }

        }
    }
}

/*function to handle grouping in mtm interventions section*/
function interventionsGridMerge() {
    var $gridId = $('#TmCrPlRecAndCurGroupGrid');
    var tContent = $gridId.find('.k-grid-content table tbody tr');
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 2; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.textContent;
            });

            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {
                //for merging INTERVENTION columns
                if ($prevArray[4].trim() == $currentArray[4].trim() &&
                    $prevArray[6].trim() == $currentArray[6].trim() &&
                    $prevArray[7].trim() == $currentArray[7].trim() &&
                    $prevArray[9].trim() == $currentArray[9].trim() &&
                    $prevArray[13].trim() == $currentArray[13].trim()) {
                    $.each($currentArray, function (index2, value) {
                        switch (index2) {
                            case 4:
                            case 6:
                            case 7:
                            case 9:
                                //Merging of columns should happen here                                
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                $($currentTd[index2]).addClass('brdAll');
                                break;
                            default:
                                $prevArray[index2] = value;
                                break;
                        }
                    });
                }
                //for merging OPPORTUNITY columns
                else if ($prevArray[4].trim() == $currentArray[4].trim() &&
                    $prevArray[5].trim() == $currentArray[5].trim() &&
                    $prevArray[6].trim() == $currentArray[6].trim() &&
                    $prevArray[7].trim() == $currentArray[7].trim() &&
                    $prevArray[13].trim() == $currentArray[13].trim()) {
                    $.each($currentArray, function (index2, value) {
                        switch (index2) {
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                //Merging of columns should happen here
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                $($currentTd[index2]).addClass('brdAll');
                                break;
                            default:
                                $prevArray[index2] = value;
                                break;
                        }
                    });
                } else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
        }
    }
}

function gridRefresh1(gridId, isClear, checkBoxCheckCount) {
    ClearGrid(gridId, isClear);
    $.each(gridId, function (index, value) {
        if (value === "#TmCrPlRecAndCurGroupGrid" || value === "#TmCrPlRecAndCurGroupListView") {
            if (checkBoxCheckCount === $(value).data("kendoGrid").dataSource.view().length) {
                $(value).data("kendoGrid").dataSource.page(1);
            }
            else {
                $(value).data("kendoGrid").dataSource.read();
            }
        } else {
            $(value).data("kendoGrid").dataSource.page(1);
        }

    });
    resetCntrlStateScroll();
}

/*Click event for checkbox click*/
function chkClicked(ctrl, iscount) {
    var ele = ctrl.id.replace('spn', '');
    var eleid = $("#" + ele);
    var divId = eleid.closest('div [id$=div]');
    var chkboxes = divId.find('input[type="checkbox"]:checked');
    if (chkboxes.length > 0) {
        var itm = "";
        var itmtxt = "";

        $.each(chkboxes, function (index, value) {
            var arry = itm.split(',');
            var nummm;
            var valaaa = jQuery.inArray($(this).val(), arry, nummm);
            if (valaaa == -1) {
                if (itm.length > 0) {
                    itm = itm + "," + $(this).val();
                    itmtxt = itmtxt + "," + $(this).next("#" + ele + "spn").html();
                }
                else {
                    itm = $(this).val();
                    itmtxt = $(this).next("#" + ele + "spn").html();
                }
            }
        });
        divId.find("[id$=hdn]").val(itm);
        divId.find("[id$=hdntxt]").val(itmtxt);
        if (iscount) {
            divId.find("[id$=val]").attr("placeholder", itm);
        }
        else {
            if (chkboxes.length == 1) {
                // $("#" + eleid + "val").attr("placeholder",chkboxes.length + " Item Selected");
                divId.find("[id$=val]").attr("placeholder", "Item Selected");
            }
            else {
                //$("#" + eleid + "val").attr("placeholder", chkboxes.length + " Items Selected");
                divId.find("[id$=val]").attr("placeholder", "Items Selected");
            }
        }
    }
    else {
        divId.find("[id$=val]").attr("placeholder", "Select");
    }

}
function setTopLeftCurrentVal() {
    if (dashboardConfig != null && dashboardConfig.length > 0) {
        var myMembersRank = $.grep(dashboardConfig, function (element, index) { return element.QuadrantId == 1 && element.QuadrantValueId == 1 });
        topLeftCurrentValue = myMembersRank[0].Rank;
    }
}
function ShowAcknowledgeButtonMAL(e) {
    var $acknowledgeButton = $('#btnReqRejAckRRjMAL');
    if (e) {
        if (!$acknowledgeButton.is(":visible"))
            $acknowledgeButton.show();
    } else {
        if ($acknowledgeButton.is(":visible"))
            $acknowledgeButton.hide();
    }
}

function ContextMenuNActionButtonsLoad() {
    if ($('#tdMALBulkActionsRR') != null) { $('#tdMALBulkActionsRR').html(tdMALBulkActionsRR); }
    if ($('#divMALContextMenusRR') != null) { $('#divMALContextMenusRR').html(divMALContextMenusRR); }
    if (requestReferTypeMALGlobal == "Care Plan") {
        $('#btnRequestReceivedCareSignOffMAL').show();
        $('#btnRequestReceivedCareRejectMAL').show();
        $('#btnRequestReceivedAcceptMAL').hide();
    }
    if (requestReferTypeMALGlobal === "Messages" || requestReferTypeMALGlobal === "Faxes") {
        $('#selMessageTypeRRcMAL').show();
        $('#divMessageTypeRRcMAL').show();
        $('#btnRequestReceivedAcceptMAL').hide();
    }
    if (requestReferTypeMALGlobal == "Appointment")
        $('#btnRequestReceivedAcceptMAL').hide();
}
function ModuleMALParam() {
    return {
        RoleId: RoleIdVal,
        IS_PHCP_FLAG: false,
        source: "MAL"
    }
}
function GetViewPermissions_FromReqRec() {
    var IsView = '';
    var referType = '';
    var ctrlID = isMAL ? "selectRequestReceivedReferTypeMAL" : "selectRequestReceivedReferType";
    if (!$.fn.isNullOrEmpty($('#' + ctrlID).data("kendoDropDownList"))) {
        referType = $('#' + ctrlID).data("kendoDropDownList").text();
    }
    if (referType == "Activity") { IsView = $('#HdnIsViewReqRecCMA').val(); }
    else if (referType == "Member") { IsView = $('#HdnIsViewReqRecCMMM').val(); }
    else if (referType == "Appointment") { IsView = $('#HdnIsViewReqRecCMAP').val(); }
    else if (referType == "Care Plan") { IsView = $('#HdnIsViewReqRecCMCP').val(); }
    else if (referType == "Messages") { IsView = $('#HdnIsViewReqRecCMMMS').val(); }
    else if (referType === "Faxes") {
        IsView = $('#HdnIsViewReqRecFax').val();
    }

    else if (referType == "UM Activity") { IsView = $('#HdnIsViewReqRecUMAC').val(); }
    else if (referType == "UM Auth") { IsView = $('#HdnIsViewReqRecUMAT').val(); }
    else if (referType == "AG Complaint") { IsView = $('#HdnIsViewReqRecAGAC').val(); }
    else if (referType == "AG Activity") { IsView = $('#HdnIsViewReqRecAGAA').val(); }
    else { IsView = 'True'; }
    return IsView;
}

function GetViewPermissions_FromReqRej() {
    var IsView = '';
    var referType = isMAL ? $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() : $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
    if (referType == "Activity") { IsView = $('#HdnIsViewReqRejCMAC').val(); }
    else if (referType == "Member") { IsView = $('#HdnIsViewReqRejCMMM').val(); }
    else if (referType == "Appointment") { IsView = $('#HdnIsViewReqRejCMAS').val(); }

    else if (referType == "UM Activity") { IsView = $('#HdnIsViewReqRejUMAS').val(); }
    else if (referType == "UM Auth") { IsView = $('#HdnIsViewReqRejUMAT').val(); }
    else if (referType == "AG Complaint") { IsView = $('#HdnIsViewReqRejAGAC').val(); }
    else if (referType == "AG Activity") { IsView = $('#HdnIsViewReqRejAGAS').val(); }
    else { IsView = 'True'; }
    return IsView;
}
function clickedServicePlan(chkCtrl, parEle, isUM) {
    var chkboxes = "";
    if (isUM == 1) {
        if (chkCtrl != 0)
            parEle = $(chkCtrl).closest('#ddlDayschk').closest('.DiagProcCode');
    }
    else {
        if (chkCtrl != 0)
            parEle = $(chkCtrl).closest('#ddlDayschk').closest('.divCrPlSrPlAddNewCls');
    }
    chkboxes = $(parEle).find('#ddlDayschk').find('input[type="checkbox"]:checked');

    if (chkboxes.length > 0) {
        if ($(chkCtrl).length > 0) {
            $(parEle).find('#ddlDayschk').find('input[type="checkbox"]').each(function () {
                if ($(chkCtrl).val() == "Weekly") {
                    if ($(this).val() != "Weekly")
                        $(this).prop("checked", false);
                    $('#txtSrPlWeeks', parEle).prop('disabled', 'disabled');
                    $('#txtSrPlADays', parEle).prop('disabled', 'disabled');
                }
                else {
                    if ($(chkCtrl).val() != "Weekly")
                        if ($(this).val() == "Weekly")
                            $(this).prop("checked", false);
                }

            });
        }
        var count = 0;
        var outPutString = "";
        var dayNamesString = "";

        $(parEle).find('#ddlDayschk').find('input[type="checkbox"]').each(function () {
            if ($(this).val() == "Sunday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "sun" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }

            if ($(this).val() == "Monday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "mon" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }
            if ($(this).val() == "Tuesday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "tue" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }
            if ($(this).val() == "Wednesday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "wed" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }
            if ($(this).val() == "Thursday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "thu" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }
            if ($(this).val() == "Friday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "fri" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }
            if ($(this).val() == "Saturday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString = dayNamesString + "sat" + ",";
                }
                else
                    outPutString = outPutString + '0';
            }

            if ($(this).val() == "Weekly") {
                if ($(this).is(':checked')) {
                    if (isUM == 1) {
                        if ($(chkCtrl).length > 0)
                            $("#TextHrs,#TextReq,#TxtWeeklyHours,#TextAdlDays,#TextWeeks", parEle).val("");
                        var $fromdate = new Date($("#TextFromDate", parEle).val());
                        var $todate = new Date($("#TextToDate", parEle).val());
                        if ($fromdate != 'Invalid Date' && $todate != 'Invalid Date') {
                            var weeks = GetTotalWeeks($fromdate, $todate);
                            if (weeks > 0)
                                $("#TextWeeks", parEle).val(weeks);
                        }
                        $("#TextAdlDays", parEle).val('0');
                        $("#TextAdlDays", parEle).prop('disabled', 'disabled');
                        $("#TextWeeks", parEle).prop('disabled', 'disabled');
                    }
                    else {
                        var $fromdate = new Date($($(".txtCrPlAddSrPlNewSPFromDateCls", parEle)[1]).val());
                        var $todate = new Date($($(".txtCrPlAddSrPlTNewSPToDateCls", parEle)[1]).val());
                        if ($fromdate != 'Invalid Date' && $todate != 'Invalid Date') {
                            var weeks = GetTotalWeeks($fromdate, $todate);
                            $("#txtSrPlWeeks", parEle).val(weeks);
                        }
                        $("#txtSrPlADays", parEle).val('0');
                        $("#txtSrPlADays", parEle).prop('disabled', 'disabled');
                        $("#txtSrPlWeeks", parEle).prop('disabled', 'disabled');
                    }
                    outPutString = outPutString + '1';
                    $(parEle).find('#ddlDayschk').find('input[type="checkbox"]').each(function () {
                        if ($(this).val() != "Weekly") {
                            $(this).attr('disabled', 'disabled');
                            $(parEle).find('#ddlDayschk').find('div').each(function () {
                                if ($(this).text() != "Weekly") {
                                    $(this).removeAttr('onclick');
                                }
                            });
                        }
                    });
                    //$(parEle).find('#txtSrPlADays').attr('disabled', true);
                }
                else {
                    if (isUM == 1) {
                        $("#TextAdlDays", parEle).removeAttr('disabled');
                        $("#TextWeeks", parEle).removeAttr('disabled');
                    }
                    else {
                        $("#txtSrPlADays", parEle).removeAttr('disabled');
                        $("#txtSrPlWeeks", parEle).removeAttr('disabled');
                    }
                    outPutString = outPutString + '0';
                    // $(parEle).find('#txtSrPlADays').attr('disabled', false);
                }
            }

            if ($(this).is(':checked')) {
                if ($(this).val() == "Weekly") {
                    count = 'W';
                    $(this).removeAttr('disabled');
                    dayNamesString = "Week";
                }
                else {
                    count = count + 1;

                    $(parEle).find('#ddlDayschk').find('input[type="checkbox"]').each(function () {
                        if ($(this).val() == "Weekly") {
                            $(this).attr('disabled', 'disabled');
                            $(parEle).find('#ddlDayschk').find('div').each(function () {
                                if ($(this).text() == "Weekly") {
                                    $(this).removeAttr('onclick');
                                }
                            });
                        }
                    });
                }
            }
        });
        $(parEle).find("#ddlDayshdn").val(outPutString);
        $(parEle).find("#ddlDaysval").val(count);
        $(parEle).find("#ddlDayNameshdn").val(dayNamesString);
    }
    else {
        $(parEle).find("#ddlDayshdn").val("00000000");
        $(parEle).find("#ddlDayNameshdn").val("");
        $(parEle).find("#ddlDaysval").val('');

        $(parEle).find('#ddlDayschk').find('input[type="checkbox"]').each(function () {
            $(this).removeAttr('disabled');
        });
        $(parEle).find('#ddlDayschk').find('div').each(function () {
            if (isUM == 1)
                $(this).attr('onclick', 'spnclickedServicePlan(this,1)');
            else
                $(this).attr('onclick', 'spnclickedServicePlan(this,0)');
        });
    }

    if (isUM == 0 || isUM == undefined) {
        if (chkCtrl != 0) {
            var obj = $(chkCtrl).closest('#ddlDayschk').closest('.divCrPlSrPlAddNewCls');
            srplCalculations(obj);
        }
    }

    if (isUM == 1) {
        if (chkCtrl != 0) {
            var obj = $(chkCtrl).closest('#ddlDayschk').closest('.DiagProcCode');
            var $fromdate = new Date($("#TextFromDate", parEle).val());
            var $todate = new Date($("#TextToDate", parEle).val());
            $("#TextWeeks", obj).trigger("blur");
            if ($('#IsFromIAR').val() === "true") {
                $("#TextWeeks", parEle).attr('disabled', true);
                $("#TextAdlDays", parEle).attr('disabled', true);
            }
        }
    }
    $('#DIV_24_UF_CODES_SERVICE_DAYS .ai-suggested', parEle).removeClass('ai-suggested');
}

function showdropServicePlan(ctrl, isUM) {
    var parEle = ""; var isExpand = true;
    if (isUM == "1") {
        parEle = $(ctrl).closest('.DiagProcCode');
    }
    else {
        parEle = $(ctrl).closest('.divCrPlSrPlAddNewCls');
        if ($(parEle).find('.clsddlCrPlAddSrPlMembNewUnitType').val() == 1) { isExpand = false; }
    }
    if (isExpand) {
        var childCtrl = $(parEle).find('#ddlDayschk');
        $(childCtrl).show();
        $(childCtrl).children().show();
        $(childCtrl).offset({ top: ($(ctrl).offset().top + 22), left: $(childCtrl).offset().left });
    }
}
function spnclickedServicePlan(ctrl, isUM) {
    var parEle = "";
    if (isUM == 1)
        parEle = $(ctrl).closest('#ddlDayschk').closest('.DiagProcCode');
    else
        parEle = $(ctrl).closest('#ddlDayschk').closest('.divCrPlSrPlAddNewCls');

    var chkboxes = $(parEle).find("#ddlDayschk").find('input[type="checkbox"]:checked');
    var ele = $(ctrl).prev("input[type='checkbox']");
    if (ele.is(':checked')) {
        ele.prop('checked', false);
    } else {
        ele.prop('checked', true);
    }
    clickedServicePlan(ele, parEle, isUM);
}
function checkDaysChanged(input) {
    var CurRow = $(input).closest(".DiagProcCode");
    var currDays = $("#ddlDayshdn", CurRow).val(); var prevDays = $("#ddlServiceDayshdn", CurRow).val();
    if (currDays != prevDays) {
        var ErrorMess = "<div class='ItemDiv ItemML10 ItemFull' style='text-align:center;'>";
        ErrorMess += "Please click on Save and Next button to update the changes to service plan and PCS schedule form.<br><br><input type='button' id='BtnOk' class='BtnSave' style='width:100px;' value=' OK ' onclick='ModalClose();' />";
        ErrorMess += "</div>";
        // MessageBox("Diagnosis and Service Codes", ErrorMess, false);
    }
    //MessageBox("Diagnosis and Service Codes", "Please click on Save and Next button to update the changes to service plan and PCS schedule form.", true); return true;
    //alert("Please click on Save and Next button to update the changes to service plan and PCS schedule form");
}
function CareStaffPendingRefsParams() {
    return { careStaffId: $('#hdnSelectedStaffId').val() }
}
function GrdScriptsParameters() {
    return { oggiLobId: $('#hdnOggiLobId').val() }
}
function RefreshMyActLogGrid(btnName, panalID, module, ddlID) {
    var ddlSelectedVal = '';
    if (ddlID != '' && $('#' + ddlID).length > 0) {
        var ddlSelectedVal = $('#' + ddlID).data("kendoDropDownList").text();
    }
    if ($("#" + panalID).hasClass("classExpHeader") && (ddlSelectedVal == module))
        $('#' + btnName).trigger('click');
}

//Refresh logic of MyActivityLog  ==== END
function SetRoleAccessOnMALNavigation() {
    var res = getSpecRoleItem('AHS_CM_MYACTIVITY_LOG');
    $('#btnReqExpndClick').show();
    if (res != undefined && res != null && res.length > 0 && res[0].IsView == false) {
        $('#btnReqExpndClick').hide();
        return false;
    }
    return true;
}

function ToJavaScriptDate(value) {
    var pattern = /Date\(([^)]+)\)/;
    var results = pattern.exec(value);
    return parseInt(results[1]);
}

/************************NAVIGATION LOGIC TO MY CONNECTIONS****************************************************************/

function SignatureLogParameters() {
    return {
        patientId: $('#selectPatientAccessed').val(),
        TimeDictionaryobj: timeZone
    }
}

/****************************************************************************************/
function replaceLessThan(isReplace) {
    if (isReplace == '1') {
        $('#txtResnForMedctn').val($('#txtResnForMedctn').val().replace(/</g, '‹'));
        if ($('#txtDtaComments').length > 0) {
            $('#txtDtaComments').val($('#txtDtaComments').val().replace(/</g, '‹'));
        }
    }
    else {
        $('#txtResnForMedctn').val($('#txtResnForMedctn').val().replace(/‹/g, '<'));
        if ($('#txtDtaComments').length > 0) {
            $('#txtDtaComments').val($('#txtDtaComments').val().replace(/‹/g, '<'));
        }
    }
}

function CheckMemberHasTargetCarePlans(patIds) {
    var hasTargetInts = false;
    $.ajax({
        type: "GET",
        url: baseURL + '/PopulationHealth/CheckMemberTargetInterventions?patientIds=' + patIds,
        dataType: "json",
        async: false,
        success: function (data) {
            hasTargetInts = data.success;
        },
        error: function (err) {
            CustomAlert("Error Encountered");
        }
    });

    return hasTargetInts;
}

//UHC-4065 === SCRIPT FORM MVC CONVERSION === START
function funloadScriptForms(objCareActivityId, objAdditionalInfo, isFromPH) {
    loader(1);
    $('#MvcMainBody').html('');
    SetControlDisplay(4);
    $("#MvcMainBody").load(baseURL + "/ScriptForm/ScriptForm?careActivityTypeID=" + objCareActivityId + "&additionalinfo=" + objAdditionalInfo + "&isFromPH=" + isFromPH, function (response, status, xhr) {
        if (status == 'success') {
            loader(0);
        }
        else if (status == 'error') {
            loader(0);
            AlertShow('Error occurred.', 1);
        }
    });
}
//UHC-4065 === SCRIPT FORM MVC CONVERSION === END

//smart comm logic starts here
function showdropSmartSc(ctrl) {
    var eleid = ctrl.id;
    var eleclass = $(ctrl).parent()[0].className;
    var setOffsetTop = /insideSelect/i.test(eleclass);
    eleid = eleid.replace("val", "");
    if ($(eleid).val() == "") {
        $("#" + eleid + "chk").show();
        $("#" + eleid + "chk").children().show();
        if ($(ctrl).val() == "Select")
            $(ctrl).val('');
    }
    else {
        textChangedSmart(ctrl);
    }
    if (setOffsetTop) {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 37), left: $('#' + eleid + "chk").offset().left });
    }
    else {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 22), left: $('#' + eleid + "chk").offset().left });
    }
}

function validateScTemplateFields() {
    var RetVal = true;
    if (!getSelHierarchyLevelValues().RecordSelected) { CmnStatusMessageDisp('validationSaveMessage', 'Please select the eligibility level', 'Error'); RetVal = false; }
    var client = $("#ddlScClientIdhdn").val(), lob = $("#ddlScLOBIdhdn").val(), language = $("#ddlScLanguageIdhdn").val();
    if (client == "" || client.length == 0) { $('.Client').show(); RetVal = false; } else { $('.Client').hide(); }
    if ($("#ddlScModule").val() == -1) { $('.Module').show(); RetVal = false; } else { $('.Module').hide(); }
    if ($("#ddlScCategory").val() == -1) { $('.Category').show(); RetVal = false; } else { $('.Category').hide(); }
    if ($("#ddlScLanguage").val() == -1) { $('.Language').show(); RetVal = false; } else { $('.Language').hide(); }
    if (language == "" || client.length == 0) { $('.Language').show(); RetVal = false; } else { $('.Language').hide(); }
    return RetVal;
}

function validateDates() {
    var startDt = $('#txtStDt');
    var endDt = $('#txtEdDt');
    var date1 = new Date(startDt.val());
    var date2 = new Date(endDt.val());
    if (date1 != "" && date2 != "") {
        if (date1 > date2) {
            CmnStatusMessageDisp('validationScMessage', 'End date should be greater than Start date', 'Error');
            $('#txtEdDt').val('');
            return false;
        }
        else { return true; }
    }
}
//Xdr C-CDA Grid Filling
function CCDAGridParams() {
    return {
        memberId: memberidval,
        PatientId: $('#selectPatientAccessed').val(),
        MailType: $('#ddlCCDAMailType option:selected').val(),
        dateFrom: $("#txtXdrCCDAFromDate").val(),
        dateTo: $("#txtXdrCCDAToDate").val(),
        TimeDictionaryobj: timeZone
    }
}
function CCDAGridParamsDetails() {
    $('.divXdrCcdaMenu').hide();
    return {
        memberId: memberidval,
        PatientId: $('#selectPatientAccessed').val(),
        MailType: $('#ddlCCDAMailTypeDetails option:selected').val(),
        dateFrom: $("#txtXdrCCDAFromDateDetails").val(),
        dateTo: $("#txtXdrCCDAToDateDetails").val(),
        TimeDictionaryobj: timeZone
    }
}
//Xdr C-CDA Grid I Icon grid Filling

function GCPPChkBoxWithTxtclicked(ctrl, iscount, controlType) {
    var eleid = ctrl.id.replace('spn', '');
    $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
    var ischecked = false;
    if ($(ctrl).attr("type") != "checkbox") {
        ctrl = $(ctrl).prev();
        ischecked = !$(ctrl).is(':checked');
    }
    else {
        ischecked = $(ctrl).is(':checked');
    }

    if ($(ctrl).hasClass('selectallid')) {
        $(ctrl).prop("checked", ischecked);
        if ($(ctrl).hasClass('clsGCHeader')) {
            $("." + eleid + ":enabled:visible").not('.clsPPChild').prop('checked', ischecked);
            $("#" + eleid + "chk").find('input[type=' + controlType + ']:visible').not('.selectallid').not('.clsPPChild').each(function () {
                var tctrl = $(this);
                if ($(tctrl).is(":checked") == true) {

                    if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsPPChild').each(function () {
                            $(this).prop("checked", true);
                            if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(tctrl).data('updatdtext'));
                            }
                        });
                    }
                    else {

                        $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                        if ($(tctrl).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                            $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(tctrl).data('updatdtext'));
                        }
                        //$(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                        //$(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val($(tctrl).data('updatdtext'));
                    }
                }
                else {
                    if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsPPChild').each(function () {
                            if ($(this).closest('.clsParentCtrl').find('.clsPPChild').is(':checked') == true) {

                                $(this).prop("checked", true);
                                //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                                //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                                if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                    $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                    $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(this).data('updatdtext'));
                                }
                            }
                            else {

                                $(this).prop("checked", false);
                                //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                                //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').attr('disabled', 'disabled');
                                if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                    $(this).closest('.clsParentCtrl').find('.clsGCtxt').val("");
                                }
                            }
                        });

                    } else {
                        if ($(tctrl).closest('.clsParentCtrl').find('.clsPPChild').is(':checked') == true) {
                            $(tctrl).prop("checked", true);
                            //$("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').prop("checked", true);
                            //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                            //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                            if ($(tctrl).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(ctrl).data('updatdtext'));
                            }
                        }
                        else {

                            $(tctrl).prop("checked", false);
                            //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                            //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                            $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').attr('disabled', 'disabled');
                            if ($(tctrl).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').val("");
                            }
                        }
                    }
                }
            });

        }
        if ($(ctrl).hasClass('clsPPHeader')) {
            $("." + eleid + ":enabled:visible").not('.clsGCChild').prop('checked', ischecked);
            $('.clsGCHeader ', '.clschkMainHeaderContent').prop('checked', true);
            $("#" + eleid + "chk").find('input[type=' + controlType + ']:visible').not('.selectallid').not('.clsGCChild').each(function () {
                var tctrl = $(this);
                if ($(tctrl).is(":checked") == true) {
                    if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsGCChild').each(function () {
                            if ($(this).prop('disabled') == false) {
                                $(this).prop("checked", true);
                                $(this).closest('.clsParentCtrl').find('.clsGCChild').prop("checked", true);
                                if ($(this).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                    $(this).closest('.clsParentCtrl').find('.clsPPtxt').removeAttr('disabled');
                                    $(this).closest('.clsParentCtrl').find('.clsPPtxt').val($(this).data('updatdtext'));
                                    $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                    $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(this).closest('.clsParentCtrl').find('.clsGCChild').data('updatdtext'));
                                }
                            }
                        });
                    }
                    else {

                        //$(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                        $(tctrl).closest('.clsParentCtrl').find('.clsGCChild').prop("checked", true);
                        if ($(tctrl).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(tctrl).closest('.clsParentCtrl').find('.clsPPtxt').removeAttr('disabled');
                            $(tctrl).closest('.clsParentCtrl').find('.clsPPtxt').val($(tctrl).data('updatdtext'));
                            $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                            $(tctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(tctrl).closest('.clsParentCtrl').find('.clsGCChild').data('updatdtext'));
                        }
                        //$(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                        //$(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val($(tctrl).data('updatdtext'));
                    }
                }
                else {
                    if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsGCChild').each(function () {
                            if ($(this).prop('disabled') == false) {
                                $(this).prop("checked", false);
                                $(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                                $(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                                $(this).closest('.clsParentCtrl').find('.clsPPtxt').attr('disabled', 'disabled');
                                if ($(this).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                    $(this).closest('.clsParentCtrl').find('.clsPPtxt').val("");
                                }
                            }
                        });
                    }
                    else {
                        $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                        $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr("checked");
                        $(tctrl).closest('.clsParentCtrl').find('.clsPPtxt').attr('disabled', 'disabled');
                        if ($(tctrl).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(tctrl).closest('.clsParentCtrl').find('.clsPPtxt').val("");
                        }
                    }
                }
            });

        }
    }
    else {
        if ($(ctrl).hasClass('clsGCChild')) {
            if ($(".selectallid", "#" + eleid + "chk").not('.clsPPHeader').is(":checked") == true && $(ctrl).is(":checked") == false) {
                $(".selectallid", "#" + eleid + "chk").not('.clsPPHeader').prop('checked', false);
            }

            if ($(ctrl).is(":checked") == true) {
                if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsPPChild').each(function () {
                        $(this).prop("checked", true);
                        if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                            $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(this).data('updatdtext'));
                        }
                    });
                }
                else {
                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').is(":checked") == false) {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').prop("checked", true);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').closest('.clsParentCtrl').find('.clsGCtxt').val($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').data('updatdtext'));
                    }

                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                    if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                        $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                        $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(ctrl).data('updatdtext'));
                    }
                }
            }
            else {
                if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsPPChild').each(function () {
                        if ($(this).closest('.clsParentCtrl').find('.clsPPChild').is(':checked') == true) {
                            $(this).prop("checked", true);
                            //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                            //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                            if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(this).data('updatdtext'));
                            }
                        }
                        else {
                            $(this).prop("checked", false);
                            //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                            //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                            $(this).closest('.clsParentCtrl').find('.clsGCtxt').attr('disabled', 'disabled');
                            if ($(this).closest('.clsParentCtrl').find('.clsGCChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').val("");
                            }
                        }

                    });

                } else {
                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'CF' + ']').not('.clsPPChild').is(":checked") == false && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'NF' + ']').not('.clsPPChild').is(":checked") == false) {
                        if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").length == 0)
                            $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').prop("checked", false);

                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').closest('.clsParentCtrl').find('.clsGCtxt').attr('disabled', 'disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').closest('.clsParentCtrl').find('.clsGCtxt').val("");
                    }
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr("checked");

                    if ($(ctrl).closest('.clsParentCtrl').find('.clsPPChild').is(':checked') == true) {
                        $(ctrl).prop("checked", true);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').prop("checked", true);
                        //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                        //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                            $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(ctrl).data('updatdtext'));
                        }
                    } else {
                        $(ctrl).prop("checked", false);
                        //$(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                        //$(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').attr('disabled', 'disabled');
                        if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').val("");
                        }
                    }

                }
            }

        }
        if ($(ctrl).hasClass('clsPPChild')) {
            if ($(".selectallid", "#" + eleid + "chk").not('.clsGCHeader').is(":checked") == true && $(ctrl).is(":checked") == false) {
                $(".selectallid", "#" + eleid + "chk").not('.clsGCHeader').prop('checked', false);
            }

            if ($(ctrl).is(":checked") == true) {
                if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsGCChild').each(function () {
                        if ($(this).prop('disabled') == false) {
                            $(this).prop("checked", true);
                            $(this).closest('.clsParentCtrl').find('.clsGCChild').prop("checked", true);
                            if ($(this).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                                $(this).closest('.clsParentCtrl').find('.clsPPtxt').removeAttr('disabled');
                                $(this).closest('.clsParentCtrl').find('.clsPPtxt').val($(this).data('updatdtext'));
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                                $(this).closest('.clsParentCtrl').find('.clsGCtxt').val($(this).closest('.clsParentCtrl').find('.clsGCChild').data('updatdtext'));
                            }
                        }
                    });
                }
                else {
                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').is(":checked") == false) {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').prop("checked", true);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').closest('.clsParentCtrl').find('.clsGCtxt').val($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').data('updatdtext'));
                    }
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                    if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                        $(ctrl).closest('.clsParentCtrl').find('.clsPPtxt').removeAttr('disabled');
                        $(ctrl).closest('.clsParentCtrl').find('.clsPPtxt').val($(ctrl).data('updatdtext'));
                    }

                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsPPChild').prop("checked", true);
                    $(ctrl).closest('.clsParentCtrl').find('.clsGCChild').prop("checked", true);
                    if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                        $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').removeAttr('disabled');
                        $(ctrl).closest('.clsParentCtrl').find('.clsGCtxt').val($(ctrl).closest('.clsParentCtrl').find('.clsGCChild').data('updatdtext'));
                    }
                }
            }
            else {
                if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsGCChild').each(function () {
                        $(this).prop("checked", false);
                        $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $(this).closest('.clsParentCtrl').find('.clsPPtxt').attr('disabled', 'disabled');
                        if ($(this).closest('.clsParentCtrl').find('.clsPPChild').data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                            $(this).closest('.clsParentCtrl').find('.clsPPtxt').val("");
                        }
                    });

                }
                else {

                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'CF' + ']').not('.clsGCChild').is(":checked") == false && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'NF' + ']').not('.clsGCChild').is(":checked") == false) {
                        if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").length == 0)
                            $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').prop("checked", false);

                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').closest('.clsParentCtrl').find('.clsPPtxt').attr('disabled', 'disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').not('.clsGCChild').closest('.clsParentCtrl').find('.clsPPtxt').val("");
                    }
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr("checked");
                    $(ctrl).closest('.clsParentCtrl').find('.clsPPtxt').attr('disabled', 'disabled');
                    if ($(ctrl).data('fieldcode') !== "DIV_22_UF_PROV_FACILITY_SEARCH") {
                        $(ctrl).closest('.clsParentCtrl').find('.clsPPtxt').val("");
                    }
                }
            }

        }
    }

    if (controlType == undefined) controlType = "checkbox";
    //var eleid = ctrl.id.replace('spn', '');
    var ignoreContent = '.clsPPChild';
    if ($(ctrl).hasClass('clsGCHeader') || $(ctrl).hasClass('clsGCChild')) { ignoreContent = '.clsPPChild'; ddlGCPPcolumnselectedshow(eleid, iscount, controlType, ignoreContent); }
    if ($(ctrl).hasClass('clsPPHeader') || $(ctrl).hasClass('clsPPChild')) { ignoreContent = '.clsGCChild'; ddlGCPPcolumnselectedshow(eleid, iscount, controlType, ignoreContent); }

    if (ctrl.id == 'ddlWLMLobId' || ctrl.id == 'ddlWLMLobIdspn') { isLOBChecked = true; }
    if (ctrl.id == 'ddlWLMPlanId' || ctrl.id == 'ddlWLMPlanIdspn') { isPlanChecked = true; }
}

function ChkBoxWithTxtclicked(ctrl, iscount, controlType) {
    var eleid = ctrl.id.replace('spn', '');
    $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
    var ischecked = false;
    if ($(ctrl).attr("type") != "checkbox") {
        ctrl = $(ctrl).prev();
        ischecked = !$(ctrl).is(':checked');
    }
    else {
        ischecked = $(ctrl).is(':checked');
    }

    if ($(ctrl).hasClass('selectallid')) {
        $(ctrl).prop("checked", ischecked);
        $("." + eleid + ":enabled:visible").prop('checked', ischecked);

        $("#" + eleid + "chk").find('input[type=' + controlType + ']:visible').not('.selectallid').each(function () {
            var tctrl = $(this);
            if ($(tctrl).is(":checked") == true) {
                if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').each(function () {
                        $(this).prop("checked", true);
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").val(unescapeHtml($(tctrl).data('updatdtext')));
                    });
                }
                else {
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val(unescapeHtml($(tctrl).data('updatdtext')));
                }
            }
            else {
                if ($(tctrl).data('child') != "" && $(tctrl).data('displaytype') == "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').each(function () {
                        $(this).prop("checked", false);
                        $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                        $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").val("");
                    });

                } else {
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr("checked");
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                    $(tctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val("");
                }
            }
        });
    }
    else {
        if ($(".selectallid", "#" + eleid + "chk").is(":checked") == true && $(ctrl).is(":checked") == false) {
            $(".selectallid", "#" + eleid + "chk").prop('checked', false);
        }

        if ($(ctrl).is(":checked") == true) {
            if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').each(function () {
                    $(this).prop("checked", true);
                    $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                    $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").val(unescapeHtml($(this).data('updatdtext')));
                });
            }
            else {
                if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').is(":checked") == false) {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').prop("checked", true);
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").val($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').data('updatdtext'));
                }
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr('disabled');
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val(unescapeHtml($(ctrl).data('updatdtext')));
            }
        }
        else {
            if ($(ctrl).data('child') != "" && $(ctrl).data('displaytype') == "GF") {
                $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').each(function () {
                    $(this).prop("checked", false);
                    $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(this).next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                    $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                    $(this).next("#" + eleid + "spn").next("#" + eleid + "txt").val("");
                });

            } else {
                if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').length > 0 && $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'CF' + ']').is(":checked") == false) {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").val("");

                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").length == 0)
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').prop("checked", false);
                }
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").attr('disabled', 'disabled');
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "rdo").removeAttr("checked");
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                $(ctrl).next("#" + eleid + "spn").next("#" + eleid + "txt").val("");
            }
        }
    }

    if (controlType == undefined) controlType = "checkbox";
    //var eleid = ctrl.id.replace('spn', '');
    ddlcolumnselectedshow(eleid, iscount, controlType);

    if (ctrl.id == 'ddlWLMLobId' || ctrl.id == 'ddlWLMLobIdspn') { isLOBChecked = true; }
    if (ctrl.id == 'ddlWLMPlanId' || ctrl.id == 'ddlWLMPlanIdspn') { isPlanChecked = true; }
}
function BindTextValue(cntl) {
    if ($.trim($(cntl).val()) == "")
        $(cntl).val($(cntl).data('val'));
}

//Service plan Grid Edit Modifier ---Starts
function CreateServicePlanEditModifierDropCheck(selectid, data, ddlid, tbid, cvalues) {
    var controlType = "checkbox";
    var width = $('#' + selectid).width();
    $('#' + selectid).attr('data-ddlId', ddlid);
    $('#' + selectid).attr('data-CtrlType', controlType);
    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide selectedValColor' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:240px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var cval = "";
    if (cvalues != null && cvalues !== "") {
        cval = cvalues.toString().split(',');
    }
    var resData = '';
    resData = data.d;
    if (data.length > 0) {
        $.each(data, function (key, val) {
            if (jQuery.inArray(val.Value, cval) != '-1' || val.IsChecked) {
                htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"clicked(this,0,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + unescapeHtml(val.Text) + "</div><br/>";
            }
            else {
                htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"clicked(this,0,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + unescapeHtml(val.Text) + "</div><br/>";
            }
        });
    }
    else {
        htm = htm + "No Records";
    }
    htm = htm + "</div>";
    $("#" + selectid).html('');
    $("#" + selectid).append(htm);
    clickedbyprg(ddlid, 0, controlType);
    if (resData == 'undefined' || resData == '')
        $("#" + selectid).append("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");
    jQuery.ajaxSetup({ async: true, cache: false });

    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        if ($(this).attr('type') != 'checkbox') {
            $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
            var ctrlId = $(this).attr('data-ddlId');
            var ctrlType = $(this).attr('data-CtrlType');
            ddlcolumnselectedshow(ctrlId, 0, ctrlType);
            $(".dropcheck").hide();
        }
    });
}
//Service plan Grid Edit Modifier ---Ends

//PROD-14937---Bind QM Fileds --Starts
function BindQualityMeasureFields() {
    if ($('#ViewScriptActivitySummaryForm #trQmDetails').is(':visible')) {
        $('#trQMPrint').show();
        $('#trPrintIdentifiedDate').show();
        $('#lblPrintQualityMeasure').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblQualityMeasure').AhsGetHtml());
        $('#lblPrintQualityMeasureStatus').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblQualityMeasureStatus').AhsGetHtml());
        $('#lblPrintIdentifiedDate').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblIdentifiedDate').AhsGetHtml());
    }
    else {
        $('#trQMPrint').remove();
        $('#trPrintIdentifiedDate').remove();
        $('#lblPrintQualityMeasure').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblQualityMeasure').AhsSetHtml(''));
        $('#lblPrintQualityMeasureStatus').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblQualityMeasureStatus').AhsSetHtml(''));
        $('#lblPrintIdentifiedDate').AhsSetHtml($('#ViewScriptActivitySummaryForm #lblIdentifiedDate').AhsGetHtml());
    }
}
//PROD-14937---Bind QM Fileds --Ends//PROD-14937---Bind QM Fileds --Starts
// PROD-12202 -START
function uncheckCarePlanBarriersCheckBoxItems() {
    var unChkItems = $('#hdnFCPBarrierSelectedIds').val();
    var grdChkChkdItems = $('#grdAllFullCarePlanBarrier').find($(".clschkFCPBarrier:checked"));
    var chkHeadChk = 0;
    if (unChkItems != '' && unChkItems != null && unChkItems != 'undefined') {
        var unChkItemsSplit = unChkItems.split(',');
        $.each(grdChkChkdItems, function (key, item) {
            var grdChkItem = grdChkChkdItems[key];
            $.each(unChkItemsSplit, function (index) {
                if (unChkItemsSplit[index] == grdChkItem.getAttribute('data-cplids')) {
                    grdChkItem.checked = false;
                    chkHeadChk = 1;
                }
            });
        });
        if (chkHeadChk > 0) {
            $('#grdAllFullCarePlanBarrier .clschkFCPBarriersHead').prop('checked', false);
        }
        else {
            $('#grdAllFullCarePlanBarrier .clschkFCPBarriersHead').prop('checked', true);
        }
    }
}
function EnableCPRAcknowledgeButton() {
    if ($('.btnTargetedAcknowledge:visible').length <= 0) {
        $('#btnAcknowledge').css({ 'opacity': 1, 'cursor': 'pointer' });
        $('#btnAcknowledge').addClass('sendAcknowledge');
    }
}

function uncheckCarePlanStrengthsCheckBoxItems() {
    var unChkItems = $('#hdnFCPStrengthSelectedIds').val();
    var grdChkChkdItems = $('#FCrPlStrengthGrid').find($(".clschkFCPStrength:checked"));
    var chkHeadChk = 0;
    if (unChkItems != '' && unChkItems != null && unChkItems != 'undefined') {
        var unChkItemsSplit = unChkItems.split(',');
        $.each(grdChkChkdItems, function (key, item) {
            var grdChkItem = grdChkChkdItems[key];
            $.each(unChkItemsSplit, function (index) {
                if (unChkItemsSplit[index] == grdChkItem.getAttribute('data-cplids')) {
                    grdChkItem.checked = false;
                    chkHeadChk = 1;
                }
            });
        });
        if (chkHeadChk > 0) {
            $('#FCrPlStrengthGrid .clschkFCPStrengthsHead').prop('checked', false);
        }
        else {
            $('#FCrPlStrengthGrid .clschkFCPStrengthsHead').prop('checked', true);
        }
    }
}
function phBulkActivityAccept(dataParams) {
    $.ajax({
        type: "POST",
        url: baseURL + "/PopulationHealth/PHBulkActivityAccept",
        dataType: "json",
        data: dataParams,
        success: function (data) {
            if (data.success) {
                if ($('#hdnActLogReqRecReqType').val() == "ActLogReqRec") {
                    $('#btnCloseRequestReceivedAcceptComments').trigger('click');
                    $('#btnActLogRequestReceivedSearch').trigger('click');
                    $('#btnActLogMemberActSearch').trigger('click');
                } else {
                    $('#ReqRecGrid' + (isMAL ? 'MAL' : '') + ' .k-pager-refresh').trigger('click');
                    RefreshGridOnActionPerformed("TCAL", "CM");
                    $('#btnCloseRequestReceivedAcceptComments').trigger('click');
                    $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                    if (((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) && !isMAL) {
                        if ((data.msg == 'Activity has been accepted successfully!') || (data.msg == 'All activities have been accepted successfully!.')) {
                            CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Success');
                        }
                        else
                            CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Error');
                    }
                    else {
                        CustomAlert(data.msg);
                    }
                    if ($('#ReceivedAppoinmentCount').attr('id'))
                        FillRequestCountFreek();
                }
            } else {
                if (((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) && !isMAL)
                    CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Error');
                else
                    CustomAlert(data.msg);
            }
            $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled');
        }
    });
}
function PopulateProviderSearchValuesForCM(physicianId, physicianData) {
    if ($("#hdnProvSearchFromMedic").length > 0 && $("#hdnProvSearchFromMedic").val() == "1") {
        if (physicianData.length > 0) {
            var splittedData = physicianData.split('�');
            var providerNameCode = '';
            if (splittedData.length > 0)
                providerNameCode = replaceAll("§", "'", splittedData[0]);
            if (providerNameCode == 'null' || providerNameCode == '') {
                providerNameCode = '';
                if (splittedData.length > 1 && splittedData[1] != 'null')
                    providerNameCode += splittedData[1];
                if (splittedData.length > 2 && splittedData[2] != 'null')
                    providerNameCode += ' ' + splittedData[2];
            }
            if (splittedData.length > 3)
                providerNameCode += '(' + splittedData[3] + ')';
            $('#ProviderNameMedications').val(providerNameCode);
            if (splittedData.length > 4)
                $('#PhysicianId').val(splittedData[4]);
        }
    }
    $('#closePopUp', '#popUpDialog3').trigger('click');//close advance provider search pop up
    if ($('#ExCrTmFormId').length > 0) {//for external careteam
        if ($("#popUpDialog2").is(":visible")) {
            $("#popUpDialog2").CMNPopup({
                pvUrl: baseURL + "/PatientCareTeam/ExternalCareTeam?physicianID=" + physicianId + "&recordToEdit=" + true + "&patientId=" + $('#selectPatientAccessed').val(),
                onLoad: function () {
                    $("#divExtCareTeam").animate({ scrollTop: $("#divExtProvDetails").offset().top }, 500);
                    var itemArr = $('#ExCrTmFormId #LobId').val();
                    var varLanguages = $('#ExCrTmFormId #PrimaryLanguage').val();
                    var varSpecialityId = $('#ExCrTmFormId #SpecialityIds').val();
                    CreateDropCheck('ddlExCrTmLanguage', baseURL + '/Master/BindPrimaryLanguage/', 'ddlExCrTmLanguageId', 0, varLanguages, null, null, 'LanguageName', 'LanguageId');
                    CreateDropCheck('selectExtSpecialityType', baseURL + '/Master/BindSpecialityType/', 'selectExtSpecialityTypeId', 0, varSpecialityId, null, null, 'Speciality', 'SpecialityId');
                    if ($('#hdnddlStatusForLoadDataOFExtCt').val() != undefined && $('#hdnddlStatusForLoadDataOFExtCt').val() == 1)
                        DisableFieldsForExternalCareTeam();
                    else {
                        //Provider Role Configuration---Starts
                        var providerRoleItem = getSpecRoleItem("AHS_CMN_MANAGE_PROVIDER");
                        if (providerRoleItem != null && providerRoleItem.length != 0) {
                            if (providerRoleItem[0].IsEdit == false) {
                                DisableFieldsForExternalCareTeam(0);
                            }
                        }
                        var providerAddressRoleItem = getSpecRoleItem("AHS_CMN_MANAGE_PROVIDER_ADDRESS");
                        if (providerAddressRoleItem != null && providerAddressRoleItem.length != 0) {
                            if (providerAddressRoleItem[0].IsAdd == false) {
                                $('#ExCrTmFormId #btnCareTeamAddressAdd').attr("disabled", "disabled").attr('title', 'You do not have permission to add provider Address.');
                            }
                            if (providerAddressRoleItem[0].IsEdit == false) {
                                $('#ExCrTmFormId #btnCareTeamAddressEdit').attr("disabled", "disabled").attr('title', 'You do not have permission to edit provider Address.');
                            }
                            if (providerAddressRoleItem[0].IsDelete == false) {
                                $('#ExCrTmFormId #btnCareTeamAddressDelete').attr("disabled", "disabled").attr('title', 'You do not have permission to delete provider Address.');
                            }
                        }
                        //Provider Role Configuration---Ends
                    }

                    $('#trCarePlanMultipleAddress').show();
                    $('#trNewProviderAddress').hide();
                    $("#CarePlanMultipleAddress").data("kendoGrid").dataSource.read();
                    $('#ExCrTmFormId #PrimaryBehavioral1').attr('checked', false);
                    $('#ExCrTmFormId #IsPcp1').attr('checked', false);
                    $('#ExCrTmFormId #IsHealthHome').attr('checked', false);
                    $('#ddlExtCrTmRole').prop("disabled", true);
                    ExCrTmEmailBtnShHd();
                    setTimeout(function () { $('#CarePlanMultipleAddress div.k-grid-content').css("height", ""); }, 1000);
                },
                popLevel: 2,
                popUpHeader: "Add External Care Team",
                closeButton: '#btnExCrTmCancel'
            });
        }
    }
    else if ($('#AddAppoinmentForm').length > 0) {//for add apointment
        FunFetchCareProviderDetails(physicianId);
    }
    else if ($('#AddEditVisits #btnSearchProviderCode').length > 0) {//Visits section
        if (physicianData.length > 0) {
            var splittedProvData = physicianData.split('�');
            $('#txtProviderCode').val('');
            if (splittedProvData.length > 3 && splittedProvData[3] != 'null') { $('#txtProviderCode').val(splittedProvData[3]); }
        }
    }
    else {//for add provider sections
        if ($("#popUpDialog2").is(":visible")) {
            $("#popUpDialog2").CMNPopup({
                pvUrl: baseURL + "/PatientCareTeam/AddProvider?PhysicianId=" + physicianId + "&CareTeamUnableChk=" + 1 + "&recordToEdit=" + true + "&patientId=" + $('#selectPatientAccessed').val(),
                onLoad: function () {
                    $("#divExtProvDetails").animate({ scrollTop: $("#divProvDetails").offset().top }, 500);
                    var varSpecialityId = $('#SpecialityIds').val();
                    var varPrimaryLanguage = $('#LanguageIds').val();
                    CreateDropCheck('selectSpecialityType', baseURL + '/Master/BindSpecialityType/', 'selectSpecialityTypeId', 0, varSpecialityId, null, null, 'Speciality', 'SpecialityId');
                    CreateDropCheck('selectLanguageType', baseURL + '/Home/BindLanguageType/', 'selectLanguageTypeId', 0, varPrimaryLanguage);
                    if ($('#hdnddlStatusForLoadData').val() != undefined && $('#hdnddlStatusForLoadData').val() == 1)
                        DisableFieldsForProvider();
                    else {
                        //Provider Role Configuration---Starts
                        var providerRoleItem = getSpecRoleItem("AHS_CMN_MANAGE_PROVIDER");
                        if (providerRoleItem != null && providerRoleItem.length != 0) {
                            if (providerRoleItem[0].IsEdit == false) {
                                DisableFieldsForProvider(0);
                            }
                        }
                        var providerAddressRoleItem = getSpecRoleItem("AHS_CMN_MANAGE_PROVIDER_ADDRESS");
                        if (providerAddressRoleItem != null && providerAddressRoleItem.length != 0) {
                            if (providerAddressRoleItem[0].IsAdd == false) {
                                $('#divExtProvDetails #btnProviderAddressAdd').attr("disabled", "disabled").attr('title', 'You do not have permission to add provider Address.');
                            }
                            if (providerAddressRoleItem[0].IsEdit == false) {
                                $('#divExtProvDetails #btnProviderAddressEdit').attr("disabled", "disabled").attr('title', 'You do not have permission to edit provider Address.');
                            }
                            if (providerAddressRoleItem[0].IsDelete == false) {
                                $('#divExtProvDetails #btnProviderAddressDelete').attr("disabled", "disabled").attr('title', 'You do not have permission to delete provider Address.');
                            }
                        }
                        //Provider Role Configuration---Ends                        
                    }
                    $('#trProviderMultipleAddress').show();
                    $('#trAddAddressAddProvider').hide();
                    $("#ProviderMultipleAddress").data("kendoGrid").dataSource.read();
                    $('#PrimaryBehavioral1').prop('disabled', true);
                    $('#IsPcp1').prop('disabled', true);
                    var Chkvalue = $('#CareTeamUnableChk').val();
                    if (Chkvalue == "1") {
                        $('#PrimaryBehavioral1').removeAttr('disabled');
                        $('#IsPcp1').removeAttr('disabled');
                    }
                    var IsPcpVar = $('#IsPcp1').val();
                    if (IsPcpVar == 'True') {
                        $('#tdDates').show();
                    }
                    setTimeout(function () {
                        $('#CarePlanMultipleAddress div.k-grid-content').css("height", "");
                    }, 1000);
                    A11yModal.trapFocusInModal('popUpDialog2');
                },
                popUpHeader: "Add Provider",
                popLevel: 2,
                closeButton: "#closebutton",
                modalWidth: MODAL_WIDTH.LARGE
            });
        }
    }
}
function ValidateDurationHrs(inputText) {
    if ($(inputText).val() > 23) {
        CustomAlert('Please enter correct format duration');
        $(inputText).val('');
    }
}
function ValidateDurationMins(inputText) {
    if ($(inputText).val() > 59) {
        CustomAlert('Please enter correct format duration');
        $(inputText).val('');
    }
}
function fnValidateCustomFields(id) {
    let isValid = true;
    let ele = $("#" + id + " .requriedCustfield");
    $.each(ele, function () {
        let type = $(this).data("type");
        let self = this;

        switch (type) {
            case 'textbox':
            case 'textarea':
            case 'phone':
                isValid &= A11yForms.validateFormField($(this).attr("id"), null, [A11yForms.VALIDATIONS.REQUIRED]);
                break;
            case 'calendar':
                if ($(self).val().trim() === "") {
                    // For some reason (probaly b/c it is a Kendo component), we had to wrap this in a setTimeout to get it to work.
                    setTimeout(function () {
                        A11yForms.showFormFieldError($(self).attr("id"), A11yForms.ERROR_MESSAGES.REQUIRED);
                    });
                    isValid = false;
                }
                break;
            case 'radiolist':
                let radioCheckedCount = $(self).find("input[type='radio']:checked").length;
                if (radioCheckedCount !== 1) {
                    A11yForms.showFormFieldError($(self).attr("id"), A11yForms.ERROR_MESSAGES.REQUIRED);
                    isValid = false;
                }
                break;
            case 'checkboxlist':
                let checkboxCheckedCount = $(self).find("input[type='checkbox']:checked").length;
                if (checkboxCheckedCount < 1) {
                    A11yForms.showFormFieldError($(self).attr("id"), A11yForms.ERROR_MESSAGES.REQUIRED);
                    isValid = false;
                }
                break;
            case 'duration':
                isValid &= validateCustomDuration(true, self);
                break;
            default:
                DevUtils.logDebug('fnValidateCustomFields - invalid type', 'GCHomeCommonRefs', { type: type, id: $(this).attr("id"), this: this });
                break;
        }

    });

    isValid &= validatePhoneField();

    let elecldr = $("#" + id + " input.cstcalendar");
    $.each(elecldr, function () {
        isValid &= A11yForms.validateFormField($(this).attr("id"), null, [A11yForms.VALIDATIONS.DATE]);
    });

    let eleDuration = $("#" + id + " div.customDuration");
    $.each(eleDuration, function () {
        isValid &= validateCustomDuration(false, this);
    });
    return isValid;
}

function validateCustomDuration(isMandatory, element) {
    let durHrsId = 'durHrs_' + $(element).attr("id");
    let durMinsId = 'durMins_' + $(element).attr("id");
    let parentDiv = 'inner_' + $(element).attr("id");
    let durationLabelId = $(element).attr("id") + 'label';
    return validateDuration(isMandatory, durHrsId, durMinsId, parentDiv, durationLabelId);
}

function CreateCustomFields(ctrlType, ctrlId, ctrlText, selectedValue, optionIds, optionText, isMandatory, PatientFollowupCfId) { // NOSONAR: Has to many parameters (7). Max allowed it 8
    isMandatory = (isMandatory !== undefined && isMandatory != null) ? isMandatory : false;
    selectedValue = (selectedValue !== undefined && selectedValue != null) ? selectedValue : '';
    let hrsVal = "";
    let minsVal = "";
    let html = '<div id="divCustField_' + ctrlId + '" class="float-left width33P ItemPT20">';

    DevUtils.logDebug('CreateCustomFields', 'GCHomeCommonRefs', { ctrlType: ctrlType, ctrlId: ctrlId, ctrlText: ctrlText });

    switch (ctrlType) {
        case 'Textbox':
            html += createCustomFieldsLabel(ctrlId, 'txt_', isMandatory, ctrlText);
            html += '<input class="cstfield ah-input ' + (isMandatory ? "requriedCustfield" : "") + '" data-type="textbox" data-patientfollowupcfid="' + PatientFollowupCfId + '" data-id="' + ctrlId.trim() + '" id="txt_' + ctrlId.trim() + '" name="' + ctrlText.trim() + '" type="text" maxlength="50" value="' + selectedValue.trim() + '">';
            break;
        case 'Text Area':
            html += createCustomFieldsLabel(ctrlId, 'txtarea_', isMandatory, ctrlText);
            html += '<textarea class="txtboxfield cstfield ah-input ' + (isMandatory ? "requriedCustfield" : "") + '" data-type="textarea" data-patientfollowupcfid="' + PatientFollowupCfId + '" maxlength="256"  data-id="' + ctrlId.trim() + '" cols="20" id="txtarea_' + ctrlId.trim() + '" name="' + ctrlText.trim() + '" rows="2">' + selectedValue.trim() + '</textarea>';
            break;
        case 'Phone':
            html += createCustomFieldsLabel(ctrlId, 'txtPhone_', isMandatory, ctrlText, 'ah-telephone-label');
            html += '<input class="keydown mask cstfield ah-input phone ' + (isMandatory ? "requriedCustfield" : "") + '" data-patientfollowupcfid="' + PatientFollowupCfId + '" data-type="phone" data-id="' + ctrlId.trim() + '" id="txtPhone_' + ctrlId.trim() + '" maxlength="12" name="' + ctrlText.trim() + '" type="text" value="' + selectedValue.trim() + '">';
            html += '<label id="txtLabelPhone_' + ctrlId.trim() + '"></label>'
            break;
        case 'Calendar':
            html += createCustomFieldsLabel(ctrlId, 'txtCalendar_', isMandatory, ctrlText, 'ah-date-picker-label');
            html += '<input class="dateInside cstfield cstcalendar ah-input ' + (isMandatory ? "requriedCustfield" : "") + '" data-patientfollowupcfid="' + PatientFollowupCfId + '" data-type="calendar" data-id="' + ctrlId.trim() + '" id="txtCalendar_' + ctrlId.trim() + '" name="' + ctrlText.trim() + '" type="text" value="' + selectedValue.trim() + '" onkeypress="return RistrictKeyBoard(event);">';
            break;
        case 'Radio Button List':
            html += '<fieldset class="ah-fieldset ah-fieldset-invisible">';
            html += '<legend>' + ctrlText + '</legend>';
            html += createCustomFieldsLabel(ctrlId, 'rbl_', isMandatory, ctrlText);
            html += '<div id="rbl_' + ctrlId.trim() + '" class="ah-radio-group cstfield ' + (isMandatory ? "requriedCustfield" : "") + '" data-patientfollowupcfid="' + PatientFollowupCfId + '" data-id="' + ctrlId.trim() + '" data-type="radiolist">';

            let RidArr = optionIds ? optionIds.split("ØæŒ") : '';
            let RtextArr = optionText ? optionText.split("ØæŒ") : '';
            if (Array.isArray(RidArr) && RidArr.length) {
                $.each(RidArr, function (k, v) {
                    let radioName = 'radio_' + ctrlId;
                    let radioId = radioName + '_' + k;
                    if (k > 0) {
                        html += '<p/>';
                    }
                    html += '<input type="radio" class="chkradiocustfield" id="' + radioId + '" name="' + radioName + '" ' + (selectedValue === RidArr[k].trim() ? "checked=checked" : "") + ' value="' + RidArr[k].trim() + '">';
                    html += '<label for="' + radioId + '"><span style="font-weight: normal;">' + $.fn.replaceAndEscapeHtmlExt(RtextArr[k].trim()) + '</span></label>';
                });
            }
            html += '</div></fieldset>';
            break;
        case 'Checkbox List':
            html += '<fieldset class="ah-fieldset ah-fieldset-invisible">';
            html += '<legend>' + ctrlText + '</legend>';
            html += createCustomFieldsLabel(ctrlId.trim(), 'cbl_', isMandatory, ctrlText);
            html += '<div id="cbl_' + ctrlId.trim() + '" class="cstfield ' + (isMandatory ? "requriedCustfield" : "") + '" data-patientfollowupcfid="' + PatientFollowupCfId + '" data-id="' + ctrlId.trim() + '" data-type="checkboxlist">';
            let CidArr = optionIds ? optionIds.split("ØæŒ") : '';
            let selectedValArry = selectedValue ? selectedValue.split(',') : '';
            let CtextArr = optionText ? optionText.split("ØæŒ") : '';
            $.each(CidArr, function (k, v) {
                let checkboxId = ctrlId.trim() + '_' + k + '_checkbox';
                html += '<div class="ah-checkbox-container" style="margin-bottom: 10px;">';
                html += '<input type="checkbox" id="' + checkboxId + '" class="ah-input chkcheckcustfield" name="checkbox_' + ctrlId + '"' + ($.inArray(CidArr[k].trim(), selectedValArry) > -1 ? "checked=checked" : "") + ' value="' + CidArr[k].trim() + '"' + (isMandatory ? "aria-required=true" : "") + '>';
                html += '<label for="' + checkboxId + '"><span style="font-weight: normal;">' + $.fn.replaceAndEscapeHtmlExt(CtextArr[k].trim()) + '</span><i class="fas fa-check" aria-hidden="true"></i></label>';
                html += '</div>';
            });

            html += '</div></fieldset>';
            break;
        case 'Duration':
            if (selectedValue !== "") {
                let arr = selectedValue.split(" ");
                hrsVal = arr[0];
                minsVal = arr[1];
            }
            let divCustFieldId = 'divCustField_' + ctrlId;
            let durHrsId = 'durHrs_' + divCustFieldId;
            let durMinsId = 'durMins_' + divCustFieldId;

            html = '<div id="' + divCustFieldId + '" class="float-left width33P ItemPT20 cstfield customDuration ' + (isMandatory ? "requriedCustfield" : "")
                + '" data-id="' + ctrlId.trim() + '" id="txt_' + ctrlId.trim() + '" data-type="duration" data-patientfollowupcfid="' + PatientFollowupCfId + '">';
            html += '<fieldset class="ah-fieldset ah-fieldset-invisible">';
            html += '<legend>' + ctrlText + '</legend>';
            html += createCustomFieldsLabel(ctrlId, 'txt_', isMandatory, ctrlText);
            html += '<div id="inner_' + divCustFieldId + '">';
            html += '<input class="ah-input" data-type="textbox" id="' + durHrsId + '" data-patientfollowupcfid="' + PatientFollowupCfId + '" name="' + ctrlText.trim() + '" style="width:45px !important; text-align:center;" onkeyup="return CheckNumeric(this);" type="text" maxlength="2" value="' + hrsVal + '">' + '&nbsp; <label for="' + durHrsId + '">Hrs</label> &nbsp;&nbsp;';
            html += '<input class="ah-input" data-type="textbox" id="' + durMinsId + '"  data-patientfollowupcfid="' + PatientFollowupCfId + '" name="' + ctrlText.trim() + '" style="width:45px !important; text-align:center;" onkeyup="return CheckNumeric(this);" type="text" maxlength="2" value="' + minsVal + '">' + '&nbsp; <label for="' + durMinsId + '">Mins</label>';
            html += '</div>';
            html += '</fieldset>';
            break;
    }
    html += '</div></div>';
    return html;
}


function createCustomFieldsLabel(ctrlId, fieldIdPrefix, isMandatory, labelText, labelHelperText) {
    if (labelHelperText === undefined) {
        labelHelperText = '';
    }
    return ' <div> <label id="divCustField_' + ctrlId + 'label" class="ah-label' + (isMandatory ? " ah-required " : " ") + labelHelperText + '" for="' + fieldIdPrefix + ctrlId.trim() + '"> ' + labelText + '</label>';
}

function fnCreateCustomFieldstoXML(id, actModeId, actSectionId) {
    var xmldata = '<customfields actmodeid="' + actModeId + '" actsectionid="' + actSectionId + '">';
    if (id == 'ActivityOutcomeCustomFieldUnique') {
        $.each(($("iFrame:not(#iframeSmartCOMMSSo)").contents().find("#" + id + " .cstfield")), function () {
            var datatype = $(this).data("type");
            var PatientFollowupCfId = $(this).data("patientfollowupcfid");
            PatientFollowupCfId = PatientFollowupCfId != undefined ? PatientFollowupCfId : '0';
            switch (datatype) {
                case 'textbox':
                case 'textarea':
                case 'phone':
                case 'calendar':
                    var tval = $(this).val().trim();
                    //var tid = $(this).data("id").toString().split("ØæŒ");
                    $.each(($(this).data("id").toString().split("ØæŒ")), function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + escapeHtml(tval) + '"></customfield>';
                    });
                    break;
                case 'radiolist':
                    var rval = $(this).find(".chkradiocustfield:checked").val();
                    rval = (typeof (rval) !== 'undefined') ? rval : "";
                    //var rid = $(this).data("id").toString().split("ØæŒ");
                    $.each(($(this).data("id").toString().split("ØæŒ")), function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + rval + '"></customfield>';
                    });

                    break;
                case 'checkboxlist':
                    var cval = "";
                    cval = $.map($(this).find(".chkcheckcustfield:checked"), function (n, i) { return n.value; }).join(',');
                    //var cid = $(this).data("id").toString().split("ØæŒ");
                    $.each(($(this).data("id").toString().split("ØæŒ")), function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + cval + '"></customfield>';
                    });
                    break;
                case 'duration':
                    let durHrsId = '#durHrs_' + $(this).attr("id");
                    let durMinsId = '#durMins_' + $(this).attr("id");
                    let dval = $(durHrsId).val() + ' ' + $(durMinsId).val();

                    let did = $(this).data("id").toString().split("ØæŒ");
                    $.each(did, function (k, v) {
                        let CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + dval + '"></customfield>';
                    });
                    break;
            }
        });
    }
    else {
        $.each($("#" + id + " .cstfield"), function () {
            var datatype = $(this).data("type");
            var PatientFollowupCfId = $(this).data("patientfollowupcfid");
            PatientFollowupCfId = PatientFollowupCfId != undefined ? PatientFollowupCfId : '0';
            switch (datatype) {
                case 'textbox':
                case 'textarea':
                case 'phone':
                case 'calendar':
                    var tval = $(this).val().trim();
                    var tid = $(this).data("id").toString().split("ØæŒ");
                    $.each(tid, function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + escapeHtml(tval) + '"></customfield>';
                    });
                    break;
                case 'radiolist':
                    var rval = $(this).find(".chkradiocustfield:checked").val();
                    rval = (typeof (rval) !== 'undefined') ? rval : "";
                    var rid = $(this).data("id").toString().split("ØæŒ");
                    $.each(rid, function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + rval + '"></customfield>';
                    });

                    break;
                case 'checkboxlist':
                    var cval = "";
                    cval = $.map($(this).find(".chkcheckcustfield:checked"), function (n, i) { return n.value; }).join(',');
                    var cid = $(this).data("id").toString().split("ØæŒ");
                    $.each(cid, function (k, v) {
                        var CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + cval + '"></customfield>';
                    });
                    break;
                case 'duration':
                    let durHrsId = '#durHrs_' + $(this).attr("id");
                    let durMinsId = '#durMins_' + $(this).attr("id");
                    let dval = $(durHrsId).val() + ' ' + $(durMinsId).val();

                    let did = $(this).data("id").toString().split("ØæŒ");
                    $.each(did, function (k, v) {
                        let CusFieldActId = v.toString().split("-");
                        xmldata += '<customfield patientfollowupcfid="' + PatientFollowupCfId + '" custfieldid="' + CusFieldActId[0] + '" careactivitytypeid="' + CusFieldActId[1] + '" value="' + dval + '"></customfield>';
                    });
                    break;
            }
        });
    }
    xmldata += "</customfields>".toString();
    DevUtils.logDebug('fnCreateCustomFieldstoXML', 'GCHomeCommonRefs', { id: id, actModeId: actModeId, actSectionId: actSectionId, xmldata: xmldata });
    return xmldata;
};
function closeAssessmentPopUpWindow() {
    var popUpWindow = $('#closePopUp').closest('div[id*="popUpDialog1"]');
    if ($(popUpWindow).is(':visible')) {
        $('#closePopUp').trigger('click');
    }
    else {
        $('#popUpDialog2 #closePopUp').trigger('click');
    }
}

function getPacketLogGrid(PatientId, ComplaintTypeId, ComplaintRecId, ComplaintId) {
    $('#HdnPacketLogTabId').val(2); //To Redirect to PacketLog LeftTab
    var ComplaintDivId = "#ComplaintDiv_" + PatientId + "_" + ComplaintTypeId + "_" + ComplaintRecId;
    HANDLER_URL = "api/Route/GetAGResult";
    if ($("#MvcMainBody .InComplaintPage").length <= 0) {
        SetComplaintData(PatientId, ComplaintRecId);
        setTimeout(function () {
            AgTab.leftTabSet(2, '1', false, null, ComplaintRecId, ComplaintId, PatientId);
        }, 1000);
    }
    else if ($(ComplaintDivId).length > 0) {
        AgTab.leftTabSet(2, '1', false, null, ComplaintRecId, ComplaintId, PatientId);
    }
    else {
        AgTab.agTabShow(ComplaintRecId, null, null, null, null, PatientId);
        AgTab.leftTabSet(2, '1', false, null, ComplaintRecId, ComplaintId, PatientId);
    }
}
function PacketAlert(isPacketLogPage) {
    if (!isPacketLogPage && GlobalPacketIds.length > 0) {
        var ProgressStatusUrl = baseApiURL + '/AgPacket/GetProgressStatus?AgpacketId=' + GlobalPacketIds.join(",");
        $.ajax({
            type: "POST",
            url: ProgressStatusUrl,
            dataType: "json",
            success: function (data) {
                if (ToValue(data, "") !== "") {
                    $.each(data, function (index, itemData) {
                        if (itemData.PacketStatusId === 4) {
                            var PacketLogGridFunc = 'getPacketLogGrid(' + itemData.PatientId + ',' + itemData.ComplaintTypeId + ',' + itemData.ComplaintRecordId + ',' + "'" + itemData.ComplaintId + "'" + ")";
                            $('#divPacketlogAlertMessage').css("display", "flex");
                            $('#spnPacketNavi').AhsSetHtml("Success, Complaints, Appeals and Grievance packet number <a onclick=" + PacketLogGridFunc + " style='text-decoration: none;'> " + itemData.ComplaintId + "</a>" + " is ready.");
                            GlobalPacketIds = $.grep(GlobalPacketIds, function (n) { return n !== itemData.AgPacketId; });
                            setTimeout(function () {
                                $('#divPacketlogAlertMessage').css("display", "none");

                            }, 15000);
                        }
                        else if (itemData.PacketStatusId === 5) {
                            GlobalPacketIds = $.grep(GlobalPacketIds, function (n) { return n !== itemData.AgPacketId; });
                            $('#divPacketlogErroMessage').css("display", "flex");
                            setTimeout(function () {
                                $('#divPacketlogErroMessage').css("display", "none");
                            }, 15000);
                        }
                    });
                }
            },
            error: function () {
                console.log("Error occurred in PacketAlert method.");
            }

        });
    }
}

function UpdateCareMemberGridColumnDropdown(callBack) {
    MyCareMemberDefaultfilter = false;
    var count = 0;
    var lst = $('#ddlDynaColumnIdhdntxt').val().split(',');
    if (lst && lst.length > 7) {
        CustomAlert('You cannot select more than 7 columns');
        callBack(false);
    }
    else {
        $($("#grdMyTeamMembers").data("kendoGrid").columns).each(function () {
            count = count + 1;
            if (count > 7) {
                $("#grdMyTeamMembers").data("kendoGrid").hideColumn(count);
            }
        });

        if ($('#ddlDynaColumnIdhdn').val().length !== 0 && $('#ddlDynaColumnIdhdn').val() !== "" && $('#ddlDynaColumnIdhdn').val() !== "-1") {
            for (var i = 0; i < lst.length; i++) {
                var column = lst[i];
                switch (column) {
                    case "Assigned Date":
                        column = "AssignedOn";
                        break;
                    case "Referred By":
                        column = "ReferredStaffName";
                        break;
                    case "DOB":
                        column = "PatientDob";
                        break;
                    case "Medical Condition":
                        column = "PrimaryMedicalCondition";
                        break;
                    case RootLevel:
                        column = "DataRootName";
                        break;
                    case "Language":
                        column = "PrimaryLanguage";
                        break;
                    case "Behavioral Condition":
                        column = "PrimaryBehaviouralCondition";
                        break;
                    case "Gender":
                        column = "Sex";
                        break;
                    case "Last Performed Activity/Script":
                        column = "ActivityScriptName";
                        break;
                    case "Medical Condition":
                        column = "PrimaryMedicalCondition";
                        break;
                    case "Program Name":
                        column = "ProgramNames";
                        break;
                    case "Referral Date":
                        column = "ReferredDate";
                        break;
                    case "Status":
                        column = "LatestPlanStatus";
                        break;
                    case "Eligibility End Date":
                        column = "EligibilityEndDate";
                        break;
                    case "Assigned Care Manager":
                        column = "AssignedCareManager";
                        break;
                    case "PSU Score":
                        column = "PsuScore";
                        break;
                    case "Member Zip Code":
                        column = "MemberZipCode";
                        break;
                    case "Persistent Super Utilizer Flag":
                        column = "PersistentSuperUtilizerFlag";
                        break;
                    case "Risk of Admission":
                        column = "RiskofAdmission";
                        break;
                    case "ISP Due Date":
                        column = "IspDueDate";
                        break;
                    default:
                        break;
                }
                $("#grdMyTeamMembers").data("kendoGrid").showColumn(column.replace(" ", ""));
            }
        }
        callBack(true);
    }
}

function checkDateIsValid(dateEleId, dateEleType) {
    var ErrorMessage = '';
    $dateEleId = $('#' + dateEleId);
    dateEleValue = $dateEleId.val();

    if ($.trim(dateEleValue) !== "" && (!isNaN(dateEleValue) || !isValidDate(dateEleValue))) {
        ErrorMessage = 'Please enter valid program ' + dateEleType.toLowerCase();
    }
    return ErrorMessage;
}

function chkBoxWithTxtclickedAgConfig(ctrl, iscount) {
    var eleid = ctrl.id.replace('spn', '');
    $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
    var ischecked = false;
    if ($(ctrl).attr("type") !== "checkbox") {
        ctrl = $(ctrl).prev();
        ischecked = !$(ctrl).is(':checked');
    }
    else {
        ischecked = $(ctrl).is(':checked');
    }

    if ($(ctrl).hasClass('selectallid')) {
        $(ctrl).prop("checked", ischecked);
        $("." + eleid + ":enabled:visible").prop('checked', ischecked);

        $("#" + eleid + "chk").find("." + eleid + ":visible").not('.selectallid').each(function () {
            var tctrl = $(this);
            if ($(tctrl).is(":checked")) {
                if ($(tctrl).data('child') !== "" && $(tctrl).data('displaytype') === "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsLevelChk').not('.clsLevelAll').each(function () {
                        $(this).prop("checked", true);
                        $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").removeAttr('disabled');
                        $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").val(unescapeHtml($(tctrl).data('updatdtext')));
                        if ($(this).data('islevelsmandate') !== false && $(this).data('iscontrolmandate') !== true &&
                            $(this).data('islevelsmandate') !== undefined && $(this).data('iscontrolmandate') !== undefined && $(this).data('displaytype') !== "GF") {
                            $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).removeAttr('disabled');
                            $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                        }
                        else {
                            $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                        }
                        //}
                    });
                }
                else {
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").removeAttr('disabled');
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").removeAttr('disabled');
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").val(unescapeHtml($(tctrl).data('updatdtext')));
                    if ($(tctrl).data('islevelsmandate') !== false && $(tctrl).data('iscontrolmandate') !== true &&
                        $(tctrl).data('islevelsmandate') !== undefined && $(tctrl).data('iscontrolmandate') !== undefined && $(tctrl).data('displaytype') !== "GF") {
                        $('input:checkbox', $(tctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).removeAttr('disabled');
                        $('input:checkbox', $(tctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                    }
                    else {
                        $('input:checkbox', $(tctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                    }
                }
            }
            else {
                if ($(tctrl).data('child') !== "" && $(tctrl).data('displaytype') === "GF") {
                    $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(tctrl).data('child') + ']').not('.clsLevelChk').not('.clsLevelAll').each(function () {
                        $(this).prop("checked", false);
                        $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").attr('disabled', 'disabled');
                        $(this).closest(".clsChildDropcheck").find("#" + eleid + "rdo").prop("checked", false);
                        $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").attr('disabled', 'disabled');
                        $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").val("");
                        $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).attr('disabled', 'disabled');
                        $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", false);
                    });

                } else {
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").removeAttr("checked");
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").attr('disabled', 'disabled');
                    $(tctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").val("");
                    $('input:checkbox', $(tctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).attr('disabled', 'disabled');
                    $('input:checkbox', $(tctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", false);
                }
            }
        });
    }
    else {
        if ($(".selectallid", "#" + eleid + "chk").is(":checked") && !$(ctrl).is(":checked")) {
            $(".selectallid", "#" + eleid + "chk").prop('checked', false);
        }

        if ($(ctrl).is(":checked")) {
            if ($(ctrl).data('child') !== "" && $(ctrl).data('displaytype') === "GF") {
                $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsLevelChk').not('.clsLevelAll').each(function () {
                    $(this).prop("checked", true);
                    $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").removeAttr('disabled');
                    $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").val(unescapeHtml($(this).data('updatdtext')));
                    if ($(this).data('islevelsmandate') !== false && $(this).data('iscontrolmandate') !== true &&
                        $(this).data('islevelsmandate') !== undefined && $(this).data('iscontrolmandate') !== undefined && $(this).data('displaytype') !== "GF") {
                        $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).removeAttr('disabled');
                        $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                    }
                    else {
                        $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                    }
                    // }
                });
            }
            else {
                if ($(ctrl).data('child') !== "") {
                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').length > 0 && !$("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').is(":checked")) {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').prop("checked", true);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").removeAttr('disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").val($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').data('updatdtext'));
                    }
                }
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").removeAttr('disabled');
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").removeAttr('disabled');
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").val(unescapeHtml($(ctrl).data('updatdtext')));
                if ($(ctrl).data('islevelsmandate') !== false && $(ctrl).data('iscontrolmandate') !== true &&
                    $(ctrl).data('islevelsmandate') !== undefined && $(ctrl).data('iscontrolmandate') !== undefined && $(ctrl).data('displaytype') !== "GF") {
                    $('input:checkbox', $(ctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).removeAttr('disabled');
                    $('input:checkbox', $(ctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                }
                else {
                    $('input:checkbox', $(ctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", true);
                }
            }
        }
        else {
            if ($(ctrl).data('child') !== "" && $(ctrl).data('displaytype') === "GF") {
                $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + ']').not('.clsLevelChk').not('.clsLevelAll').each(function () {
                    $(this).prop("checked", false);
                    $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").attr('disabled', 'disabled');
                    $(this).closest(".clsChildDropcheck").find("#" + eleid + "rdo").prop("checked", false);
                    $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").attr('disabled', 'disabled');
                    $(this).closest(".clsChildDropcheck").find("#" + eleid + "txt").val("");
                    $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).attr('disabled', 'disabled');
                    $('input:checkbox', $(this).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", false);
                });

            } else {
                $('input:checkbox', $(ctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).prop("checked", false);
                if ($(ctrl).data('child') !== "") {
                    if ($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').length > 0 && !$("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'CF' + ']').is(":checked")) {
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").prop("checked", false);
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").attr('disabled', 'disabled');
                        $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "txt").val("");

                        if (($("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').next("#" + eleid + "spn").next("#" + eleid + "rdo").length).toString() === "0") {
                            $("#" + eleid + "chk").find('input[type=checkbox][data-child=' + $(ctrl).data('child') + '][data-displaytype=' + 'GF' + ']').prop("checked", false);
                        }
                    }
                }
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").attr('disabled', 'disabled');
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "rdo").removeAttr("checked");
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").attr('disabled', 'disabled');
                $(ctrl).closest(".clsChildDropcheck").find("#" + eleid + "txt").val("");
                $('input:checkbox', $(ctrl).closest(".clsChildDropcheck").find('.clsLevelChkContent')).attr('disabled', 'disabled');

            }
        }
    }

    ddlShowColumnSelectedAgConfig(eleid, iscount);

    if (ctrl.id === 'ddlWLMLobId' || ctrl.id === 'ddlWLMLobIdspn') {
        isLOBChecked = true;
    }
    if (ctrl.id === 'ddlWLMPlanId' || ctrl.id === 'ddlWLMPlanIdspn') {
        isPlanChecked = true;
    }
}

function escapeHtmlWithHtmlTags(text) {
    var div = document.createElement("div");
    div.innerHTML = text;
    var str = div.textContent || div.innerText || "";
    if (text === str) {
        text = text.replace(/>/g, "&gt;").replace(/</g, "&lt;");
    }
    text = text.replace(/\[:Ü:]/g, '|');
    return text;
}
function readDatasourcefromGrid(gridId, isfreshload) {
    if (gridPagerMode && !((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1'))) {
        gridPagination.fetchGridData(gridId, isfreshload);
    }
    else {
        $('#' + gridId).data('kendoGrid').dataSource.page(1);
    }
}
function refereshDatasourcefromPager(gridId) {
    if (gridPagerMode && !isMAL && !((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1'))) {
        gridPagination.fetchGridData(gridId, false);
    }
    else {
        $('#' + gridId + ' .k-pager-refresh').trigger('click');
    }
}
function extCareTeamMandatoryFieldsToggle(isMandatory) {
    if (isMandatory) {
        $('#ExCrTmFormId #ProviderName').closest('td').find('.requiredfields').show();
        $('#ExCrTmFormId #txtExtFirstName').closest('td').find('.requiredfields').show();
        $('#ExCrTmFormId #txtExtCrTmLastName').closest('td').find('.requiredfields').show();
    }
    else {
        $('#ExCrTmFormId #ProviderName').closest('td').find('.requiredfields').hide();
        $('#ExCrTmFormId #txtExtFirstName').closest('td').find('.requiredfields').hide();
        $('#ExCrTmFormId #txtExtCrTmLastName').closest('td').find('.requiredfields').hide();
    }
}

function bindAlertHeader() {
    var currentPanel = $.grep(dashboardConfig, function (element, _index) {
        return element.QuadrantId === 4 && element.Rank === bottomLeftCurrentValue;
    });
    if (currentPanel.length > 0 && currentPanel[0].QuadrantValueId != null) {
        loadBasedonDashboardConfig(currentPanel[0].QuadrantValueId);
    }
}
